/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/booking/detail/booking-detail.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../../public/upgrade/feature/booking/booking.service';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '@angular/http/src/http';
import * as import10 from '@angular/router/src/router_state';
import * as import11 from '../../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import12 from '@angular/core/src/zone/ng_zone';
import * as import13 from '../../../../../../public/upgrade/core/session.service';
import * as import14 from '../../../../../../public/upgrade/root/information-modal/information-modal.service';
import * as import15 from '../../../../../../public/upgrade/root/toast/notification.service';
import * as import16 from '@angular/common/src/location/location';
import * as import17 from '@ngx-translate/core/src/translate.service';
import * as import18 from '@ngx-translate/core/src/translate.pipe';
import * as import19 from '@angular/core/src/linker/view_container';
import * as import20 from '@angular/core/src/change_detection/change_detection_util';
import * as import21 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import22 from '@angular/core/src/linker/template_ref';
import * as import23 from '@angular/common/src/directives/ng_if';
import * as import24 from '../../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import25 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import26 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import27 from '@angular/core/src/linker/element_ref';
import * as import28 from '@angular/common/src/directives/ng_class';
import * as import29 from '../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import30 from '@angular/common/src/directives/ng_for';
import * as import31 from '../../../../../../public/upgrade/feature/booking/email-tooltip.component';
import * as import32 from '../../../../../../public/upgrade/root/ga/ga.service';
import * as import33 from '../../../../../../public/upgrade/core/mobile.service';
import * as import34 from '../email-tooltip.component.ngfactory';
import * as import35 from '@angular/core/src/linker/query_list';
import * as import36 from '@angular/common/src/pipes/date_pipe';
import * as import37 from '@angular/core/src/i18n/tokens';
export class Wrapper_BookingDetailComponent {
  /*private*/ _eventHandler:Function;
  context:import0.BookingDetailComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any) {
    this._changed = false;
    this.context = new import0.BookingDetailComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_BookingDetailComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_BookingDetailComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.BookingDetailComponent>;
  _BookingService_0_3:import5.BookingService;
  _BookingDetailComponent_0_4:Wrapper_BookingDetailComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_BookingDetailComponent_Host0,renderType_BookingDetailComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'booking-detail',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_BookingDetailComponent0(this.viewUtils,this,0,this._el_0);
    this._BookingService_0_3 = new import5.BookingService(this.injectorGet(import9.Http,this.parentIndex));
    this._BookingDetailComponent_0_4 = new Wrapper_BookingDetailComponent(this._BookingService_0_3,this.injectorGet(import10.ActivatedRoute,this.parentIndex),this.injectorGet(import11.LoadingWheelService,this.parentIndex),this.injectorGet(import12.NgZone,this.parentIndex),this.injectorGet(import13.SessionService,this.parentIndex),this.injectorGet(import14.InformationModalService,this.parentIndex),this.injectorGet(import15.NotificationService,this.parentIndex),this.injectorGet(import16.Location,this.parentIndex),this.injectorGet(import17.TranslateService,this.parentIndex));
    this.compView_0.create(this._BookingDetailComponent_0_4.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._BookingDetailComponent_0_4.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.BookingService) && (0 === requestNodeIndex))) { return this._BookingService_0_3; }
    if (((token === import0.BookingDetailComponent) && (0 === requestNodeIndex))) { return this._BookingDetailComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._BookingDetailComponent_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const BookingDetailComponentNgFactory:import8.ComponentFactory<import0.BookingDetailComponent> = new import8.ComponentFactory<import0.BookingDetailComponent>('booking-detail',View_BookingDetailComponent_Host0,import0.BookingDetailComponent);
const styles_BookingDetailComponent:any[] = ([] as any[]);
class View_BookingDetailComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  /*private*/ _expr_19:any;
  /*private*/ _expr_20:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_22:any;
  _pipe_translate_1:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent1,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_19 = import20.UNINITIALIZED;
    this._expr_20 = import20.UNINITIALIZED;
    this._expr_22 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray4(4,'class','col -lg-3 -md-3 -sm-12 actions-detail','id','btn-download-detail'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','-eva-3-mt-lg'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'a',new import3.InlineArray2(2,'class','eva-3-btn -link -sm -icon -eva-3-mr-md'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'em',new import3.InlineArray2(2,'class','btn-text -eva-3-tc-blue-2'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_2,'a',new import3.InlineArray2(2,'class','eva-3-btn-ghost button-download-detail -darken -sm -icon'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                            ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'i',new import3.InlineArray2(2,'class','btn-icon eva-3-icon-download'),(null as any));
    this._text_13 = this.renderer.createText(this._el_10,'\n                            ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_10,'em',new import3.InlineArray2(2,'class','btn-text'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._text_17 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._text_18 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_4));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_10,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_10));
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._text_17,
      this._text_18
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    const currVal_19:any = this.parentView.context.hideNoShow();
    if (import3.checkBinding(throwOnChange,this._expr_19,currVal_19)) {
      this.renderer.setElementProperty(this._el_4,'hidden',currVal_19);
      this._expr_19 = currVal_19;
    }
    valUnwrapper.reset();
    const currVal_20:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.NO_SHOW_BUTTON')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_20,currVal_20))) {
      this.renderer.setText(this._text_7,currVal_20);
      this._expr_20 = currVal_20;
    }
    valUnwrapper.reset();
    const currVal_22:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('common.DOWNLOAD')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_22,currVal_22))) {
      this.renderer.setText(this._text_15,currVal_22);
      this._expr_22 = currVal_22;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.performNoShow()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_10(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.download()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_BookingDetailComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _text_36:any;
  _el_37:any;
  _text_38:any;
  _text_39:any;
  _text_40:any;
  _text_41:any;
  _text_42:any;
  /*private*/ _expr_43:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_45:any;
  _pipe_translate_1:import18.TranslatePipe;
  /*private*/ _expr_47:any;
  /*private*/ _expr_48:any;
  _pipe_translate_2:import18.TranslatePipe;
  /*private*/ _expr_50:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent3,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_43 = import20.UNINITIALIZED;
    this._expr_45 = import20.UNINITIALIZED;
    this._expr_47 = import20.UNINITIALIZED;
    this._expr_48 = import20.UNINITIALIZED;
    this._expr_50 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-3 -md-3 -sm-3'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-lg'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                                ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','detail-icon-info'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                                    ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'i',new import3.InlineArray2(2,'class','eva-3-icon-airplane-going -eva-3-icon-sm -eva-3-tc-blue-1'),(null as any));
    this._text_9 = this.renderer.createText(this._el_6,'\n                                                ',(null as any));
    this._text_10 = this.renderer.createText(this._el_4,'\n                                                ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','detail-name-info'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n                                                    ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_11,'h5',new import3.InlineArray2(2,'class','eva-3-h5 -eva-3-tc-blue-1'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'',(null as any));
    this._text_15 = this.renderer.createText(this._el_11,'\n                                                ',(null as any));
    this._text_16 = this.renderer.createText(this._el_4,'\n                                            ',(null as any));
    this._text_17 = this.renderer.createText(this._el_2,'\n                                        ',(null as any));
    this._text_18 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row detail-left-padding'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'\n                                            ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_19,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n                                                ',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_21,'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'\n                                                    ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_23,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'',(null as any));
    this._text_27 = this.renderer.createText(this._el_23,'\n                                                    ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_23,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'',(null as any));
    this._text_30 = this.renderer.createText(this._el_23,'\n                                                ',(null as any));
    this._text_31 = this.renderer.createText(this._el_21,'\n                                                ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_21,'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'\n                                                    ',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_32,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'',(null as any));
    this._text_36 = this.renderer.createText(this._el_32,'\n                                                    ',(null as any));
    this._el_37 = import3.createRenderElement(this.renderer,this._el_32,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_38 = this.renderer.createText(this._el_37,'',(null as any));
    this._text_39 = this.renderer.createText(this._el_32,'\n                                                ',(null as any));
    this._text_40 = this.renderer.createText(this._el_21,'\n                                            ',(null as any));
    this._text_41 = this.renderer.createText(this._el_19,'\n                                        ',(null as any));
    this._text_42 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_2 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._text_36,
      this._el_37,
      this._text_38,
      this._text_39,
      this._text_40,
      this._text_41,
      this._text_42
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_43:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.FLIGHT_INFO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_43,currVal_43))) {
      this.renderer.setText(this._text_14,currVal_43);
      this._expr_43 = currVal_43;
    }
    valUnwrapper.reset();
    const currVal_45:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingDetail.FLIGHT.AIRLINE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_45,currVal_45))) {
      this.renderer.setText(this._text_26,currVal_45);
      this._expr_45 = currVal_45;
    }
    const currVal_47:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.airline,'');
    if (import3.checkBinding(throwOnChange,this._expr_47,currVal_47)) {
      this.renderer.setText(this._text_29,currVal_47);
      this._expr_47 = currVal_47;
    }
    valUnwrapper.reset();
    const currVal_48:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('bookingDetail.FLIGHT.NUMBER')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_48,currVal_48))) {
      this.renderer.setText(this._text_35,currVal_48);
      this._expr_48 = currVal_48;
    }
    const currVal_50:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.flightNumber,'');
    if (import3.checkBinding(throwOnChange,this._expr_50,currVal_50)) {
      this.renderer.setText(this._text_38,currVal_50);
      this._expr_50 = currVal_50;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent5 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent5,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2:any = import3.inlineInterpolate(1,'\n                                                            ',('/ ' + this.parentView.parentView.parentView.context.bookingDetail.pickupPoint.pickupIndications.phoneOptional),'\n                                                        ');
    if (import3.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _vc_7:import19.ViewContainer;
  _TemplateRef_7_5:any;
  _NgIf_7_6:import21.Wrapper_NgIf;
  _text_8:any;
  _text_9:any;
  /*private*/ _expr_13:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_15:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent4,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_13 = import20.UNINITIALIZED;
    this._expr_15 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_5,(null as any));
    this._vc_7 = new import19.ViewContainer(7,5,this,this._anchor_7);
    this._TemplateRef_7_5 = new import22.TemplateRef_(this,7,this._anchor_7);
    this._NgIf_7_6 = new import21.Wrapper_NgIf(this._vc_7.vcRef,this._TemplateRef_7_5);
    this._text_8 = this.renderer.createText(this._el_5,'\n                                                    ',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._anchor_7,
      this._text_8,
      this._text_9
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import23.NgIf) && (7 === requestNodeIndex))) { return this._NgIf_7_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    const currVal_7_0_0:any = this.parentView.parentView.context.isPhoneOpt;
    this._NgIf_7_6.check_ngIf(currVal_7_0_0,throwOnChange,false);
    this._NgIf_7_6.ngDoCheck(this,this._anchor_7,throwOnChange);
    this._vc_7.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_13:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.POINT.PHONE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_13,currVal_13))) {
      this.renderer.setText(this._text_3,currVal_13);
      this._expr_13 = currVal_13;
    }
    const currVal_15:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.pickupPoint.pickupIndications.phoneRequired,'\n                                                        ');
    if (import3.checkBinding(throwOnChange,this._expr_15,currVal_15)) {
      this.renderer.setText(this._text_6,currVal_15);
      this._expr_15 = currVal_15;
    }
  }
  destroyInternal():void {
    this._vc_7.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 7)) { return new View_BookingDetailComponent5(this.viewUtils,this,7,this._anchor_7,this._vc_7); }
    return (null as any);
  }
}
class View_BookingDetailComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_10:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent6,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import20.UNINITIALIZED;
    this._expr_10 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_8:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.POINT.PHONE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_8,currVal_8))) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    const currVal_10:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.pickUpPointOfSale.phone,'');
    if (import3.checkBinding(throwOnChange,this._expr_10,currVal_10)) {
      this.renderer.setText(this._text_6,currVal_10);
      this._expr_10 = currVal_10;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent10 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _map_3:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent10,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
    this._map_3 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        terminal_list_in: p0,
        terminal_list_out: p1
      }
      ;
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n                                                                ',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.position.cancun.multiple',this._map_3(this.parentView.parentView.parentView.parentView.parentView.context.getTerminalCancun('IN'),this.parentView.parentView.parentView.parentView.parentView.context.getTerminalCancun('OUT')))),'\n                                                            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent11 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  /*private*/ _expr_5:any;
  _map_6:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent11,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_5 = import20.UNINITIALIZED;
    this._map_6 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {terminal_list: p0};
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                            ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_5:any = import3.inlineInterpolate(1,'\n                                                                    ',valUnwrapper.unwrap(this._pipe_translate_0.transform(('bookingDetail.position.cancun.single.' + this.parentView.parentView.parentView.parentView.parentView.context.isInPosition()),this._map_6(this.parentView.parentView.parentView.parentView.parentView.context.getTerminalCancun()))),'\n                                                                ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_5,currVal_5))) {
      this.renderer.setText(this._text_3,currVal_5);
      this._expr_5 = currVal_5;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent9 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import19.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import21.Wrapper_NgIf;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _vc_4:import19.ViewContainer;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import21.Wrapper_NgIf;
  _text_5:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent9,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                            ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import19.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import22.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import21.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n                                                            ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_4 = new import19.ViewContainer(4,0,this,this._anchor_4);
    this._TemplateRef_4_5 = new import22.TemplateRef_(this,4,this._anchor_4);
    this._NgIf_4_6 = new import21.Wrapper_NgIf(this._vc_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._anchor_4,
      this._text_5
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import23.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import22.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import23.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.parentView.parentView.parentView.context.isMultipleCancun();
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    const currVal_4_0_0:boolean = !this.parentView.parentView.parentView.parentView.context.isMultipleCancun();
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.ngDoCheck(this,this._anchor_4,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    this._vc_4.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this._vc_4.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_BookingDetailComponent10(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    if ((nodeIndex == 4)) { return new View_BookingDetailComponent11(this.viewUtils,this,4,this._anchor_4,this._vc_4); }
    return (null as any);
  }
}
class View_BookingDetailComponent12 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  /*private*/ _expr_5:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent12,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_5 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_5:any = import3.inlineInterpolate(1,'\n                                                                ',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.position.cancun.none')),'\n                                                            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_5,currVal_5))) {
      this.renderer.setText(this._text_3,currVal_5);
      this._expr_5 = currVal_5;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent8 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import19.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import21.Wrapper_NgIf;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _vc_4:import19.ViewContainer;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import21.Wrapper_NgIf;
  _text_5:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent8,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import19.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import22.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import21.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_4 = new import19.ViewContainer(4,0,this,this._anchor_4);
    this._TemplateRef_4_5 = new import22.TemplateRef_(this,4,this._anchor_4);
    this._NgIf_4_6 = new import21.Wrapper_NgIf(this._vc_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._anchor_4,
      this._text_5
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import23.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import22.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import23.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.parentView.parentView.context.cancunHasCounter();
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    const currVal_4_0_0:boolean = !this.parentView.parentView.parentView.context.cancunHasCounter();
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.ngDoCheck(this,this._anchor_4,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    this._vc_4.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this._vc_4.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_BookingDetailComponent9(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    if ((nodeIndex == 4)) { return new View_BookingDetailComponent12(this.viewUtils,this,4,this._anchor_4,this._vc_4); }
    return (null as any);
  }
}
class View_BookingDetailComponent14 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _map_3:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent14,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
    this._map_3 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        platform_list_A: p0,
        platform_list_B: p1
      }
      ;
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n                                                            ',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.position.orlando.multiple',this._map_3(this.parentView.parentView.parentView.parentView.context.getOrlandoPlatforms('A'),this.parentView.parentView.parentView.parentView.context.getOrlandoPlatforms('B')))),'\n                                                        ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent15 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _map_3:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent15,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
    this._map_3 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        platform_list: p0,
        terminal: p1
      }
      ;
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n                                                            ',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.position.orlando.single',this._map_3(this.parentView.parentView.parentView.parentView.context.getOrlandoPlatforms(),this.parentView.parentView.parentView.parentView.context.getOrlandoTerminal()))),'\n                                                        ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent13 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import19.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import21.Wrapper_NgIf;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _vc_4:import19.ViewContainer;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import21.Wrapper_NgIf;
  _text_5:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent13,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import19.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import22.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import21.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_4 = new import19.ViewContainer(4,0,this,this._anchor_4);
    this._TemplateRef_4_5 = new import22.TemplateRef_(this,4,this._anchor_4);
    this._NgIf_4_6 = new import21.Wrapper_NgIf(this._vc_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._anchor_4,
      this._text_5
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import23.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import22.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import23.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.parentView.parentView.context.isMultipleOrlando();
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    const currVal_4_0_0:boolean = !this.parentView.parentView.parentView.context.isMultipleOrlando();
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.ngDoCheck(this,this._anchor_4,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    this._vc_4.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this._vc_4.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_BookingDetailComponent14(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    if ((nodeIndex == 4)) { return new View_BookingDetailComponent15(this.viewUtils,this,4,this._anchor_4,this._vc_4); }
    return (null as any);
  }
}
class View_BookingDetailComponent17 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _map_3:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent17,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
    this._map_3 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        platforms: p0,
        last_platform: p1
      }
      ;
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n                                                            ',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.position.rcc.plural',this._map_3(this.parentView.parentView.parentView.parentView.context.miamiAirportPositions,this.parentView.parentView.parentView.parentView.context.miamiAirportPositions_last))),'\n                                                        ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent18 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _map_3:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent18,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
    this._map_3 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {platform: p0};
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n                                                            ',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.position.rcc.singular',this._map_3(this.parentView.parentView.parentView.parentView.context.miamiAirportPositions))),'\n                                                        ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent16 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import19.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import21.Wrapper_NgIf;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _vc_4:import19.ViewContainer;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import21.Wrapper_NgIf;
  _text_5:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent16,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import19.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import22.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import21.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n\n                                                        ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_4 = new import19.ViewContainer(4,0,this,this._anchor_4);
    this._TemplateRef_4_5 = new import22.TemplateRef_(this,4,this._anchor_4);
    this._NgIf_4_6 = new import21.Wrapper_NgIf(this._vc_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._anchor_4,
      this._text_5
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import23.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import22.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import23.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = (this.parentView.parentView.parentView.context.indications.miamiAirportPositions && this.parentView.parentView.parentView.context.miamiAirportPositions_last);
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    const currVal_4_0_0:any = (this.parentView.parentView.parentView.context.indications.miamiAirportPositions && !this.parentView.parentView.parentView.context.miamiAirportPositions_last);
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.ngDoCheck(this,this._anchor_4,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    this._vc_4.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this._vc_4.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_BookingDetailComponent17(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    if ((nodeIndex == 4)) { return new View_BookingDetailComponent18(this.viewUtils,this,4,this._anchor_4,this._vc_4); }
    return (null as any);
  }
}
class View_BookingDetailComponent20 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent20,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(('pointOfSale.meetingType.description.' + this.parentView.parentView.parentView.parentView.context.bookingDetail.meetingType))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent19 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import19.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import21.Wrapper_NgIf;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent19,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import19.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import22.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import21.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import23.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:boolean = !this.parentView.parentView.parentView.context.indications;
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_BookingDetailComponent20(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
}
class View_BookingDetailComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import19.ViewContainer;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import21.Wrapper_NgIf;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _vc_7:import19.ViewContainer;
  _TemplateRef_7_5:any;
  _NgIf_7_6:import21.Wrapper_NgIf;
  _text_8:any;
  _anchor_9:any;
  /*private*/ _vc_9:import19.ViewContainer;
  _TemplateRef_9_5:any;
  _NgIf_9_6:import21.Wrapper_NgIf;
  _text_10:any;
  _anchor_11:any;
  /*private*/ _vc_11:import19.ViewContainer;
  _TemplateRef_11_5:any;
  _NgIf_11_6:import21.Wrapper_NgIf;
  _text_12:any;
  /*private*/ _expr_25:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent7,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_25 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n\n                                                    ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_5 = new import19.ViewContainer(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import22.TemplateRef_(this,5,this._anchor_5);
    this._NgIf_5_6 = new import21.Wrapper_NgIf(this._vc_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_7 = new import19.ViewContainer(7,0,this,this._anchor_7);
    this._TemplateRef_7_5 = new import22.TemplateRef_(this,7,this._anchor_7);
    this._NgIf_7_6 = new import21.Wrapper_NgIf(this._vc_7.vcRef,this._TemplateRef_7_5);
    this._text_8 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._anchor_9 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_9 = new import19.ViewContainer(9,0,this,this._anchor_9);
    this._TemplateRef_9_5 = new import22.TemplateRef_(this,9,this._anchor_9);
    this._NgIf_9_6 = new import21.Wrapper_NgIf(this._vc_9.vcRef,this._TemplateRef_9_5);
    this._text_10 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._anchor_11 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_11 = new import19.ViewContainer(11,0,this,this._anchor_11);
    this._TemplateRef_11_5 = new import22.TemplateRef_(this,11,this._anchor_11);
    this._NgIf_11_6 = new import21.Wrapper_NgIf(this._vc_11.vcRef,this._TemplateRef_11_5);
    this._text_12 = this.renderer.createText(this._el_0,'\n\n\n\n\n                                                ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._anchor_7,
      this._text_8,
      this._anchor_9,
      this._text_10,
      this._anchor_11,
      this._text_12
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import23.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    if (((token === import22.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import23.NgIf) && (7 === requestNodeIndex))) { return this._NgIf_7_6.context; }
    if (((token === import22.TemplateRef) && (9 === requestNodeIndex))) { return this._TemplateRef_9_5; }
    if (((token === import23.NgIf) && (9 === requestNodeIndex))) { return this._NgIf_9_6.context; }
    if (((token === import22.TemplateRef) && (11 === requestNodeIndex))) { return this._TemplateRef_11_5; }
    if (((token === import23.NgIf) && (11 === requestNodeIndex))) { return this._NgIf_11_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    const currVal_5_0_0:any = this.parentView.parentView.context.isCancunAirport();
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    const currVal_7_0_0:any = this.parentView.parentView.context.isOrlandoAirport();
    this._NgIf_7_6.check_ngIf(currVal_7_0_0,throwOnChange,false);
    this._NgIf_7_6.ngDoCheck(this,this._anchor_7,throwOnChange);
    const currVal_9_0_0:any = this.parentView.parentView.context.isMiamiAirport();
    this._NgIf_9_6.check_ngIf(currVal_9_0_0,throwOnChange,false);
    this._NgIf_9_6.ngDoCheck(this,this._anchor_9,throwOnChange);
    const currVal_11_0_0:boolean = !((this.parentView.parentView.context.isCancunAirport() || this.parentView.parentView.context.isOrlandoAirport()) || this.parentView.parentView.context.isMiamiAirport());
    this._NgIf_11_6.check_ngIf(currVal_11_0_0,throwOnChange,false);
    this._NgIf_11_6.ngDoCheck(this,this._anchor_11,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    this._vc_7.detectChangesInNestedViews(throwOnChange);
    this._vc_9.detectChangesInNestedViews(throwOnChange);
    this._vc_11.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_25:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.POINT.MEETING_TYPE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_25,currVal_25))) {
      this.renderer.setText(this._text_3,currVal_25);
      this._expr_25 = currVal_25;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._vc_7.destroyNestedViews();
    this._vc_9.destroyNestedViews();
    this._vc_11.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 5)) { return new View_BookingDetailComponent8(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    if ((nodeIndex == 7)) { return new View_BookingDetailComponent13(this.viewUtils,this,7,this._anchor_7,this._vc_7); }
    if ((nodeIndex == 9)) { return new View_BookingDetailComponent16(this.viewUtils,this,9,this._anchor_9,this._vc_9); }
    if ((nodeIndex == 11)) { return new View_BookingDetailComponent19(this.viewUtils,this,11,this._anchor_11,this._vc_11); }
    return (null as any);
  }
}
class View_BookingDetailComponent22 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent22,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2:any = import3.inlineInterpolate(1,'\n                                                            ',('/ ' + this.parentView.parentView.parentView.context.bookingDetail.pickupPoint.pickupIndications.phoneOptional),'\n                                                        ');
    if (import3.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent21 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _vc_7:import19.ViewContainer;
  _TemplateRef_7_5:any;
  _NgIf_7_6:import21.Wrapper_NgIf;
  _text_8:any;
  _text_9:any;
  /*private*/ _expr_13:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_15:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent21,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_13 = import20.UNINITIALIZED;
    this._expr_15 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_5,(null as any));
    this._vc_7 = new import19.ViewContainer(7,5,this,this._anchor_7);
    this._TemplateRef_7_5 = new import22.TemplateRef_(this,7,this._anchor_7);
    this._NgIf_7_6 = new import21.Wrapper_NgIf(this._vc_7.vcRef,this._TemplateRef_7_5);
    this._text_8 = this.renderer.createText(this._el_5,'\n                                                    ',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._anchor_7,
      this._text_8,
      this._text_9
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import23.NgIf) && (7 === requestNodeIndex))) { return this._NgIf_7_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    const currVal_7_0_0:any = this.parentView.parentView.context.isPhoneOpt;
    this._NgIf_7_6.check_ngIf(currVal_7_0_0,throwOnChange,false);
    this._NgIf_7_6.ngDoCheck(this,this._anchor_7,throwOnChange);
    this._vc_7.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_13:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.POINT.PHONE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_13,currVal_13))) {
      this.renderer.setText(this._text_3,currVal_13);
      this._expr_13 = currVal_13;
    }
    const currVal_15:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.pickupPoint.pickupIndications.phoneRequired,'\n                                                        ');
    if (import3.checkBinding(throwOnChange,this._expr_15,currVal_15)) {
      this.renderer.setText(this._text_6,currVal_15);
      this._expr_15 = currVal_15;
    }
  }
  destroyInternal():void {
    this._vc_7.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 7)) { return new View_BookingDetailComponent22(this.viewUtils,this,7,this._anchor_7,this._vc_7); }
    return (null as any);
  }
}
class View_BookingDetailComponent23 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_10:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent23,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import20.UNINITIALIZED;
    this._expr_10 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_8:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.POINT.PHONE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_8,currVal_8))) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    const currVal_10:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.pickUpPointOfSale.phone,'');
    if (import3.checkBinding(throwOnChange,this._expr_10,currVal_10)) {
      this.renderer.setText(this._text_6,currVal_10);
      this._expr_10 = currVal_10;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent25 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _el_3:any;
  _text_4:any;
  _text_5:any;
  _el_6:any;
  _NgClass_6_3:import24.Wrapper_NgClass;
  _el_7:any;
  _text_8:any;
  _text_9:any;
  _el_10:any;
  _NgClass_10_3:import24.Wrapper_NgClass;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _NgClass_14_3:import24.Wrapper_NgClass;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _NgClass_18_3:import24.Wrapper_NgClass;
  _el_19:any;
  _text_20:any;
  _text_21:any;
  _el_22:any;
  _NgClass_22_3:import24.Wrapper_NgClass;
  _el_23:any;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _el_27:any;
  _text_28:any;
  _text_29:any;
  _el_30:any;
  _el_31:any;
  _text_32:any;
  _text_33:any;
  /*private*/ _expr_39:any;
  _pipe_date_2_0:any;
  _map_41:any;
  /*private*/ _expr_42:any;
  _pipe_date_2_1:any;
  _map_44:any;
  /*private*/ _expr_45:any;
  _pipe_date_2_2:any;
  /*private*/ _expr_47:any;
  _map_48:any;
  /*private*/ _expr_49:any;
  /*private*/ _expr_50:any;
  _map_51:any;
  /*private*/ _expr_52:any;
  _map_53:any;
  /*private*/ _expr_54:any;
  /*private*/ _expr_55:any;
  /*private*/ _expr_56:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent25,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_39 = import20.UNINITIALIZED;
    this._map_41 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {redColor: p0};
    });
    this._expr_42 = import20.UNINITIALIZED;
    this._map_44 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {redColor: p0};
    });
    this._expr_45 = import20.UNINITIALIZED;
    this._expr_47 = import20.UNINITIALIZED;
    this._map_48 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {redColor: p0};
    });
    this._expr_49 = import20.UNINITIALIZED;
    this._expr_50 = import20.UNINITIALIZED;
    this._map_51 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {redColor: p0};
    });
    this._expr_52 = import20.UNINITIALIZED;
    this._map_53 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {redColor: p0};
    });
    this._expr_54 = import20.UNINITIALIZED;
    this._expr_55 = import20.UNINITIALIZED;
    this._expr_56 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-table-row',new import3.InlineArray2(2,'total','7'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray2(2,'class','cell-size cell-size-sm'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'',(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_0,'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._NgClass_6_3 = new import24.Wrapper_NgClass(this.parentView.parentView.parentView.parentView.injectorGet(import25.IterableDiffers,this.parentView.parentView.parentView.parentIndex),this.parentView.parentView.parentView.parentView.injectorGet(import26.KeyValueDiffers,this.parentView.parentView.parentView.parentIndex),new import27.ElementRef(this._el_6),this.renderer);
    this._el_7 = import3.createRenderElement(this.renderer,this._el_6,'span',new import3.InlineArray2(2,'class','cell-size cell-size-sm'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_0,'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._NgClass_10_3 = new import24.Wrapper_NgClass(this.parentView.parentView.parentView.parentView.injectorGet(import25.IterableDiffers,this.parentView.parentView.parentView.parentIndex),this.parentView.parentView.parentView.parentView.injectorGet(import26.KeyValueDiffers,this.parentView.parentView.parentView.parentIndex),new import27.ElementRef(this._el_10),this.renderer);
    this._el_11 = import3.createRenderElement(this.renderer,this._el_10,'span',new import3.InlineArray2(2,'class','cell-size cell-size-sm'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_0,'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._NgClass_14_3 = new import24.Wrapper_NgClass(this.parentView.parentView.parentView.parentView.injectorGet(import25.IterableDiffers,this.parentView.parentView.parentView.parentIndex),this.parentView.parentView.parentView.parentView.injectorGet(import26.KeyValueDiffers,this.parentView.parentView.parentView.parentIndex),new import27.ElementRef(this._el_14),this.renderer);
    this._el_15 = import3.createRenderElement(this.renderer,this._el_14,'span',new import3.InlineArray2(2,'class','cell-size'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_17 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_0,'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._NgClass_18_3 = new import24.Wrapper_NgClass(this.parentView.parentView.parentView.parentView.injectorGet(import25.IterableDiffers,this.parentView.parentView.parentView.parentIndex),this.parentView.parentView.parentView.parentView.injectorGet(import26.KeyValueDiffers,this.parentView.parentView.parentView.parentIndex),new import27.ElementRef(this._el_18),this.renderer);
    this._el_19 = import3.createRenderElement(this.renderer,this._el_18,'span',new import3.InlineArray2(2,'class','cell-size'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'',(null as any));
    this._text_21 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_0,'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._NgClass_22_3 = new import24.Wrapper_NgClass(this.parentView.parentView.parentView.parentView.injectorGet(import25.IterableDiffers,this.parentView.parentView.parentView.parentIndex),this.parentView.parentView.parentView.parentView.injectorGet(import26.KeyValueDiffers,this.parentView.parentView.parentView.parentIndex),new import27.ElementRef(this._el_22),this.renderer);
    this._el_23 = import3.createRenderElement(this.renderer,this._el_22,'span',new import3.InlineArray2(2,'class','cell-size'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'',(null as any));
    this._text_25 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_0,'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._el_27 = import3.createRenderElement(this.renderer,this._el_26,'span',new import3.InlineArray2(2,'class','cell-size cell-size-sm'),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'',(null as any));
    this._text_29 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_0,'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,this._el_30,'span',new import3.InlineArray2(2,'class','cell-size cell-size-sm'),(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'',(null as any));
    this._text_33 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_date_2_0 = import3.pureProxy2((<View_BookingDetailComponent0>this.parentView.parentView.parentView)._pipe_date_2.transform.bind((<View_BookingDetailComponent0>this.parentView.parentView.parentView)._pipe_date_2));
    this._pipe_date_2_1 = import3.pureProxy2((<View_BookingDetailComponent0>this.parentView.parentView.parentView)._pipe_date_2.transform.bind((<View_BookingDetailComponent0>this.parentView.parentView.parentView)._pipe_date_2));
    this._pipe_date_2_2 = import3.pureProxy2((<View_BookingDetailComponent0>this.parentView.parentView.parentView)._pipe_date_2.transform.bind((<View_BookingDetailComponent0>this.parentView.parentView.parentView)._pipe_date_2));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._el_3,
      this._text_4,
      this._text_5,
      this._el_6,
      this._el_7,
      this._text_8,
      this._text_9,
      this._el_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._el_19,
      this._text_20,
      this._text_21,
      this._el_22,
      this._el_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._el_27,
      this._text_28,
      this._text_29,
      this._el_30,
      this._el_31,
      this._text_32,
      this._text_33
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import28.NgClass) && ((6 <= requestNodeIndex) && (requestNodeIndex <= 8)))) { return this._NgClass_6_3.context; }
    if (((token === import28.NgClass) && ((10 <= requestNodeIndex) && (requestNodeIndex <= 12)))) { return this._NgClass_10_3.context; }
    if (((token === import28.NgClass) && ((14 <= requestNodeIndex) && (requestNodeIndex <= 16)))) { return this._NgClass_14_3.context; }
    if (((token === import28.NgClass) && ((18 <= requestNodeIndex) && (requestNodeIndex <= 20)))) { return this._NgClass_18_3.context; }
    if (((token === import28.NgClass) && ((22 <= requestNodeIndex) && (requestNodeIndex <= 24)))) { return this._NgClass_22_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    const currVal_6_0_0:any = '-eva-3-ellipsis';
    this._NgClass_6_3.check_klass(currVal_6_0_0,throwOnChange,false);
    const currVal_6_0_1:any = this._map_41((this.context.$implicit.pickupDate != this.parentView.parentView.parentView.context.bookingDetail.period.from));
    this._NgClass_6_3.check_ngClass(currVal_6_0_1,throwOnChange,false);
    this._NgClass_6_3.ngDoCheck(this,this._el_6,throwOnChange);
    const currVal_10_0_0:any = '-eva-3-ellipsis';
    this._NgClass_10_3.check_klass(currVal_10_0_0,throwOnChange,false);
    const currVal_10_0_1:any = this._map_44((this.context.$implicit.dropoffDate != this.parentView.parentView.parentView.context.bookingDetail.period.to));
    this._NgClass_10_3.check_ngClass(currVal_10_0_1,throwOnChange,false);
    this._NgClass_10_3.ngDoCheck(this,this._el_10,throwOnChange);
    const currVal_14_0_0:any = '-eva-3-ellipsis';
    this._NgClass_14_3.check_klass(currVal_14_0_0,throwOnChange,false);
    const currVal_14_0_1:any = this._map_48(!this.parentView.parentView.parentView.context.isEqualPickup(this.context.$implicit,this.parentView.parentView.parentView.context.bookingDetail));
    this._NgClass_14_3.check_ngClass(currVal_14_0_1,throwOnChange,false);
    this._NgClass_14_3.ngDoCheck(this,this._el_14,throwOnChange);
    const currVal_18_0_0:any = '-eva-3-ellipsis';
    this._NgClass_18_3.check_klass(currVal_18_0_0,throwOnChange,false);
    const currVal_18_0_1:any = this._map_51(!this.parentView.parentView.parentView.context.isEqualDropoff(this.context.$implicit,this.parentView.parentView.parentView.context.bookingDetail));
    this._NgClass_18_3.check_ngClass(currVal_18_0_1,throwOnChange,false);
    this._NgClass_18_3.ngDoCheck(this,this._el_18,throwOnChange);
    const currVal_22_0_0:any = '-eva-3-ellipsis';
    this._NgClass_22_3.check_klass(currVal_22_0_0,throwOnChange,false);
    const currVal_22_0_1:any = this._map_53((this.context.$implicit.car.oid != this.parentView.parentView.parentView.context.bookingDetail.car.oid));
    this._NgClass_22_3.check_ngClass(currVal_22_0_1,throwOnChange,false);
    this._NgClass_22_3.ngDoCheck(this,this._el_22,throwOnChange);
    valUnwrapper.reset();
    const currVal_39:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(import3.castByValue(this._pipe_date_2_0,(<View_BookingDetailComponent0>this.parentView.parentView.parentView)._pipe_date_2.transform)(this.context.$implicit.modificationDate,'dd-MM-yyyy')),' - ',this.parentView.parentView.parentView.context.getHour(this.context.$implicit.modificationDate),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_39,currVal_39))) {
      this.renderer.setText(this._text_4,currVal_39);
      this._expr_39 = currVal_39;
    }
    valUnwrapper.reset();
    const currVal_42:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(import3.castByValue(this._pipe_date_2_1,(<View_BookingDetailComponent0>this.parentView.parentView.parentView)._pipe_date_2.transform)(this.context.$implicit.pickupDate,'dd-MM-yyyy')),' - ',this.parentView.parentView.parentView.context.getHour(this.context.$implicit.pickupDate),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_42,currVal_42))) {
      this.renderer.setText(this._text_8,currVal_42);
      this._expr_42 = currVal_42;
    }
    valUnwrapper.reset();
    const currVal_45:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(import3.castByValue(this._pipe_date_2_2,(<View_BookingDetailComponent0>this.parentView.parentView.parentView)._pipe_date_2.transform)(this.context.$implicit.dropoffDate,'dd-MM-yyyy')),' - ',this.parentView.parentView.parentView.context.getHour(this.context.$implicit.dropoffDate),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_45,currVal_45))) {
      this.renderer.setText(this._text_12,currVal_45);
      this._expr_45 = currVal_45;
    }
    const currVal_47:any = import3.inlineInterpolate(1,'',this.parentView.parentView.parentView.context.buildAddress(this.context.$implicit.pickupPoint),'');
    if (import3.checkBinding(throwOnChange,this._expr_47,currVal_47)) {
      this.renderer.setElementProperty(this._el_14,'title',currVal_47);
      this._expr_47 = currVal_47;
    }
    const currVal_49:any = import3.inlineInterpolate(1,'',this.parentView.parentView.parentView.context.buildAddress(this.context.$implicit.pickupPoint),'');
    if (import3.checkBinding(throwOnChange,this._expr_49,currVal_49)) {
      this.renderer.setText(this._text_16,currVal_49);
      this._expr_49 = currVal_49;
    }
    const currVal_50:any = import3.inlineInterpolate(1,'',this.parentView.parentView.parentView.context.buildAddress(this.context.$implicit.dropoffPoint),'');
    if (import3.checkBinding(throwOnChange,this._expr_50,currVal_50)) {
      this.renderer.setElementProperty(this._el_18,'title',currVal_50);
      this._expr_50 = currVal_50;
    }
    const currVal_52:any = import3.inlineInterpolate(1,'',this.parentView.parentView.parentView.context.buildAddress(this.context.$implicit.dropoffPoint),'');
    if (import3.checkBinding(throwOnChange,this._expr_52,currVal_52)) {
      this.renderer.setText(this._text_20,currVal_52);
      this._expr_52 = currVal_52;
    }
    const currVal_54:any = import3.inlineInterpolate(3,'',this.context.$implicit.car.name,' - ',this.context.$implicit.car.carModel.model,' -',this.context.$implicit.car.carModel.brand,'');
    if (import3.checkBinding(throwOnChange,this._expr_54,currVal_54)) {
      this.renderer.setText(this._text_24,currVal_54);
      this._expr_54 = currVal_54;
    }
    const currVal_55:any = import3.inlineInterpolate(1,'',this.context.$implicit.carBasePrice,'');
    if (import3.checkBinding(throwOnChange,this._expr_55,currVal_55)) {
      this.renderer.setText(this._text_28,currVal_55);
      this._expr_55 = currVal_55;
    }
    const currVal_56:any = import3.inlineInterpolate(1,'',this.context.$implicit.totalPrice,'');
    if (import3.checkBinding(throwOnChange,this._expr_56,currVal_56)) {
      this.renderer.setText(this._text_32,currVal_56);
      this._expr_56 = currVal_56;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent24 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _el_13:any;
  _text_14:any;
  _text_15:any;
  _el_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _el_21:any;
  _text_22:any;
  _text_23:any;
  _el_24:any;
  _el_25:any;
  _text_26:any;
  _text_27:any;
  _el_28:any;
  _el_29:any;
  _text_30:any;
  _text_31:any;
  _el_32:any;
  _el_33:any;
  _text_34:any;
  _text_35:any;
  _el_36:any;
  _el_37:any;
  _text_38:any;
  _text_39:any;
  _el_40:any;
  _el_41:any;
  _text_42:any;
  _text_43:any;
  _text_44:any;
  _el_45:any;
  _text_46:any;
  _anchor_47:any;
  /*private*/ _vc_47:import19.ViewContainer;
  _TemplateRef_47_5:any;
  _NgFor_47_6:import29.Wrapper_NgFor;
  _text_48:any;
  _text_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _text_53:any;
  /*private*/ _expr_57:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_59:any;
  _pipe_translate_1:import18.TranslatePipe;
  /*private*/ _expr_61:any;
  _pipe_translate_2:import18.TranslatePipe;
  /*private*/ _expr_63:any;
  _pipe_translate_3:import18.TranslatePipe;
  /*private*/ _expr_65:any;
  _pipe_translate_4:import18.TranslatePipe;
  /*private*/ _expr_67:any;
  _pipe_translate_5:import18.TranslatePipe;
  /*private*/ _expr_69:any;
  _pipe_translate_6:import18.TranslatePipe;
  /*private*/ _expr_71:any;
  _pipe_translate_7:import18.TranslatePipe;
  /*private*/ _expr_73:any;
  _pipe_translate_8:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent24,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_57 = import20.UNINITIALIZED;
    this._expr_59 = import20.UNINITIALIZED;
    this._expr_61 = import20.UNINITIALIZED;
    this._expr_63 = import20.UNINITIALIZED;
    this._expr_65 = import20.UNINITIALIZED;
    this._expr_67 = import20.UNINITIALIZED;
    this._expr_69 = import20.UNINITIALIZED;
    this._expr_71 = import20.UNINITIALIZED;
    this._expr_73 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-dropdown',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','panel-info-border'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                            ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'dsp-table',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                                                ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'dsp-table-head',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                                                    ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal'),(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_12,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'',(null as any));
    this._text_15 = this.renderer.createText(this._el_10,'\n                                                    ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_10,'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal'),(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_16,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_10,'\n                                                    ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_10,'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal'),(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_20,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'',(null as any));
    this._text_23 = this.renderer.createText(this._el_10,'\n                                                    ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_10,'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal;'),(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_24,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'',(null as any));
    this._text_27 = this.renderer.createText(this._el_10,'\n                                                    ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_10,'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal;'),(null as any));
    this._el_29 = import3.createRenderElement(this.renderer,this._el_28,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_30 = this.renderer.createText(this._el_29,'',(null as any));
    this._text_31 = this.renderer.createText(this._el_10,'\n                                                    ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_10,'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal'),(null as any));
    this._el_33 = import3.createRenderElement(this.renderer,this._el_32,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_34 = this.renderer.createText(this._el_33,'',(null as any));
    this._text_35 = this.renderer.createText(this._el_10,'\n                                                    ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_10,'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal'),(null as any));
    this._el_37 = import3.createRenderElement(this.renderer,this._el_36,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_38 = this.renderer.createText(this._el_37,'',(null as any));
    this._text_39 = this.renderer.createText(this._el_10,'\n                                                    ',(null as any));
    this._el_40 = import3.createRenderElement(this.renderer,this._el_10,'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal'),(null as any));
    this._el_41 = import3.createRenderElement(this.renderer,this._el_40,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_42 = this.renderer.createText(this._el_41,'',(null as any));
    this._text_43 = this.renderer.createText(this._el_10,'\n                                                ',(null as any));
    this._text_44 = this.renderer.createText(this._el_8,'\n                                                ',(null as any));
    this._el_45 = import3.createRenderElement(this.renderer,this._el_8,'dsp-table-body',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_46 = this.renderer.createText(this._el_45,'\n                                                    ',(null as any));
    this._anchor_47 = this.renderer.createTemplateAnchor(this._el_45,(null as any));
    this._vc_47 = new import19.ViewContainer(47,45,this,this._anchor_47);
    this._TemplateRef_47_5 = new import22.TemplateRef_(this,47,this._anchor_47);
    this._NgFor_47_6 = new import29.Wrapper_NgFor(this._vc_47.vcRef,this._TemplateRef_47_5,this.parentView.parentView.parentView.injectorGet(import25.IterableDiffers,this.parentView.parentView.parentIndex),this.parentView.parentView.ref);
    this._text_48 = this.renderer.createText(this._el_45,'\n                                                ',(null as any));
    this._text_49 = this.renderer.createText(this._el_8,'\n                                            ',(null as any));
    this._text_50 = this.renderer.createText(this._el_6,'\n                                        ',(null as any));
    this._text_51 = this.renderer.createText(this._el_4,'\n                                    ',(null as any));
    this._text_52 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._text_53 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_2 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_3 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_4 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_5 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_6 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_7 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_8 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._el_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._el_21,
      this._text_22,
      this._text_23,
      this._el_24,
      this._el_25,
      this._text_26,
      this._text_27,
      this._el_28,
      this._el_29,
      this._text_30,
      this._text_31,
      this._el_32,
      this._el_33,
      this._text_34,
      this._text_35,
      this._el_36,
      this._el_37,
      this._text_38,
      this._text_39,
      this._el_40,
      this._el_41,
      this._text_42,
      this._text_43,
      this._text_44,
      this._el_45,
      this._text_46,
      this._anchor_47,
      this._text_48,
      this._text_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._text_53
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (47 === requestNodeIndex))) { return this._TemplateRef_47_5; }
    if (((token === import30.NgFor) && (47 === requestNodeIndex))) { return this._NgFor_47_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    const currVal_47_0_0:any = this.parentView.parentView.context.bookingHistories;
    this._NgFor_47_6.check_ngForOf(currVal_47_0_0,throwOnChange,false);
    this._NgFor_47_6.ngDoCheck(this,this._anchor_47,throwOnChange);
    this._vc_47.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_57:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.MODIFICATION_HISTORY')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_57,currVal_57))) {
      this.renderer.setElementProperty(this._el_0,'label',currVal_57);
      this._expr_57 = currVal_57;
    }
    valUnwrapper.reset();
    const currVal_59:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingDetail.MODIFICATION.DATE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_59,currVal_59))) {
      this.renderer.setText(this._text_14,currVal_59);
      this._expr_59 = currVal_59;
    }
    valUnwrapper.reset();
    const currVal_61:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('bookingDetail.MODIFICATION.PICKUP')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_61,currVal_61))) {
      this.renderer.setText(this._text_18,currVal_61);
      this._expr_61 = currVal_61;
    }
    valUnwrapper.reset();
    const currVal_63:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('bookingDetail.MODIFICATION.DROPOFF')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_63,currVal_63))) {
      this.renderer.setText(this._text_22,currVal_63);
      this._expr_63 = currVal_63;
    }
    valUnwrapper.reset();
    const currVal_65:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('bookingDetail.MODIFICATION.PICKUP_POS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_65,currVal_65))) {
      this.renderer.setText(this._text_26,currVal_65);
      this._expr_65 = currVal_65;
    }
    valUnwrapper.reset();
    const currVal_67:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('bookingDetail.MODIFICATION.DROPOFF_POS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_67,currVal_67))) {
      this.renderer.setText(this._text_30,currVal_67);
      this._expr_67 = currVal_67;
    }
    valUnwrapper.reset();
    const currVal_69:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('bookingDetail.MODIFICATION.CAR_DETAIL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_69,currVal_69))) {
      this.renderer.setText(this._text_34,currVal_69);
      this._expr_69 = currVal_69;
    }
    valUnwrapper.reset();
    const currVal_71:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('bookingDetail.MODIFICATION.BASE_PRICE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_71,currVal_71))) {
      this.renderer.setText(this._text_38,currVal_71);
      this._expr_71 = currVal_71;
    }
    valUnwrapper.reset();
    const currVal_73:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_8.transform('bookingDetail.MODIFICATION.TOTAL_PRICE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_73,currVal_73))) {
      this.renderer.setText(this._text_42,currVal_73);
      this._expr_73 = currVal_73;
    }
  }
  dirtyParentQueriesInternal():void {
    (<View_BookingDetailComponent0>this.parentView.parentView)._viewQuery_dp1_0.setDirty();
  }
  destroyInternal():void {
    this._vc_47.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 47)) { return new View_BookingDetailComponent25(this.viewUtils,this,47,this._anchor_47,this._vc_47); }
    return (null as any);
  }
}
class View_BookingDetailComponent26 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_10:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent26,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import20.UNINITIALIZED;
    this._expr_10 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_8:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.RATE.DAILY')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_8,currVal_8))) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    const currVal_10:any = import3.inlineInterpolate(2,'',this.parentView.parentView.context.bookingDetail.currencyCode,' ',this.parentView.parentView.context.bookingDetail.dailyPrice,'');
    if (import3.checkBinding(throwOnChange,this._expr_10,currVal_10)) {
      this.renderer.setText(this._text_6,currVal_10);
      this._expr_10 = currVal_10;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent27 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_10:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent27,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import20.UNINITIALIZED;
    this._expr_10 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_8:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(('bookingDetail.RATE.' + this.context.$implicit.chargeType))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_8,currVal_8))) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    const currVal_10:any = import3.inlineInterpolate(2,'',this.parentView.parentView.context.bookingDetail.currencyCode,' ',this.context.$implicit.amount,'');
    if (import3.checkBinding(throwOnChange,this._expr_10,currVal_10)) {
      this.renderer.setText(this._text_6,currVal_10);
      this._expr_10 = currVal_10;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent28 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_10:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent28,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import20.UNINITIALIZED;
    this._expr_10 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_8:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.INSURANCE_UPSELLING')),' (',this.parentView.parentView.context.listedBookedInsurences(),')\n                                                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_8,currVal_8))) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    const currVal_10:any = import3.inlineInterpolate(2,'',this.parentView.parentView.context.bookingDetail.currencyCode,' ',this.parentView.parentView.context.bookingDetail.bookedInsurancesBaseAmount,'');
    if (import3.checkBinding(throwOnChange,this._expr_10,currVal_10)) {
      this.renderer.setText(this._text_6,currVal_10);
      this._expr_10 = currVal_10;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent29 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_10:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent29,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import20.UNINITIALIZED;
    this._expr_10 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_8:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.FEES_ON_BASE')),' (',this.parentView.parentView.context.bookingDetail.percentageAdditionalCharges,'%)');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_8,currVal_8))) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    const currVal_10:any = import3.inlineInterpolate(2,'',this.parentView.parentView.context.bookingDetail.currencyCode,' ',this.parentView.parentView.context.bookingDetail.percentageAdditionalChargesAmount,'');
    if (import3.checkBinding(throwOnChange,this._expr_10,currVal_10)) {
      this.renderer.setText(this._text_6,currVal_10);
      this._expr_10 = currVal_10;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent30 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_10:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent30,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import20.UNINITIALIZED;
    this._expr_10 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_8:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.NOMINAL_TAXES')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_8,currVal_8))) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    const currVal_10:any = import3.inlineInterpolate(2,'',this.parentView.parentView.context.bookingDetail.currencyCode,' ',this.parentView.parentView.context.bookingDetail.fixedAmountAdditionalCharges,'');
    if (import3.checkBinding(throwOnChange,this._expr_10,currVal_10)) {
      this.renderer.setText(this._text_6,currVal_10);
      this._expr_10 = currVal_10;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent31 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_10:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent31,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import20.UNINITIALIZED;
    this._expr_10 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_8:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.AVAILABLE_ADDITIONALS_TEXT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_8,currVal_8))) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    const currVal_10:any = import3.inlineInterpolate(2,'',this.parentView.parentView.context.bookingDetail.currencyCode,' ',this.parentView.parentView.context.bookingDetail.bookedAssuredAdditionalsCost,'');
    if (import3.checkBinding(throwOnChange,this._expr_10,currVal_10)) {
      this.renderer.setText(this._text_6,currVal_10);
      this._expr_10 = currVal_10;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent32 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_10:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent32,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import20.UNINITIALIZED;
    this._expr_10 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_8:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.ADDITIONALS_VAT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_8,currVal_8))) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    const currVal_10:any = import3.inlineInterpolate(2,'',this.parentView.parentView.context.bookingDetail.currencyCode,' ',this.parentView.parentView.context.bookingDetail.bookedAssuredAdditionalsIvaCost,'');
    if (import3.checkBinding(throwOnChange,this._expr_10,currVal_10)) {
      this.renderer.setText(this._text_6,currVal_10);
      this._expr_10 = currVal_10;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent33 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_10:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent33,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import20.UNINITIALIZED;
    this._expr_10 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_8:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.ADDITIONALS_FEES')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_8,currVal_8))) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    const currVal_10:any = import3.inlineInterpolate(2,'',this.parentView.parentView.context.bookingDetail.currencyCode,' ',this.parentView.parentView.context.bookingDetail.bookedAssuredAdditionalsPercentageFeesAmount,'');
    if (import3.checkBinding(throwOnChange,this._expr_10,currVal_10)) {
      this.renderer.setText(this._text_6,currVal_10);
      this._expr_10 = currVal_10;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent35 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent35,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.AGE_CHARGE_PRICE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent36 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent36,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.AGE_CHARGE_PRICE_PREPAYMENT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent34 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import19.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import21.Wrapper_NgIf;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _vc_4:import19.ViewContainer;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import21.Wrapper_NgIf;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  /*private*/ _expr_15:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent34,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_15 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import19.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import22.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import21.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_4 = new import19.ViewContainer(4,0,this,this._anchor_4);
    this._TemplateRef_4_5 = new import22.TemplateRef_(this,4,this._anchor_4);
    this._NgIf_4_6 = new import21.Wrapper_NgIf(this._vc_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._anchor_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import23.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import22.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import23.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = (this.parentView.parentView.context.bookingDetail.paymentMethod != 'PREPAYMENT');
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    const currVal_4_0_0:any = (this.parentView.parentView.context.bookingDetail.paymentMethod == 'PREPAYMENT');
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.ngDoCheck(this,this._anchor_4,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    this._vc_4.detectChangesInNestedViews(throwOnChange);
    const currVal_15:any = import3.inlineInterpolate(2,'',this.parentView.parentView.context.bookingDetail.currencyCode,' ',this.parentView.parentView.context.bookingDetail.ageChargePrice,'');
    if (import3.checkBinding(throwOnChange,this._expr_15,currVal_15)) {
      this.renderer.setText(this._text_7,currVal_15);
      this._expr_15 = currVal_15;
    }
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this._vc_4.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_BookingDetailComponent35(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    if ((nodeIndex == 4)) { return new View_BookingDetailComponent36(this.viewUtils,this,4,this._anchor_4,this._vc_4); }
    return (null as any);
  }
}
class View_BookingDetailComponent37 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _text_9:any;
  /*private*/ _expr_10:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_12:any;
  /*private*/ _expr_13:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent37,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_10 = import20.UNINITIALIZED;
    this._expr_12 = import20.UNINITIALIZED;
    this._expr_13 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-md -eva-3-pt-sm -eva-3-pb-sm -eva-3-bc-gray-8'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-bold'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_5,'span',new import3.InlineArray2(2,'style','font-size: 16px;'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._text_9
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_10:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.TOTAL_TO_PAY')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_10,currVal_10))) {
      this.renderer.setText(this._text_3,currVal_10);
      this._expr_10 = currVal_10;
    }
    const currVal_12:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.currencyCode,' ');
    if (import3.checkBinding(throwOnChange,this._expr_12,currVal_12)) {
      this.renderer.setText(this._text_6,currVal_12);
      this._expr_12 = currVal_12;
    }
    const currVal_13:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.totalToPayAtDestination,'');
    if (import3.checkBinding(throwOnChange,this._expr_13,currVal_13)) {
      this.renderer.setText(this._text_8,currVal_13);
      this._expr_13 = currVal_13;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent38 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _text_9:any;
  /*private*/ _expr_10:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_12:any;
  /*private*/ _expr_13:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent38,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_10 = import20.UNINITIALIZED;
    this._expr_12 = import20.UNINITIALIZED;
    this._expr_13 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-md -eva-3-pt-sm -eva-3-pb-sm -eva-3-bc-gray-8'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-bold'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_5,'span',new import3.InlineArray2(2,'style','font-size: 16px;'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._text_9
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_10:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.PAY_AT_DEST_TOTAL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_10,currVal_10))) {
      this.renderer.setText(this._text_3,currVal_10);
      this._expr_10 = currVal_10;
    }
    const currVal_12:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.currencyCode,' ');
    if (import3.checkBinding(throwOnChange,this._expr_12,currVal_12)) {
      this.renderer.setText(this._text_6,currVal_12);
      this._expr_12 = currVal_12;
    }
    const currVal_13:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.totalToPayAtDestination,'');
    if (import3.checkBinding(throwOnChange,this._expr_13,currVal_13)) {
      this.renderer.setText(this._text_8,currVal_13);
      this._expr_13 = currVal_13;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent40 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent40,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import20.UNINITIALIZED;
    this._expr_5 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'style','font-size: 16px;'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_4:any = import3.inlineInterpolate(1,'',this.parentView.parentView.parentView.context.bookingDetail.currencyCode,' ');
    if (import3.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
    const currVal_5:any = import3.inlineInterpolate(1,'',this.parentView.parentView.parentView.context.bookingDetail.settlementPrice,'');
    if (import3.checkBinding(throwOnChange,this._expr_5,currVal_5)) {
      this.renderer.setText(this._text_3,currVal_5);
      this._expr_5 = currVal_5;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent41 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent41,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import20.UNINITIALIZED;
    this._expr_5 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'style','font-size: 16px;'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_4:any = import3.inlineInterpolate(1,'',this.parentView.parentView.parentView.context.bookingDetail.currencyCode,' ');
    if (import3.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
    const currVal_5:any = import3.inlineInterpolate(1,'',this.parentView.parentView.parentView.context.bookingDetail.totalToPayToSupplier,'');
    if (import3.checkBinding(throwOnChange,this._expr_5,currVal_5)) {
      this.renderer.setText(this._text_3,currVal_5);
      this._expr_5 = currVal_5;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent39 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import19.ViewContainer;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import21.Wrapper_NgIf;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _vc_7:import19.ViewContainer;
  _TemplateRef_7_5:any;
  _NgIf_7_6:import21.Wrapper_NgIf;
  _text_8:any;
  /*private*/ _expr_15:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent39,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_15 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-md -eva-3-pt-sm -eva-3-pb-sm -eva-3-bc-gray-8'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-bold'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_5 = new import19.ViewContainer(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import22.TemplateRef_(this,5,this._anchor_5);
    this._NgIf_5_6 = new import21.Wrapper_NgIf(this._vc_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_7 = new import19.ViewContainer(7,0,this,this._anchor_7);
    this._TemplateRef_7_5 = new import22.TemplateRef_(this,7,this._anchor_7);
    this._NgIf_7_6 = new import21.Wrapper_NgIf(this._vc_7.vcRef,this._TemplateRef_7_5);
    this._text_8 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._anchor_7,
      this._text_8
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import23.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    if (((token === import22.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import23.NgIf) && (7 === requestNodeIndex))) { return this._NgIf_7_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    const currVal_5_0_0:any = (this.parentView.parentView.context.bookingDetail.ageChargePrice == 0);
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    const currVal_7_0_0:any = (this.parentView.parentView.context.bookingDetail.ageChargePrice > 0);
    this._NgIf_7_6.check_ngIf(currVal_7_0_0,throwOnChange,false);
    this._NgIf_7_6.ngDoCheck(this,this._anchor_7,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    this._vc_7.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_15:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.PAY_TO_SUPPLIER')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_15,currVal_15))) {
      this.renderer.setText(this._text_3,currVal_15);
      this._expr_15 = currVal_15;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._vc_7.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 5)) { return new View_BookingDetailComponent40(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    if ((nodeIndex == 7)) { return new View_BookingDetailComponent41(this.viewUtils,this,7,this._anchor_7,this._vc_7); }
    return (null as any);
  }
}
class View_BookingDetailComponent42 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  /*private*/ _expr_24:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_26:any;
  /*private*/ _expr_27:any;
  /*private*/ _expr_28:any;
  _pipe_translate_1:import18.TranslatePipe;
  /*private*/ _expr_30:any;
  /*private*/ _expr_31:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent42,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_24 = import20.UNINITIALIZED;
    this._expr_26 = import20.UNINITIALIZED;
    this._expr_27 = import20.UNINITIALIZED;
    this._expr_28 = import20.UNINITIALIZED;
    this._expr_30 = import20.UNINITIALIZED;
    this._expr_31 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-md -eva-3-pt-sm -eva-3-pb-sm -eva-3-bc-gray-8'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                                            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-bold'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                                                            ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_7,'span',new import3.InlineArray2(2,'style','font-size: 16px;'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n                                                        ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_0,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-md -eva-3-pt-sm -eva-3-pb-sm -eva-3-bc-gray-8'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n                                                            ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_13,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-bold'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_17 = this.renderer.createText(this._el_13,'\n                                                            ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_13,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_18,'span',new import3.InlineArray2(2,'style','font-size: 16px;'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'',(null as any));
    this._text_22 = this.renderer.createText(this._el_13,'\n                                                        ',(null as any));
    this._text_23 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._text_23
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_24:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.PAY_AT_DEST_TOTAL_PREPAYMENT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_24,currVal_24))) {
      this.renderer.setText(this._text_5,currVal_24);
      this._expr_24 = currVal_24;
    }
    const currVal_26:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.currencyCode,' ');
    if (import3.checkBinding(throwOnChange,this._expr_26,currVal_26)) {
      this.renderer.setText(this._text_8,currVal_26);
      this._expr_26 = currVal_26;
    }
    const currVal_27:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.totalToPayAtDestination,'');
    if (import3.checkBinding(throwOnChange,this._expr_27,currVal_27)) {
      this.renderer.setText(this._text_10,currVal_27);
      this._expr_27 = currVal_27;
    }
    valUnwrapper.reset();
    const currVal_28:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingDetail.RESERVATION_TOTAL_PRICE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_28,currVal_28))) {
      this.renderer.setText(this._text_16,currVal_28);
      this._expr_28 = currVal_28;
    }
    const currVal_30:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.currencyCode,' ');
    if (import3.checkBinding(throwOnChange,this._expr_30,currVal_30)) {
      this.renderer.setText(this._text_19,currVal_30);
      this._expr_30 = currVal_30;
    }
    const currVal_31:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.settlementPrice,'');
    if (import3.checkBinding(throwOnChange,this._expr_31,currVal_31)) {
      this.renderer.setText(this._text_21,currVal_31);
      this._expr_31 = currVal_31;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent44 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent44,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.COMMISION_AND_TAXES_ALREADY_PAYED')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent45 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent45,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.RESERVATION_FULLY_PAID')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent43 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _anchor_8:any;
  /*private*/ _vc_8:import19.ViewContainer;
  _TemplateRef_8_5:any;
  _NgIf_8_6:import21.Wrapper_NgIf;
  _text_9:any;
  _anchor_10:any;
  /*private*/ _vc_10:import19.ViewContainer;
  _TemplateRef_10_5:any;
  _NgIf_10_6:import21.Wrapper_NgIf;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent43,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','panel-info-border'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                                ',(null as any));
    this._anchor_8 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_8 = new import19.ViewContainer(8,6,this,this._anchor_8);
    this._TemplateRef_8_5 = new import22.TemplateRef_(this,8,this._anchor_8);
    this._NgIf_8_6 = new import21.Wrapper_NgIf(this._vc_8.vcRef,this._TemplateRef_8_5);
    this._text_9 = this.renderer.createText(this._el_6,'\n                                                ',(null as any));
    this._anchor_10 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_10 = new import19.ViewContainer(10,6,this,this._anchor_10);
    this._TemplateRef_10_5 = new import22.TemplateRef_(this,10,this._anchor_10);
    this._NgIf_10_6 = new import21.Wrapper_NgIf(this._vc_10.vcRef,this._TemplateRef_10_5);
    this._text_11 = this.renderer.createText(this._el_6,'\n                                            ',(null as any));
    this._text_12 = this.renderer.createText(this._el_4,'\n                                        ',(null as any));
    this._text_13 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._text_14 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._anchor_8,
      this._text_9,
      this._anchor_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._text_14
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (8 === requestNodeIndex))) { return this._TemplateRef_8_5; }
    if (((token === import23.NgIf) && (8 === requestNodeIndex))) { return this._NgIf_8_6.context; }
    if (((token === import22.TemplateRef) && (10 === requestNodeIndex))) { return this._TemplateRef_10_5; }
    if (((token === import23.NgIf) && (10 === requestNodeIndex))) { return this._NgIf_10_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_8_0_0:any = (this.parentView.parentView.context.bookingDetail.paymentMethod == 'PREPAYMENT_COMMISSION');
    this._NgIf_8_6.check_ngIf(currVal_8_0_0,throwOnChange,false);
    this._NgIf_8_6.ngDoCheck(this,this._anchor_8,throwOnChange);
    const currVal_10_0_0:any = (this.parentView.parentView.context.bookingDetail.paymentMethod == 'PREPAYMENT');
    this._NgIf_10_6.check_ngIf(currVal_10_0_0,throwOnChange,false);
    this._NgIf_10_6.ngDoCheck(this,this._anchor_10,throwOnChange);
    this._vc_8.detectChangesInNestedViews(throwOnChange);
    this._vc_10.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_8.destroyNestedViews();
    this._vc_10.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 8)) { return new View_BookingDetailComponent44(this.viewUtils,this,8,this._anchor_8,this._vc_8); }
    if ((nodeIndex == 10)) { return new View_BookingDetailComponent45(this.viewUtils,this,10,this._anchor_10,this._vc_10); }
    return (null as any);
  }
}
class View_BookingDetailComponent46 extends import1.AppView<any> {
  _el_0:any;
  _el_1:any;
  _text_2:any;
  /*private*/ _expr_3:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent46,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_3 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal;'),(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,this._el_0,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._el_1,
      this._text_2
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_3:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(('bookingDetail.dailyRatesTable.' + this.parentView.parentView.context.bookingDetail.commissionType))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_3,currVal_3))) {
      this.renderer.setText(this._text_2,currVal_3);
      this._expr_3 = currVal_3;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent47 extends import1.AppView<any> {
  _el_0:any;
  _el_1:any;
  _text_2:any;
  /*private*/ _expr_3:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent47,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_3 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal;'),(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,this._el_0,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._el_1,
      this._text_2
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_3:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.dailyRatesTable.INTERNAL_NAME')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_3,currVal_3))) {
      this.renderer.setText(this._text_2,currVal_3);
      this._expr_3 = currVal_3;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent48 extends import1.AppView<any> {
  _el_0:any;
  _el_1:any;
  _text_2:any;
  /*private*/ _expr_3:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent48,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_3 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal;'),(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,this._el_0,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._el_1,
      this._text_2
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_3:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.dailyRatesTable.PROMOTION_TYPE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_3,currVal_3))) {
      this.renderer.setText(this._text_2,currVal_3);
      this._expr_3 = currVal_3;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent49 extends import1.AppView<any> {
  _el_0:any;
  _el_1:any;
  _text_2:any;
  /*private*/ _expr_3:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent49,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_3 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal;'),(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,this._el_0,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._el_1,
      this._text_2
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_3:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.dailyRatesTable.PROMOTION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_3,currVal_3))) {
      this.renderer.setText(this._text_2,currVal_3);
      this._expr_3 = currVal_3;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent50 extends import1.AppView<any> {
  _el_0:any;
  _el_1:any;
  _text_2:any;
  /*private*/ _expr_3:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent50,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_3 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal;'),(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,this._el_0,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._el_1,
      this._text_2
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_3:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.dailyRatesTable.OPAQUE_RATE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_3,currVal_3))) {
      this.renderer.setText(this._text_2,currVal_3);
      this._expr_3 = currVal_3;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent51 extends import1.AppView<any> {
  _el_0:any;
  _el_1:any;
  _text_2:any;
  /*private*/ _expr_3:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent51,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_3 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal;'),(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,this._el_0,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._el_1,
      this._text_2
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_3:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.dailyRatesTable.OPAQUE_RATE_DISCOUNT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_3,currVal_3))) {
      this.renderer.setText(this._text_2,currVal_3);
      this._expr_3 = currVal_3;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent53 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent53,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2:any = import3.inlineInterpolate(1,'',(this.parentView.context.$implicit.commissionPercentage + '%'),'');
    if (import3.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent54 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent54,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2:any = import3.inlineInterpolate(1,'',(!this.parentView.context.$implicit.specialOfferName? '-': this.parentView.context.$implicit.specialOfferName),'');
    if (import3.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent55 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent55,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2:any = import3.inlineInterpolate(1,'',(!this.parentView.context.$implicit.specialOfferPercentage? '-': (this.parentView.context.$implicit.specialOfferPercentage + '%')),'');
    if (import3.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent56 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent56,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2:any = import3.inlineInterpolate(1,'',(!this.parentView.context.$implicit.opaqueRateName? '-': this.parentView.context.$implicit.opaqueRateName),'');
    if (import3.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent57 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent57,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2:any = import3.inlineInterpolate(1,'',(!this.parentView.context.$implicit.opaqueRatePercentage? '-': (this.parentView.context.$implicit.opaqueRatePercentage + '%')),'');
    if (import3.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent52 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import19.ViewContainer;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import21.Wrapper_NgIf;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _vc_7:import19.ViewContainer;
  _TemplateRef_7_5:any;
  _NgIf_7_6:import21.Wrapper_NgIf;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _anchor_12:any;
  /*private*/ _vc_12:import19.ViewContainer;
  _TemplateRef_12_5:any;
  _NgIf_12_6:import21.Wrapper_NgIf;
  _text_13:any;
  _anchor_14:any;
  /*private*/ _vc_14:import19.ViewContainer;
  _TemplateRef_14_5:any;
  _NgIf_14_6:import21.Wrapper_NgIf;
  _text_15:any;
  _anchor_16:any;
  /*private*/ _vc_16:import19.ViewContainer;
  _TemplateRef_16_5:any;
  _NgIf_16_6:import21.Wrapper_NgIf;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _text_20:any;
  /*private*/ _expr_36:any;
  _pipe_translate_0:import18.TranslatePipe;
  _pipe_translate_1:import18.TranslatePipe;
  /*private*/ _expr_39:any;
  /*private*/ _expr_40:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent52,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_36 = import20.UNINITIALIZED;
    this._expr_39 = import20.UNINITIALIZED;
    this._expr_40 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-table-row',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_5 = new import19.ViewContainer(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import22.TemplateRef_(this,5,this._anchor_5);
    this._NgIf_5_6 = new import21.Wrapper_NgIf(this._vc_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_7 = new import19.ViewContainer(7,0,this,this._anchor_7);
    this._TemplateRef_7_5 = new import22.TemplateRef_(this,7,this._anchor_7);
    this._NgIf_7_6 = new import21.Wrapper_NgIf(this._vc_7.vcRef,this._TemplateRef_7_5);
    this._text_8 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_0,'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_12 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_12 = new import19.ViewContainer(12,0,this,this._anchor_12);
    this._TemplateRef_12_5 = new import22.TemplateRef_(this,12,this._anchor_12);
    this._NgIf_12_6 = new import21.Wrapper_NgIf(this._vc_12.vcRef,this._TemplateRef_12_5);
    this._text_13 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_14 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_14 = new import19.ViewContainer(14,0,this,this._anchor_14);
    this._TemplateRef_14_5 = new import22.TemplateRef_(this,14,this._anchor_14);
    this._NgIf_14_6 = new import21.Wrapper_NgIf(this._vc_14.vcRef,this._TemplateRef_14_5);
    this._text_15 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._anchor_16 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_16 = new import19.ViewContainer(16,0,this,this._anchor_16);
    this._TemplateRef_16_5 = new import22.TemplateRef_(this,16,this._anchor_16);
    this._NgIf_16_6 = new import21.Wrapper_NgIf(this._vc_16.vcRef,this._TemplateRef_16_5);
    this._text_17 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_0,'dsp-table-cell',new import3.InlineArray2(2,'class','-eva-3-ellipsis'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'',(null as any));
    this._text_20 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._anchor_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._anchor_12,
      this._text_13,
      this._anchor_14,
      this._text_15,
      this._anchor_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import23.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    if (((token === import22.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import23.NgIf) && (7 === requestNodeIndex))) { return this._NgIf_7_6.context; }
    if (((token === import22.TemplateRef) && (12 === requestNodeIndex))) { return this._TemplateRef_12_5; }
    if (((token === import23.NgIf) && (12 === requestNodeIndex))) { return this._NgIf_12_6.context; }
    if (((token === import22.TemplateRef) && (14 === requestNodeIndex))) { return this._TemplateRef_14_5; }
    if (((token === import23.NgIf) && (14 === requestNodeIndex))) { return this._NgIf_14_6.context; }
    if (((token === import22.TemplateRef) && (16 === requestNodeIndex))) { return this._TemplateRef_16_5; }
    if (((token === import23.NgIf) && (16 === requestNodeIndex))) { return this._NgIf_16_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    const currVal_5_0_0:any = this.parentView.parentView.context.isCommissionableOrMarkupVisible(this.parentView.parentView.context.permViewMarkup,this.parentView.parentView.context.bookingDetail.commissionType);
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    const currVal_7_0_0:any = this.parentView.parentView.context.hasSpecialOffer;
    this._NgIf_7_6.check_ngIf(currVal_7_0_0,throwOnChange,false);
    this._NgIf_7_6.ngDoCheck(this,this._anchor_7,throwOnChange);
    const currVal_12_0_0:any = this.parentView.parentView.context.hasSpecialOffer;
    this._NgIf_12_6.check_ngIf(currVal_12_0_0,throwOnChange,false);
    this._NgIf_12_6.ngDoCheck(this,this._anchor_12,throwOnChange);
    const currVal_14_0_0:any = this.parentView.parentView.context.hasOpaqueDiscount;
    this._NgIf_14_6.check_ngIf(currVal_14_0_0,throwOnChange,false);
    this._NgIf_14_6.ngDoCheck(this,this._anchor_14,throwOnChange);
    const currVal_16_0_0:any = this.parentView.parentView.context.hasOpaqueDiscount;
    this._NgIf_16_6.check_ngIf(currVal_16_0_0,throwOnChange,false);
    this._NgIf_16_6.ngDoCheck(this,this._anchor_16,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    this._vc_7.detectChangesInNestedViews(throwOnChange);
    this._vc_12.detectChangesInNestedViews(throwOnChange);
    this._vc_14.detectChangesInNestedViews(throwOnChange);
    this._vc_16.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_36:any = import3.inlineInterpolate(4,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(('common.week.short.' + this.parentView.parentView.context.getDay(this.context.$implicit.date)))),'. ',this.parentView.parentView.context.getDate(this.context.$implicit.date),' ',valUnwrapper.unwrap(this._pipe_translate_1.transform(('common.month.short.' + this.parentView.parentView.context.getMonth(this.context.$implicit.date)))),' ',this.parentView.parentView.context.getYear(this.context.$implicit.date),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_36,currVal_36))) {
      this.renderer.setText(this._text_3,currVal_36);
      this._expr_36 = currVal_36;
    }
    const currVal_39:any = import3.inlineInterpolate(1,' ',this.parentView.parentView.context.checkOfferType(this.context.$implicit),'');
    if (import3.checkBinding(throwOnChange,this._expr_39,currVal_39)) {
      this.renderer.setText(this._text_10,currVal_39);
      this._expr_39 = currVal_39;
    }
    const currVal_40:any = import3.inlineInterpolate(2,'',this.parentView.parentView.context.bookingDetail.currencyCode,' ',this.context.$implicit.rateWithDiscounts.toFixed(2),'');
    if (import3.checkBinding(throwOnChange,this._expr_40,currVal_40)) {
      this.renderer.setText(this._text_19,currVal_40);
      this._expr_40 = currVal_40;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._vc_7.destroyNestedViews();
    this._vc_12.destroyNestedViews();
    this._vc_14.destroyNestedViews();
    this._vc_16.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 5)) { return new View_BookingDetailComponent53(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    if ((nodeIndex == 7)) { return new View_BookingDetailComponent54(this.viewUtils,this,7,this._anchor_7,this._vc_7); }
    if ((nodeIndex == 12)) { return new View_BookingDetailComponent55(this.viewUtils,this,12,this._anchor_12,this._vc_12); }
    if ((nodeIndex == 14)) { return new View_BookingDetailComponent56(this.viewUtils,this,14,this._anchor_14,this._vc_14); }
    if ((nodeIndex == 16)) { return new View_BookingDetailComponent57(this.viewUtils,this,16,this._anchor_16,this._vc_16); }
    return (null as any);
  }
}
class View_BookingDetailComponent59 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  /*private*/ _expr_11:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_13:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent59,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_11 = import20.UNINITIALIZED;
    this._expr_13 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'ul',new import3.InlineArray2(2,'class',''),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                                            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                                                            ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n                                                        ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._text_9,
      this._text_10
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_11:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(('additionalPrice.additional.' + this.context.$implicit.additional.code))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_11,currVal_11))) {
      this.renderer.setText(this._text_5,currVal_11);
      this._expr_11 = currVal_11;
    }
    const currVal_13:any = import3.inlineInterpolate(2,'',this.context.$implicit.baseAmount,' ',this.parentView.parentView.parentView.context.bookingDetail.currencyCode,'');
    if (import3.checkBinding(throwOnChange,this._expr_13,currVal_13)) {
      this.renderer.setText(this._text_8,currVal_13);
      this._expr_13 = currVal_13;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent58 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _anchor_14:any;
  /*private*/ _vc_14:import19.ViewContainer;
  _TemplateRef_14_5:any;
  _NgFor_14_6:import29.Wrapper_NgFor;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  /*private*/ _expr_23:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_25:any;
  _pipe_translate_1:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent58,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_23 = import20.UNINITIALIZED;
    this._expr_25 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-dropdown',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','panel-info-border'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'span',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 -eva-3-pb-sm'),(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_8,'strong',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_6,'\n                                                ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                                                    ',(null as any));
    this._anchor_14 = this.renderer.createTemplateAnchor(this._el_12,(null as any));
    this._vc_14 = new import19.ViewContainer(14,12,this,this._anchor_14);
    this._TemplateRef_14_5 = new import22.TemplateRef_(this,14,this._anchor_14);
    this._NgFor_14_6 = new import29.Wrapper_NgFor(this._vc_14.vcRef,this._TemplateRef_14_5,this.parentView.parentView.parentView.injectorGet(import25.IterableDiffers,this.parentView.parentView.parentIndex),this.parentView.parentView.ref);
    this._text_15 = this.renderer.createText(this._el_12,'\n                                                ',(null as any));
    this._text_16 = this.renderer.createText(this._el_6,'\n                                            ',(null as any));
    this._text_17 = this.renderer.createText(this._el_4,'\n                                        ',(null as any));
    this._text_18 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._text_19 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._anchor_14,
      this._text_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._text_19
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (14 === requestNodeIndex))) { return this._TemplateRef_14_5; }
    if (((token === import30.NgFor) && (14 === requestNodeIndex))) { return this._NgFor_14_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    const currVal_14_0_0:any = this.parentView.parentView.context.bookingDetail.additionalsExcludedFromTotal;
    this._NgFor_14_6.check_ngForOf(currVal_14_0_0,throwOnChange,false);
    this._NgFor_14_6.ngDoCheck(this,this._anchor_14,throwOnChange);
    this._vc_14.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_23:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.ADDITIONALS_TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_23,currVal_23))) {
      this.renderer.setElementProperty(this._el_0,'label',currVal_23);
      this._expr_23 = currVal_23;
    }
    valUnwrapper.reset();
    const currVal_25:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingDetail.ADDITIONALS_DESCRIPTION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_25,currVal_25))) {
      this.renderer.setText(this._text_10,currVal_25);
      this._expr_25 = currVal_25;
    }
  }
  dirtyParentQueriesInternal():void {
    (<View_BookingDetailComponent0>this.parentView.parentView)._viewQuery_dp4_3.setDirty();
  }
  destroyInternal():void {
    this._vc_14.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 14)) { return new View_BookingDetailComponent59(this.viewUtils,this,14,this._anchor_14,this._vc_14); }
    return (null as any);
  }
}
class View_BookingDetailComponent61 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  /*private*/ _expr_17:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_19:any;
  /*private*/ _expr_20:any;
  /*private*/ _expr_21:any;
  /*private*/ _expr_22:any;
  _pipe_translate_1:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent61,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_17 = import20.UNINITIALIZED;
    this._expr_19 = import20.UNINITIALIZED;
    this._expr_20 = import20.UNINITIALIZED;
    this._expr_21 = import20.UNINITIALIZED;
    this._expr_22 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'ul',new import3.InlineArray2(2,'class',''),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                                                        ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n                                                            ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_7,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_7,'\n                                                            ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_7,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_7,'\n                                                        ',(null as any));
    this._text_15 = this.renderer.createText(this._el_2,'\n                                                    ',(null as any));
    this._text_16 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._text_16
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_17:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(('additionalPrice.additional.' + this.context.$implicit.additional.code))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_17,currVal_17))) {
      this.renderer.setText(this._text_5,currVal_17);
      this._expr_17 = currVal_17;
    }
    const currVal_19:boolean = !(this.context.$implicit.baseAmount > 0);
    if (import3.checkBinding(throwOnChange,this._expr_19,currVal_19)) {
      this.renderer.setElementProperty(this._el_9,'hidden',currVal_19);
      this._expr_19 = currVal_19;
    }
    const currVal_20:any = import3.inlineInterpolate(2,'',this.context.$implicit.baseAmount,' ',this.parentView.parentView.parentView.context.bookingDetail.currencyCode,'');
    if (import3.checkBinding(throwOnChange,this._expr_20,currVal_20)) {
      this.renderer.setText(this._text_10,currVal_20);
      this._expr_20 = currVal_20;
    }
    const currVal_21:boolean = !(this.context.$implicit.baseAmount == 0);
    if (import3.checkBinding(throwOnChange,this._expr_21,currVal_21)) {
      this.renderer.setElementProperty(this._el_12,'hidden',currVal_21);
      this._expr_21 = currVal_21;
    }
    valUnwrapper.reset();
    const currVal_22:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingDetail.ADDITIONAL_PRICE_INCLUDED')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_22,currVal_22))) {
      this.renderer.setText(this._text_13,currVal_22);
      this._expr_22 = currVal_22;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent60 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _anchor_14:any;
  /*private*/ _vc_14:import19.ViewContainer;
  _TemplateRef_14_5:any;
  _NgFor_14_6:import29.Wrapper_NgFor;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  /*private*/ _expr_23:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_25:any;
  _pipe_translate_1:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent60,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_23 = import20.UNINITIALIZED;
    this._expr_25 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-dropdown',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','panel-info-border'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                            ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'span',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 -eva-3-pb-sm'),(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_8,'strong',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_6,'\n                                            ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                                                ',(null as any));
    this._anchor_14 = this.renderer.createTemplateAnchor(this._el_12,(null as any));
    this._vc_14 = new import19.ViewContainer(14,12,this,this._anchor_14);
    this._TemplateRef_14_5 = new import22.TemplateRef_(this,14,this._anchor_14);
    this._NgFor_14_6 = new import29.Wrapper_NgFor(this._vc_14.vcRef,this._TemplateRef_14_5,this.parentView.parentView.parentView.injectorGet(import25.IterableDiffers,this.parentView.parentView.parentIndex),this.parentView.parentView.ref);
    this._text_15 = this.renderer.createText(this._el_12,'\n                                            ',(null as any));
    this._text_16 = this.renderer.createText(this._el_6,'\n                                        ',(null as any));
    this._text_17 = this.renderer.createText(this._el_4,'\n                                    ',(null as any));
    this._text_18 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._text_19 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._anchor_14,
      this._text_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._text_19
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (14 === requestNodeIndex))) { return this._TemplateRef_14_5; }
    if (((token === import30.NgFor) && (14 === requestNodeIndex))) { return this._NgFor_14_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    const currVal_14_0_0:any = this.parentView.parentView.context.bookingDetail.additionalsIncludedOnTotal;
    this._NgFor_14_6.check_ngForOf(currVal_14_0_0,throwOnChange,false);
    this._NgFor_14_6.ngDoCheck(this,this._anchor_14,throwOnChange);
    this._vc_14.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_23:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.AVAILABLE_ADDITIONALS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_23,currVal_23))) {
      this.renderer.setElementProperty(this._el_0,'label',currVal_23);
      this._expr_23 = currVal_23;
    }
    valUnwrapper.reset();
    const currVal_25:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingDetail.AVAILABLE_ADDITIONALS_DESCRIPTION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_25,currVal_25))) {
      this.renderer.setText(this._text_10,currVal_25);
      this._expr_25 = currVal_25;
    }
  }
  dirtyParentQueriesInternal():void {
    (<View_BookingDetailComponent0>this.parentView.parentView)._viewQuery_dp5_4.setDirty();
  }
  destroyInternal():void {
    this._vc_14.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 14)) { return new View_BookingDetailComponent61(this.viewUtils,this,14,this._anchor_14,this._vc_14); }
    return (null as any);
  }
}
class View_BookingDetailComponent63 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent63,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2:any = import3.inlineInterpolate(3,'',this.parentView.parentView.parentView.context.bookingDetail.currencyCode,' ',this.parentView.context.$implicit.amount,' (',this.parentView.context.$implicit.percentage,'%)');
    if (import3.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent64 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import18.TranslatePipe;
  _pipe_translate_1:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent64,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(3,'',this.parentView.parentView.parentView.context.bookingDetail.currencyCode,' ',this.parentView.context.$implicit.amount,' (',((this.parentView.context.$implicit.paymentType == 'UNIQUE')? valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.TOTAL')): valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingDetail.DAILY'))),')');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent65 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import18.TranslatePipe;
  _pipe_translate_1:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent65,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(5,'',this.parentView.parentView.parentView.context.bookingDetail.currencyCode,' ',this.parentView.context.$implicit.amount,' (',this.parentView.parentView.parentView.context.bookingDetail.currencyCode,' ',this.parentView.context.$implicit.percentage,' ',((this.parentView.context.$implicit.paymentType == 'UNIQUE')? valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.TOTAL')): valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingDetail.DAILY'))),')');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent62 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _vc_7:import19.ViewContainer;
  _TemplateRef_7_5:any;
  _NgIf_7_6:import21.Wrapper_NgIf;
  _text_8:any;
  _anchor_9:any;
  /*private*/ _vc_9:import19.ViewContainer;
  _TemplateRef_9_5:any;
  _NgIf_9_6:import21.Wrapper_NgIf;
  _text_10:any;
  _anchor_11:any;
  /*private*/ _vc_11:import19.ViewContainer;
  _TemplateRef_11_5:any;
  _NgIf_11_6:import21.Wrapper_NgIf;
  _text_12:any;
  _text_13:any;
  /*private*/ _expr_23:any;
  _pipe_translate_0:import18.TranslatePipe;
  _pipe_translate_1:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent62,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_23 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'ul',new import3.InlineArray2(2,'class',''),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                                                        ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_7 = new import19.ViewContainer(7,2,this,this._anchor_7);
    this._TemplateRef_7_5 = new import22.TemplateRef_(this,7,this._anchor_7);
    this._NgIf_7_6 = new import21.Wrapper_NgIf(this._vc_7.vcRef,this._TemplateRef_7_5);
    this._text_8 = this.renderer.createText(this._el_2,'\n                                                        ',(null as any));
    this._anchor_9 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_9 = new import19.ViewContainer(9,2,this,this._anchor_9);
    this._TemplateRef_9_5 = new import22.TemplateRef_(this,9,this._anchor_9);
    this._NgIf_9_6 = new import21.Wrapper_NgIf(this._vc_9.vcRef,this._TemplateRef_9_5);
    this._text_10 = this.renderer.createText(this._el_2,'\n                                                        ',(null as any));
    this._anchor_11 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_11 = new import19.ViewContainer(11,2,this,this._anchor_11);
    this._TemplateRef_11_5 = new import22.TemplateRef_(this,11,this._anchor_11);
    this._NgIf_11_6 = new import21.Wrapper_NgIf(this._vc_11.vcRef,this._TemplateRef_11_5);
    this._text_12 = this.renderer.createText(this._el_2,'\n                                                    ',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._anchor_7,
      this._text_8,
      this._anchor_9,
      this._text_10,
      this._anchor_11,
      this._text_12,
      this._text_13
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import23.NgIf) && (7 === requestNodeIndex))) { return this._NgIf_7_6.context; }
    if (((token === import22.TemplateRef) && (9 === requestNodeIndex))) { return this._TemplateRef_9_5; }
    if (((token === import23.NgIf) && (9 === requestNodeIndex))) { return this._NgIf_9_6.context; }
    if (((token === import22.TemplateRef) && (11 === requestNodeIndex))) { return this._TemplateRef_11_5; }
    if (((token === import23.NgIf) && (11 === requestNodeIndex))) { return this._NgIf_11_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    const currVal_7_0_0:any = (this.context.$implicit.amountType == 'PERCENTAGE');
    this._NgIf_7_6.check_ngIf(currVal_7_0_0,throwOnChange,false);
    this._NgIf_7_6.ngDoCheck(this,this._anchor_7,throwOnChange);
    const currVal_9_0_0:any = ((this.context.$implicit.paymentType == 'UNIQUE') && (this.context.$implicit.amountType != 'PERCENTAGE'));
    this._NgIf_9_6.check_ngIf(currVal_9_0_0,throwOnChange,false);
    this._NgIf_9_6.ngDoCheck(this,this._anchor_9,throwOnChange);
    const currVal_11_0_0:any = ((this.context.$implicit.paymentType != 'UNIQUE') && (this.context.$implicit.amountType != 'PERCENTAGE'));
    this._NgIf_11_6.check_ngIf(currVal_11_0_0,throwOnChange,false);
    this._NgIf_11_6.ngDoCheck(this,this._anchor_11,throwOnChange);
    this._vc_7.detectChangesInNestedViews(throwOnChange);
    this._vc_9.detectChangesInNestedViews(throwOnChange);
    this._vc_11.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_23:any = import3.inlineInterpolate(2,'',this.context.$implicit.name,' (',((this.context.$implicit.category == 'TAX')? valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.BILL')): valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingDetail.TAX'))),')');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_23,currVal_23))) {
      this.renderer.setText(this._text_5,currVal_23);
      this._expr_23 = currVal_23;
    }
  }
  destroyInternal():void {
    this._vc_7.destroyNestedViews();
    this._vc_9.destroyNestedViews();
    this._vc_11.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 7)) { return new View_BookingDetailComponent63(this.viewUtils,this,7,this._anchor_7,this._vc_7); }
    if ((nodeIndex == 9)) { return new View_BookingDetailComponent64(this.viewUtils,this,9,this._anchor_9,this._vc_9); }
    if ((nodeIndex == 11)) { return new View_BookingDetailComponent65(this.viewUtils,this,11,this._anchor_11,this._vc_11); }
    return (null as any);
  }
}
class View_BookingDetailComponent66 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_10:any;
  _pipe_translate_1:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent66,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import20.UNINITIALIZED;
    this._expr_10 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','detail-text -eva-3-tc-gray-3'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','-eva-3-bold -eva-3-tc-gray-3'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_8:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_0.transform('Upgrade')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_8,currVal_8))) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    valUnwrapper.reset();
    const currVal_10:any = import3.inlineInterpolate(6,' ',this.parentView.parentView.context.upgradeCar.upgradeCarCategory,' - ',this.parentView.parentView.context.upgradeCar.upgradeCarName,' - ',this.parentView.parentView.context.upgradeCar.upgradeCarModel,' - ',this.parentView.parentView.context.upgradeCar.upgradeCarBrand,' - ',this.parentView.parentView.context.upgradeCar.upgradeCarDoors,' ',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingDetail.CAR.DOORS')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_10,currVal_10))) {
      this.renderer.setText(this._text_6,currVal_10);
      this._expr_10 = currVal_10;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent68 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import18.TranslatePipe;
  _pipe_translate_1:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent68,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','-eva-3-bold -eva-3-tc-gray-3'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(3,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('common.TO')),' ',this.parentView.parentView.parentView.context.bookingDetail.distanceValue,' ',valUnwrapper.unwrap(this._pipe_translate_1.transform(('DISTANCE.' + this.parentView.parentView.parentView.context.bookingDetail.distanceUnit))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent69 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent69,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','-eva-3-bold -eva-3-tc-gray-3'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.CAR.UNLIMITED')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent67 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import19.ViewContainer;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import21.Wrapper_NgIf;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _vc_7:import19.ViewContainer;
  _TemplateRef_7_5:any;
  _NgIf_7_6:import21.Wrapper_NgIf;
  _text_8:any;
  /*private*/ _expr_15:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent67,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_15 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','-eva-3-pt-md -eva-3-pb-lg side-panel-info-border'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','detail-text -eva-3-tc-gray-3'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_5 = new import19.ViewContainer(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import22.TemplateRef_(this,5,this._anchor_5);
    this._NgIf_5_6 = new import21.Wrapper_NgIf(this._vc_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_7 = new import19.ViewContainer(7,0,this,this._anchor_7);
    this._TemplateRef_7_5 = new import22.TemplateRef_(this,7,this._anchor_7);
    this._NgIf_7_6 = new import21.Wrapper_NgIf(this._vc_7.vcRef,this._TemplateRef_7_5);
    this._text_8 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._anchor_7,
      this._text_8
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import23.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    if (((token === import22.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import23.NgIf) && (7 === requestNodeIndex))) { return this._NgIf_7_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    const currVal_5_0_0:any = (this.parentView.parentView.context.bookingDetail.distanceUnit != 'UNLIMITED');
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    const currVal_7_0_0:any = (this.parentView.parentView.context.bookingDetail.distanceUnit == 'UNLIMITED');
    this._NgIf_7_6.check_ngIf(currVal_7_0_0,throwOnChange,false);
    this._NgIf_7_6.ngDoCheck(this,this._anchor_7,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    this._vc_7.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_15:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.CAR.DISTANCE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_15,currVal_15))) {
      this.renderer.setText(this._text_3,currVal_15);
      this._expr_15 = currVal_15;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._vc_7.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 5)) { return new View_BookingDetailComponent68(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    if ((nodeIndex == 7)) { return new View_BookingDetailComponent69(this.viewUtils,this,7,this._anchor_7,this._vc_7); }
    return (null as any);
  }
}
class View_BookingDetailComponent70 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  _text_26:any;
  _text_27:any;
  _text_28:any;
  /*private*/ _expr_29:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_31:any;
  _pipe_translate_1:import18.TranslatePipe;
  /*private*/ _expr_33:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent70,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_29 = import20.UNINITIALIZED;
    this._expr_31 = import20.UNINITIALIZED;
    this._expr_33 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-panel-info right-panel -eva-3-bc-gray-7 -eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'h5',new import3.InlineArray2(2,'class','eva-3-h6'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n                                    ',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n                                    ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_11,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n                                        ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_13,'ul',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                                            ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'li',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n                                                ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_17,'p',new import3.InlineArray2(2,'class','detail-text -eva-3-tc-gray-3'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'',(null as any));
    this._text_21 = this.renderer.createText(this._el_17,'\n                                                ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_17,'p',new import3.InlineArray2(2,'class','-eva-3-bold -eva-3-tc-gray-3'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'',(null as any));
    this._text_24 = this.renderer.createText(this._el_17,'\n                                            ',(null as any));
    this._text_25 = this.renderer.createText(this._el_15,'\n                                        ',(null as any));
    this._text_26 = this.renderer.createText(this._el_13,'\n                                    ',(null as any));
    this._text_27 = this.renderer.createText(this._el_11,'\n                                ',(null as any));
    this._text_28 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._text_24,
      this._text_25,
      this._text_26,
      this._text_27,
      this._text_28
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_29:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.CANCELLATION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_29,currVal_29))) {
      this.renderer.setText(this._text_7,currVal_29);
      this._expr_29 = currVal_29;
    }
    valUnwrapper.reset();
    const currVal_31:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingDetail.CANCELLATION_DATE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_31,currVal_31))) {
      this.renderer.setText(this._text_20,currVal_31);
      this._expr_31 = currVal_31;
    }
    const currVal_33:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.bookingDetail.cancel.cancelDate,'');
    if (import3.checkBinding(throwOnChange,this._expr_33,currVal_33)) {
      this.renderer.setText(this._text_23,currVal_33);
      this._expr_33 = currVal_33;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent71 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  /*private*/ _expr_26:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_28:any;
  _pipe_translate_1:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent71,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_26 = import20.UNINITIALIZED;
    this._expr_28 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-panel-info right-panel -eva-3-bc-gray-7 -eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'h5',new import3.InlineArray2(2,'class','eva-3-h6'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n                                    ',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n                                    ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_11,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n                                        ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_13,'ul',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                                            ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'li',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n                                                ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_17,'p',new import3.InlineArray2(2,'class','detail-text -eva-3-tc-gray-3'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'',(null as any));
    this._text_21 = this.renderer.createText(this._el_17,'\n                                            ',(null as any));
    this._text_22 = this.renderer.createText(this._el_15,'\n                                        ',(null as any));
    this._text_23 = this.renderer.createText(this._el_13,'\n                                    ',(null as any));
    this._text_24 = this.renderer.createText(this._el_11,'\n                                ',(null as any));
    this._text_25 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._text_25
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_26:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.CANCELLATION_POLICIES_TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_26,currVal_26))) {
      this.renderer.setText(this._text_7,currVal_26);
      this._expr_26 = currVal_26;
    }
    valUnwrapper.reset();
    const currVal_28:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingDetail.CANCELLATION_POLICIES')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_28,currVal_28))) {
      this.renderer.setText(this._text_20,currVal_28);
      this._expr_28 = currVal_28;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingDetailComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _text_40:any;
  _el_41:any;
  _text_42:any;
  _el_43:any;
  _text_44:any;
  _text_45:any;
  _text_46:any;
  _text_47:any;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _el_51:any;
  _text_52:any;
  _el_53:any;
  _text_54:any;
  _el_55:any;
  _text_56:any;
  _text_57:any;
  _el_58:any;
  _text_59:any;
  _text_60:any;
  _text_61:any;
  _el_62:any;
  _text_63:any;
  _el_64:any;
  _text_65:any;
  _text_66:any;
  _el_67:any;
  _text_68:any;
  _text_69:any;
  _text_70:any;
  _el_71:any;
  _text_72:any;
  _el_73:any;
  _text_74:any;
  _text_75:any;
  _el_76:any;
  _text_77:any;
  _text_78:any;
  _text_79:any;
  _el_80:any;
  _text_81:any;
  _el_82:any;
  _text_83:any;
  _text_84:any;
  _el_85:any;
  _text_86:any;
  _text_87:any;
  _text_88:any;
  _el_89:any;
  _text_90:any;
  _el_91:any;
  _text_92:any;
  _text_93:any;
  _el_94:any;
  _text_95:any;
  _text_96:any;
  _text_97:any;
  _text_98:any;
  _text_99:any;
  _text_100:any;
  _anchor_101:any;
  /*private*/ _vc_101:import19.ViewContainer;
  _TemplateRef_101_5:any;
  _NgIf_101_6:import21.Wrapper_NgIf;
  _text_102:any;
  _text_103:any;
  _el_104:any;
  _text_105:any;
  _el_106:any;
  _text_107:any;
  _el_108:any;
  _text_109:any;
  _el_110:any;
  compView_110:import1.AppView<import31.EmailTooltipComponent>;
  _GAService_110_3:import32.GAService;
  _MobileService_110_4:import33.MobileService;
  _BookingService_110_5:import5.BookingService;
  _EmailTooltipComponent_110_6:import34.Wrapper_EmailTooltipComponent;
  _text_111:any;
  _text_112:any;
  _text_113:any;
  _text_114:any;
  _text_115:any;
  _text_116:any;
  _text_117:any;
  _text_118:any;
  _text_119:any;
  _text_120:any;
  _el_121:any;
  _text_122:any;
  _el_123:any;
  _text_124:any;
  _el_125:any;
  _text_126:any;
  _el_127:any;
  _text_128:any;
  _el_129:any;
  _text_130:any;
  _el_131:any;
  _text_132:any;
  _el_133:any;
  _text_134:any;
  _text_135:any;
  _el_136:any;
  _text_137:any;
  _el_138:any;
  _text_139:any;
  _text_140:any;
  _text_141:any;
  _text_142:any;
  _text_143:any;
  _el_144:any;
  _text_145:any;
  _el_146:any;
  _text_147:any;
  _el_148:any;
  _text_149:any;
  _el_150:any;
  _text_151:any;
  _text_152:any;
  _el_153:any;
  _text_154:any;
  _text_155:any;
  _text_156:any;
  _el_157:any;
  _text_158:any;
  _el_159:any;
  _text_160:any;
  _text_161:any;
  _el_162:any;
  _text_163:any;
  _text_164:any;
  _text_165:any;
  _el_166:any;
  _text_167:any;
  _el_168:any;
  _text_169:any;
  _text_170:any;
  _el_171:any;
  _text_172:any;
  _text_173:any;
  _text_174:any;
  _el_175:any;
  _text_176:any;
  _el_177:any;
  _text_178:any;
  _text_179:any;
  _el_180:any;
  _text_181:any;
  _text_182:any;
  _text_183:any;
  _anchor_184:any;
  /*private*/ _vc_184:import19.ViewContainer;
  _TemplateRef_184_5:any;
  _NgIf_184_6:import21.Wrapper_NgIf;
  _text_185:any;
  _anchor_186:any;
  /*private*/ _vc_186:import19.ViewContainer;
  _TemplateRef_186_5:any;
  _NgIf_186_6:import21.Wrapper_NgIf;
  _text_187:any;
  _anchor_188:any;
  /*private*/ _vc_188:import19.ViewContainer;
  _TemplateRef_188_5:any;
  _NgIf_188_6:import21.Wrapper_NgIf;
  _text_189:any;
  _text_190:any;
  _text_191:any;
  _text_192:any;
  _el_193:any;
  _text_194:any;
  _el_195:any;
  _text_196:any;
  _el_197:any;
  _text_198:any;
  _el_199:any;
  _text_200:any;
  _el_201:any;
  _text_202:any;
  _text_203:any;
  _el_204:any;
  _text_205:any;
  _el_206:any;
  _text_207:any;
  _text_208:any;
  _text_209:any;
  _text_210:any;
  _text_211:any;
  _el_212:any;
  _text_213:any;
  _el_214:any;
  _text_215:any;
  _el_216:any;
  _text_217:any;
  _el_218:any;
  _text_219:any;
  _text_220:any;
  _el_221:any;
  _text_222:any;
  _text_223:any;
  _text_224:any;
  _el_225:any;
  _text_226:any;
  _el_227:any;
  _text_228:any;
  _text_229:any;
  _el_230:any;
  _text_231:any;
  _text_232:any;
  _text_233:any;
  _el_234:any;
  _text_235:any;
  _el_236:any;
  _text_237:any;
  _text_238:any;
  _el_239:any;
  _text_240:any;
  _text_241:any;
  _text_242:any;
  _anchor_243:any;
  /*private*/ _vc_243:import19.ViewContainer;
  _TemplateRef_243_5:any;
  _NgIf_243_6:import21.Wrapper_NgIf;
  _text_244:any;
  _anchor_245:any;
  /*private*/ _vc_245:import19.ViewContainer;
  _TemplateRef_245_5:any;
  _NgIf_245_6:import21.Wrapper_NgIf;
  _text_246:any;
  _text_247:any;
  _text_248:any;
  _text_249:any;
  _text_250:any;
  _text_251:any;
  _text_252:any;
  _text_253:any;
  _anchor_254:any;
  /*private*/ _vc_254:import19.ViewContainer;
  _TemplateRef_254_5:any;
  _NgIf_254_6:import21.Wrapper_NgIf;
  _text_255:any;
  _text_256:any;
  _text_257:any;
  _el_258:any;
  _text_259:any;
  _el_260:any;
  _text_261:any;
  _el_262:any;
  _text_263:any;
  _el_264:any;
  _text_265:any;
  _el_266:any;
  _text_267:any;
  _el_268:any;
  _text_269:any;
  _anchor_270:any;
  /*private*/ _vc_270:import19.ViewContainer;
  _TemplateRef_270_5:any;
  _NgIf_270_6:import21.Wrapper_NgIf;
  _text_271:any;
  _el_272:any;
  _text_273:any;
  _el_274:any;
  _text_275:any;
  _text_276:any;
  _el_277:any;
  _text_278:any;
  _text_279:any;
  _text_280:any;
  _anchor_281:any;
  /*private*/ _vc_281:import19.ViewContainer;
  _TemplateRef_281_5:any;
  _NgFor_281_6:import29.Wrapper_NgFor;
  _text_282:any;
  _el_283:any;
  _text_284:any;
  _el_285:any;
  _text_286:any;
  _text_287:any;
  _el_288:any;
  _text_289:any;
  _text_290:any;
  _text_291:any;
  _anchor_292:any;
  /*private*/ _vc_292:import19.ViewContainer;
  _TemplateRef_292_5:any;
  _NgIf_292_6:import21.Wrapper_NgIf;
  _text_293:any;
  _el_294:any;
  _text_295:any;
  _el_296:any;
  _text_297:any;
  _text_298:any;
  _el_299:any;
  _text_300:any;
  _text_301:any;
  _text_302:any;
  _text_303:any;
  _text_304:any;
  _text_305:any;
  _text_306:any;
  _text_307:any;
  _el_308:any;
  _text_309:any;
  _el_310:any;
  _text_311:any;
  _el_312:any;
  _text_313:any;
  _el_314:any;
  _text_315:any;
  _el_316:any;
  _text_317:any;
  _el_318:any;
  _text_319:any;
  _el_320:any;
  _text_321:any;
  _text_322:any;
  _el_323:any;
  _text_324:any;
  _text_325:any;
  _text_326:any;
  _el_327:any;
  _text_328:any;
  _el_329:any;
  _text_330:any;
  _text_331:any;
  _el_332:any;
  _text_333:any;
  _text_334:any;
  _text_335:any;
  _el_336:any;
  _text_337:any;
  _el_338:any;
  _text_339:any;
  _text_340:any;
  _el_341:any;
  _text_342:any;
  _text_343:any;
  _text_344:any;
  _el_345:any;
  _text_346:any;
  _el_347:any;
  _text_348:any;
  _text_349:any;
  _el_350:any;
  _text_351:any;
  _text_352:any;
  _text_353:any;
  _anchor_354:any;
  /*private*/ _vc_354:import19.ViewContainer;
  _TemplateRef_354_5:any;
  _NgIf_354_6:import21.Wrapper_NgIf;
  _text_355:any;
  _anchor_356:any;
  /*private*/ _vc_356:import19.ViewContainer;
  _TemplateRef_356_5:any;
  _NgIf_356_6:import21.Wrapper_NgIf;
  _text_357:any;
  _anchor_358:any;
  /*private*/ _vc_358:import19.ViewContainer;
  _TemplateRef_358_5:any;
  _NgIf_358_6:import21.Wrapper_NgIf;
  _text_359:any;
  _anchor_360:any;
  /*private*/ _vc_360:import19.ViewContainer;
  _TemplateRef_360_5:any;
  _NgIf_360_6:import21.Wrapper_NgIf;
  _text_361:any;
  _anchor_362:any;
  /*private*/ _vc_362:import19.ViewContainer;
  _TemplateRef_362_5:any;
  _NgIf_362_6:import21.Wrapper_NgIf;
  _text_363:any;
  _anchor_364:any;
  /*private*/ _vc_364:import19.ViewContainer;
  _TemplateRef_364_5:any;
  _NgIf_364_6:import21.Wrapper_NgIf;
  _text_365:any;
  _anchor_366:any;
  /*private*/ _vc_366:import19.ViewContainer;
  _TemplateRef_366_5:any;
  _NgIf_366_6:import21.Wrapper_NgIf;
  _text_367:any;
  _el_368:any;
  _text_369:any;
  _el_370:any;
  _text_371:any;
  _text_372:any;
  _el_373:any;
  _text_374:any;
  _el_375:any;
  _text_376:any;
  _text_377:any;
  _text_378:any;
  _anchor_379:any;
  /*private*/ _vc_379:import19.ViewContainer;
  _TemplateRef_379_5:any;
  _NgIf_379_6:import21.Wrapper_NgIf;
  _text_380:any;
  _anchor_381:any;
  /*private*/ _vc_381:import19.ViewContainer;
  _TemplateRef_381_5:any;
  _NgIf_381_6:import21.Wrapper_NgIf;
  _text_382:any;
  _anchor_383:any;
  /*private*/ _vc_383:import19.ViewContainer;
  _TemplateRef_383_5:any;
  _NgIf_383_6:import21.Wrapper_NgIf;
  _text_384:any;
  _el_385:any;
  _text_386:any;
  _el_387:any;
  _text_388:any;
  _text_389:any;
  _el_390:any;
  _text_391:any;
  _el_392:any;
  _text_393:any;
  _text_394:any;
  _text_395:any;
  _text_396:any;
  _text_397:any;
  _text_398:any;
  _text_399:any;
  _text_400:any;
  _anchor_401:any;
  /*private*/ _vc_401:import19.ViewContainer;
  _TemplateRef_401_5:any;
  _NgIf_401_6:import21.Wrapper_NgIf;
  _text_402:any;
  _text_403:any;
  _text_404:any;
  _text_405:any;
  _el_406:any;
  _text_407:any;
  _el_408:any;
  _text_409:any;
  _el_410:any;
  _text_411:any;
  _el_412:any;
  _text_413:any;
  _text_414:any;
  _el_415:any;
  _text_416:any;
  _el_417:any;
  _text_418:any;
  _el_419:any;
  _el_420:any;
  _text_421:any;
  _el_422:any;
  _text_423:any;
  _text_424:any;
  _text_425:any;
  _text_426:any;
  _el_427:any;
  _text_428:any;
  _el_429:any;
  _text_430:any;
  _el_431:any;
  _el_432:any;
  _text_433:any;
  _el_434:any;
  _text_435:any;
  _text_436:any;
  _text_437:any;
  _text_438:any;
  _el_439:any;
  _text_440:any;
  _el_441:any;
  _text_442:any;
  _el_443:any;
  _el_444:any;
  _text_445:any;
  _el_446:any;
  _text_447:any;
  _text_448:any;
  _text_449:any;
  _text_450:any;
  _text_451:any;
  _el_452:any;
  _text_453:any;
  _el_454:any;
  _text_455:any;
  _el_456:any;
  _el_457:any;
  _text_458:any;
  _text_459:any;
  _anchor_460:any;
  /*private*/ _vc_460:import19.ViewContainer;
  _TemplateRef_460_5:any;
  _NgIf_460_6:import21.Wrapper_NgIf;
  _text_461:any;
  _anchor_462:any;
  /*private*/ _vc_462:import19.ViewContainer;
  _TemplateRef_462_5:any;
  _NgIf_462_6:import21.Wrapper_NgIf;
  _text_463:any;
  _anchor_464:any;
  /*private*/ _vc_464:import19.ViewContainer;
  _TemplateRef_464_5:any;
  _NgIf_464_6:import21.Wrapper_NgIf;
  _text_465:any;
  _anchor_466:any;
  /*private*/ _vc_466:import19.ViewContainer;
  _TemplateRef_466_5:any;
  _NgIf_466_6:import21.Wrapper_NgIf;
  _text_467:any;
  _anchor_468:any;
  /*private*/ _vc_468:import19.ViewContainer;
  _TemplateRef_468_5:any;
  _NgIf_468_6:import21.Wrapper_NgIf;
  _text_469:any;
  _anchor_470:any;
  /*private*/ _vc_470:import19.ViewContainer;
  _TemplateRef_470_5:any;
  _NgIf_470_6:import21.Wrapper_NgIf;
  _text_471:any;
  _el_472:any;
  _el_473:any;
  _text_474:any;
  _text_475:any;
  _text_476:any;
  _el_477:any;
  _text_478:any;
  _anchor_479:any;
  /*private*/ _vc_479:import19.ViewContainer;
  _TemplateRef_479_5:any;
  _NgFor_479_6:import29.Wrapper_NgFor;
  _text_480:any;
  _text_481:any;
  _text_482:any;
  _text_483:any;
  _text_484:any;
  _text_485:any;
  _text_486:any;
  _text_487:any;
  _text_488:any;
  _anchor_489:any;
  /*private*/ _vc_489:import19.ViewContainer;
  _TemplateRef_489_5:any;
  _NgIf_489_6:import21.Wrapper_NgIf;
  _text_490:any;
  _text_491:any;
  _text_492:any;
  _anchor_493:any;
  /*private*/ _vc_493:import19.ViewContainer;
  _TemplateRef_493_5:any;
  _NgIf_493_6:import21.Wrapper_NgIf;
  _text_494:any;
  _text_495:any;
  _text_496:any;
  _el_497:any;
  _text_498:any;
  _el_499:any;
  _text_500:any;
  _el_501:any;
  _text_502:any;
  _el_503:any;
  _text_504:any;
  _el_505:any;
  _text_506:any;
  _anchor_507:any;
  /*private*/ _vc_507:import19.ViewContainer;
  _TemplateRef_507_5:any;
  _NgFor_507_6:import29.Wrapper_NgFor;
  _text_508:any;
  _el_509:any;
  _text_510:any;
  _el_511:any;
  _text_512:any;
  _el_513:any;
  _text_514:any;
  _text_515:any;
  _el_516:any;
  _text_517:any;
  _text_518:any;
  _text_519:any;
  _text_520:any;
  _text_521:any;
  _text_522:any;
  _text_523:any;
  _text_524:any;
  _text_525:any;
  _text_526:any;
  _text_527:any;
  _el_528:any;
  _text_529:any;
  _el_530:any;
  _text_531:any;
  _el_532:any;
  _text_533:any;
  _el_534:any;
  _text_535:any;
  _el_536:any;
  _text_537:any;
  _text_538:any;
  _text_539:any;
  _text_540:any;
  _el_541:any;
  _text_542:any;
  _el_543:any;
  _text_544:any;
  _el_545:any;
  _text_546:any;
  _el_547:any;
  _text_548:any;
  _el_549:any;
  _text_550:any;
  _text_551:any;
  _el_552:any;
  _text_553:any;
  _text_554:any;
  _text_555:any;
  _el_556:any;
  _text_557:any;
  _el_558:any;
  _text_559:any;
  _text_560:any;
  _el_561:any;
  _text_562:any;
  _text_563:any;
  _text_564:any;
  _text_565:any;
  _text_566:any;
  _text_567:any;
  _text_568:any;
  _el_569:any;
  _text_570:any;
  _el_571:any;
  _text_572:any;
  _el_573:any;
  _text_574:any;
  _el_575:any;
  _text_576:any;
  _text_577:any;
  _text_578:any;
  _text_579:any;
  _el_580:any;
  _text_581:any;
  _el_582:any;
  _text_583:any;
  _el_584:any;
  _text_585:any;
  _el_586:any;
  _text_587:any;
  _el_588:any;
  _text_589:any;
  _text_590:any;
  _el_591:any;
  _text_592:any;
  _text_593:any;
  _text_594:any;
  _anchor_595:any;
  /*private*/ _vc_595:import19.ViewContainer;
  _TemplateRef_595_5:any;
  _NgIf_595_6:import21.Wrapper_NgIf;
  _text_596:any;
  _anchor_597:any;
  /*private*/ _vc_597:import19.ViewContainer;
  _TemplateRef_597_5:any;
  _NgIf_597_6:import21.Wrapper_NgIf;
  _text_598:any;
  _text_599:any;
  _text_600:any;
  _text_601:any;
  _el_602:any;
  _text_603:any;
  _el_604:any;
  _text_605:any;
  _el_606:any;
  _text_607:any;
  _text_608:any;
  _text_609:any;
  _text_610:any;
  _el_611:any;
  _text_612:any;
  _el_613:any;
  _text_614:any;
  _el_615:any;
  _text_616:any;
  _el_617:any;
  _text_618:any;
  _el_619:any;
  _text_620:any;
  _text_621:any;
  _el_622:any;
  _text_623:any;
  _text_624:any;
  _text_625:any;
  _el_626:any;
  _text_627:any;
  _el_628:any;
  _text_629:any;
  _text_630:any;
  _el_631:any;
  _text_632:any;
  _text_633:any;
  _text_634:any;
  _text_635:any;
  _text_636:any;
  _text_637:any;
  _text_638:any;
  _el_639:any;
  _text_640:any;
  _el_641:any;
  _text_642:any;
  _el_643:any;
  _text_644:any;
  _el_645:any;
  _text_646:any;
  _text_647:any;
  _text_648:any;
  _text_649:any;
  _el_650:any;
  _text_651:any;
  _el_652:any;
  _text_653:any;
  _el_654:any;
  _text_655:any;
  _el_656:any;
  _text_657:any;
  _text_658:any;
  _el_659:any;
  _text_660:any;
  _el_661:any;
  _text_662:any;
  _text_663:any;
  _text_664:any;
  _text_665:any;
  _text_666:any;
  _text_667:any;
  _anchor_668:any;
  /*private*/ _vc_668:import19.ViewContainer;
  _TemplateRef_668_5:any;
  _NgIf_668_6:import21.Wrapper_NgIf;
  _text_669:any;
  _anchor_670:any;
  /*private*/ _vc_670:import19.ViewContainer;
  _TemplateRef_670_5:any;
  _NgIf_670_6:import21.Wrapper_NgIf;
  _text_671:any;
  _text_672:any;
  _text_673:any;
  _text_674:any;
  _text_675:any;
  _el_676:any;
  _text_677:any;
  _el_678:any;
  _text_679:any;
  _el_680:any;
  _text_681:any;
  _text_682:any;
  _text_683:any;
  _text_684:any;
  /*private*/ _expr_795:any;
  /*private*/ _expr_796:any;
  _pipe_translate_0:import18.TranslatePipe;
  _pipe_translate_1:import18.TranslatePipe;
  /*private*/ _expr_799:any;
  _pipe_translate_2:import18.TranslatePipe;
  /*private*/ _expr_801:any;
  _pipe_translate_3:import18.TranslatePipe;
  /*private*/ _expr_803:any;
  /*private*/ _expr_804:any;
  _pipe_translate_4:import18.TranslatePipe;
  /*private*/ _expr_806:any;
  /*private*/ _expr_807:any;
  _pipe_translate_5:import18.TranslatePipe;
  /*private*/ _expr_809:any;
  /*private*/ _expr_810:any;
  _pipe_translate_6:import18.TranslatePipe;
  /*private*/ _expr_812:any;
  /*private*/ _expr_813:any;
  _pipe_translate_7:import18.TranslatePipe;
  /*private*/ _expr_815:any;
  /*private*/ _expr_816:any;
  _pipe_translate_8:import18.TranslatePipe;
  /*private*/ _expr_818:any;
  _pipe_translate_9:import18.TranslatePipe;
  /*private*/ _expr_820:any;
  _pipe_translate_10:import18.TranslatePipe;
  /*private*/ _expr_822:any;
  _pipe_translate_11:import18.TranslatePipe;
  /*private*/ _expr_824:any;
  _pipe_translate_12:import18.TranslatePipe;
  _pipe_translate_13:import18.TranslatePipe;
  /*private*/ _expr_827:any;
  _pipe_translate_14:import18.TranslatePipe;
  /*private*/ _expr_829:any;
  /*private*/ _expr_830:any;
  _pipe_translate_15:import18.TranslatePipe;
  /*private*/ _expr_832:any;
  /*private*/ _expr_833:any;
  _pipe_translate_16:import18.TranslatePipe;
  /*private*/ _expr_835:any;
  _pipe_translate_17:import18.TranslatePipe;
  /*private*/ _expr_837:any;
  _pipe_translate_18:import18.TranslatePipe;
  /*private*/ _expr_839:any;
  _pipe_translate_19:import18.TranslatePipe;
  /*private*/ _expr_841:any;
  /*private*/ _expr_842:any;
  _pipe_translate_20:import18.TranslatePipe;
  /*private*/ _expr_844:any;
  /*private*/ _expr_845:any;
  _pipe_translate_21:import18.TranslatePipe;
  /*private*/ _expr_847:any;
  _pipe_translate_22:import18.TranslatePipe;
  /*private*/ _expr_849:any;
  /*private*/ _expr_850:any;
  _pipe_translate_23:import18.TranslatePipe;
  /*private*/ _expr_852:any;
  /*private*/ _expr_853:any;
  _pipe_translate_24:import18.TranslatePipe;
  /*private*/ _expr_855:any;
  /*private*/ _expr_856:any;
  /*private*/ _expr_857:any;
  _pipe_translate_25:import18.TranslatePipe;
  /*private*/ _expr_859:any;
  /*private*/ _expr_860:any;
  /*private*/ _expr_861:any;
  _pipe_translate_26:import18.TranslatePipe;
  /*private*/ _expr_863:any;
  /*private*/ _expr_864:any;
  _pipe_translate_27:import18.TranslatePipe;
  /*private*/ _expr_866:any;
  /*private*/ _expr_867:any;
  _pipe_translate_28:import18.TranslatePipe;
  /*private*/ _expr_869:any;
  /*private*/ _expr_870:any;
  /*private*/ _expr_871:any;
  _pipe_translate_29:import18.TranslatePipe;
  /*private*/ _expr_873:any;
  /*private*/ _expr_874:any;
  /*private*/ _expr_875:any;
  /*private*/ _expr_876:any;
  _pipe_translate_30:import18.TranslatePipe;
  /*private*/ _expr_878:any;
  /*private*/ _expr_879:any;
  /*private*/ _expr_880:any;
  _pipe_translate_31:import18.TranslatePipe;
  /*private*/ _expr_882:any;
  /*private*/ _expr_883:any;
  _pipe_translate_32:import18.TranslatePipe;
  /*private*/ _expr_885:any;
  /*private*/ _expr_886:any;
  _pipe_translate_33:import18.TranslatePipe;
  /*private*/ _expr_888:any;
  /*private*/ _expr_889:any;
  _pipe_translate_34:import18.TranslatePipe;
  /*private*/ _expr_891:any;
  _pipe_translate_35:import18.TranslatePipe;
  /*private*/ _expr_893:any;
  _pipe_translate_36:import18.TranslatePipe;
  _pipe_translate_37:import18.TranslatePipe;
  /*private*/ _expr_896:any;
  _pipe_translate_38:import18.TranslatePipe;
  /*private*/ _expr_898:any;
  _pipe_translate_39:import18.TranslatePipe;
  /*private*/ _expr_900:any;
  /*private*/ _expr_901:any;
  _pipe_translate_40:import18.TranslatePipe;
  /*private*/ _expr_903:any;
  _pipe_translate_41:import18.TranslatePipe;
  /*private*/ _expr_905:any;
  /*private*/ _expr_906:any;
  _pipe_translate_42:import18.TranslatePipe;
  /*private*/ _expr_908:any;
  _pipe_translate_43:import18.TranslatePipe;
  /*private*/ _expr_910:any;
  _pipe_translate_44:import18.TranslatePipe;
  /*private*/ _expr_912:any;
  _pipe_translate_45:import18.TranslatePipe;
  /*private*/ _expr_914:any;
  _pipe_translate_46:import18.TranslatePipe;
  /*private*/ _expr_916:any;
  _pipe_translate_47:import18.TranslatePipe;
  /*private*/ _expr_918:any;
  _pipe_translate_48:import18.TranslatePipe;
  /*private*/ _expr_920:any;
  /*private*/ _expr_921:any;
  _pipe_translate_49:import18.TranslatePipe;
  /*private*/ _expr_923:any;
  /*private*/ _expr_924:any;
  /*private*/ _expr_925:any;
  _pipe_translate_50:import18.TranslatePipe;
  /*private*/ _expr_927:any;
  _pipe_translate_51:import18.TranslatePipe;
  _pipe_translate_52:import18.TranslatePipe;
  /*private*/ _expr_930:any;
  _pipe_translate_53:import18.TranslatePipe;
  /*private*/ _expr_932:any;
  _pipe_translate_54:import18.TranslatePipe;
  _map_934:any;
  _pipe_translate_55:import18.TranslatePipe;
  /*private*/ _expr_936:any;
  _pipe_translate_56:import18.TranslatePipe;
  /*private*/ _expr_938:any;
  _pipe_translate_57:import18.TranslatePipe;
  /*private*/ _expr_940:any;
  _pipe_translate_58:import18.TranslatePipe;
  /*private*/ _expr_942:any;
  _pipe_translate_59:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_BookingDetailComponent2,renderType_BookingDetailComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_795 = import20.UNINITIALIZED;
    this._expr_796 = import20.UNINITIALIZED;
    this._expr_799 = import20.UNINITIALIZED;
    this._expr_801 = import20.UNINITIALIZED;
    this._expr_803 = import20.UNINITIALIZED;
    this._expr_804 = import20.UNINITIALIZED;
    this._expr_806 = import20.UNINITIALIZED;
    this._expr_807 = import20.UNINITIALIZED;
    this._expr_809 = import20.UNINITIALIZED;
    this._expr_810 = import20.UNINITIALIZED;
    this._expr_812 = import20.UNINITIALIZED;
    this._expr_813 = import20.UNINITIALIZED;
    this._expr_815 = import20.UNINITIALIZED;
    this._expr_816 = import20.UNINITIALIZED;
    this._expr_818 = import20.UNINITIALIZED;
    this._expr_820 = import20.UNINITIALIZED;
    this._expr_822 = import20.UNINITIALIZED;
    this._expr_824 = import20.UNINITIALIZED;
    this._expr_827 = import20.UNINITIALIZED;
    this._expr_829 = import20.UNINITIALIZED;
    this._expr_830 = import20.UNINITIALIZED;
    this._expr_832 = import20.UNINITIALIZED;
    this._expr_833 = import20.UNINITIALIZED;
    this._expr_835 = import20.UNINITIALIZED;
    this._expr_837 = import20.UNINITIALIZED;
    this._expr_839 = import20.UNINITIALIZED;
    this._expr_841 = import20.UNINITIALIZED;
    this._expr_842 = import20.UNINITIALIZED;
    this._expr_844 = import20.UNINITIALIZED;
    this._expr_845 = import20.UNINITIALIZED;
    this._expr_847 = import20.UNINITIALIZED;
    this._expr_849 = import20.UNINITIALIZED;
    this._expr_850 = import20.UNINITIALIZED;
    this._expr_852 = import20.UNINITIALIZED;
    this._expr_853 = import20.UNINITIALIZED;
    this._expr_855 = import20.UNINITIALIZED;
    this._expr_856 = import20.UNINITIALIZED;
    this._expr_857 = import20.UNINITIALIZED;
    this._expr_859 = import20.UNINITIALIZED;
    this._expr_860 = import20.UNINITIALIZED;
    this._expr_861 = import20.UNINITIALIZED;
    this._expr_863 = import20.UNINITIALIZED;
    this._expr_864 = import20.UNINITIALIZED;
    this._expr_866 = import20.UNINITIALIZED;
    this._expr_867 = import20.UNINITIALIZED;
    this._expr_869 = import20.UNINITIALIZED;
    this._expr_870 = import20.UNINITIALIZED;
    this._expr_871 = import20.UNINITIALIZED;
    this._expr_873 = import20.UNINITIALIZED;
    this._expr_874 = import20.UNINITIALIZED;
    this._expr_875 = import20.UNINITIALIZED;
    this._expr_876 = import20.UNINITIALIZED;
    this._expr_878 = import20.UNINITIALIZED;
    this._expr_879 = import20.UNINITIALIZED;
    this._expr_880 = import20.UNINITIALIZED;
    this._expr_882 = import20.UNINITIALIZED;
    this._expr_883 = import20.UNINITIALIZED;
    this._expr_885 = import20.UNINITIALIZED;
    this._expr_886 = import20.UNINITIALIZED;
    this._expr_888 = import20.UNINITIALIZED;
    this._expr_889 = import20.UNINITIALIZED;
    this._expr_891 = import20.UNINITIALIZED;
    this._expr_893 = import20.UNINITIALIZED;
    this._expr_896 = import20.UNINITIALIZED;
    this._expr_898 = import20.UNINITIALIZED;
    this._expr_900 = import20.UNINITIALIZED;
    this._expr_901 = import20.UNINITIALIZED;
    this._expr_903 = import20.UNINITIALIZED;
    this._expr_905 = import20.UNINITIALIZED;
    this._expr_906 = import20.UNINITIALIZED;
    this._expr_908 = import20.UNINITIALIZED;
    this._expr_910 = import20.UNINITIALIZED;
    this._expr_912 = import20.UNINITIALIZED;
    this._expr_914 = import20.UNINITIALIZED;
    this._expr_916 = import20.UNINITIALIZED;
    this._expr_918 = import20.UNINITIALIZED;
    this._expr_920 = import20.UNINITIALIZED;
    this._expr_921 = import20.UNINITIALIZED;
    this._expr_923 = import20.UNINITIALIZED;
    this._expr_924 = import20.UNINITIALIZED;
    this._expr_925 = import20.UNINITIALIZED;
    this._expr_927 = import20.UNINITIALIZED;
    this._expr_930 = import20.UNINITIALIZED;
    this._expr_932 = import20.UNINITIALIZED;
    this._map_934 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {activeTo: p0};
    });
    this._expr_936 = import20.UNINITIALIZED;
    this._expr_938 = import20.UNINITIALIZED;
    this._expr_940 = import20.UNINITIALIZED;
    this._expr_942 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'id','content-1'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mb-lg'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n\n                        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -lg-9 -md-12 -sm-12'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','panel-info-border'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                                ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                                    ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                                        ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_12,'div',new import3.InlineArray2(2,'class','eva-3-panel-info top-border -eva-3-bc-white -eva-3-pt-xsm -eva-3-pb-xsm -eva-3-pl-md'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n                                            ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_14,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'',(null as any));
    this._text_18 = this.renderer.createText(this._el_14,'\n                                        ',(null as any));
    this._text_19 = this.renderer.createText(this._el_12,'\n                                    ',(null as any));
    this._text_20 = this.renderer.createText(this._el_10,'\n                                ',(null as any));
    this._text_21 = this.renderer.createText(this._el_8,'\n                            ',(null as any));
    this._text_22 = this.renderer.createText(this._el_6,'\n\n                            ',(null as any));
    this._text_23 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-panel-info bottom-border -eva-3-bc-white detail-no-pt'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'\n                                ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_24,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n                                ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_26,'div',new import3.InlineArray2(2,'class','footer-detail'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'\n                                    ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_28,'div',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'\n                                        ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_30,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-lg'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'\n                                            ',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_32,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'\n                                                ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_34,'div',new import3.InlineArray2(2,'class','detail-icon-info'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'\n                                                    ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_36,'i',new import3.InlineArray2(2,'class','eva-3-icon-user -eva-3-icon-sm -eva-3-tc-blue-1'),(null as any));
    this._text_39 = this.renderer.createText(this._el_36,'\n                                                ',(null as any));
    this._text_40 = this.renderer.createText(this._el_34,'\n                                                ',(null as any));
    this._el_41 = import3.createRenderElement(this.renderer,this._el_34,'div',new import3.InlineArray2(2,'class','detail-name-info'),(null as any));
    this._text_42 = this.renderer.createText(this._el_41,'\n                                                    ',(null as any));
    this._el_43 = import3.createRenderElement(this.renderer,this._el_41,'h5',new import3.InlineArray2(2,'class','eva-3-h5 -eva-3-tc-blue-1'),(null as any));
    this._text_44 = this.renderer.createText(this._el_43,'',(null as any));
    this._text_45 = this.renderer.createText(this._el_41,'\n                                                ',(null as any));
    this._text_46 = this.renderer.createText(this._el_34,'\n                                            ',(null as any));
    this._text_47 = this.renderer.createText(this._el_32,'\n                                        ',(null as any));
    this._text_48 = this.renderer.createText(this._el_30,'\n                                        ',(null as any));
    this._el_49 = import3.createRenderElement(this.renderer,this._el_30,'div',new import3.InlineArray2(2,'class','eva-3-row detail-left-padding'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'\n                                            ',(null as any));
    this._el_51 = import3.createRenderElement(this.renderer,this._el_49,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_52 = this.renderer.createText(this._el_51,'\n                                                ',(null as any));
    this._el_53 = import3.createRenderElement(this.renderer,this._el_51,'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_54 = this.renderer.createText(this._el_53,'\n                                                    ',(null as any));
    this._el_55 = import3.createRenderElement(this.renderer,this._el_53,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_56 = this.renderer.createText(this._el_55,'',(null as any));
    this._text_57 = this.renderer.createText(this._el_53,'\n                                                    ',(null as any));
    this._el_58 = import3.createRenderElement(this.renderer,this._el_53,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_59 = this.renderer.createText(this._el_58,'',(null as any));
    this._text_60 = this.renderer.createText(this._el_53,'\n                                                ',(null as any));
    this._text_61 = this.renderer.createText(this._el_51,'\n                                                ',(null as any));
    this._el_62 = import3.createRenderElement(this.renderer,this._el_51,'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_63 = this.renderer.createText(this._el_62,'\n                                                    ',(null as any));
    this._el_64 = import3.createRenderElement(this.renderer,this._el_62,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_65 = this.renderer.createText(this._el_64,'',(null as any));
    this._text_66 = this.renderer.createText(this._el_62,'\n                                                    ',(null as any));
    this._el_67 = import3.createRenderElement(this.renderer,this._el_62,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_68 = this.renderer.createText(this._el_67,'',(null as any));
    this._text_69 = this.renderer.createText(this._el_62,'\n                                                ',(null as any));
    this._text_70 = this.renderer.createText(this._el_51,'\n                                                ',(null as any));
    this._el_71 = import3.createRenderElement(this.renderer,this._el_51,'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_72 = this.renderer.createText(this._el_71,'\n                                                    ',(null as any));
    this._el_73 = import3.createRenderElement(this.renderer,this._el_71,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_74 = this.renderer.createText(this._el_73,'',(null as any));
    this._text_75 = this.renderer.createText(this._el_71,'\n                                                    ',(null as any));
    this._el_76 = import3.createRenderElement(this.renderer,this._el_71,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_77 = this.renderer.createText(this._el_76,'',(null as any));
    this._text_78 = this.renderer.createText(this._el_71,'\n                                                ',(null as any));
    this._text_79 = this.renderer.createText(this._el_51,'\n                                                ',(null as any));
    this._el_80 = import3.createRenderElement(this.renderer,this._el_51,'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_81 = this.renderer.createText(this._el_80,'\n                                                    ',(null as any));
    this._el_82 = import3.createRenderElement(this.renderer,this._el_80,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_83 = this.renderer.createText(this._el_82,'',(null as any));
    this._text_84 = this.renderer.createText(this._el_80,'\n                                                    ',(null as any));
    this._el_85 = import3.createRenderElement(this.renderer,this._el_80,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_86 = this.renderer.createText(this._el_85,'',(null as any));
    this._text_87 = this.renderer.createText(this._el_80,'\n                                                ',(null as any));
    this._text_88 = this.renderer.createText(this._el_51,'\n                                                ',(null as any));
    this._el_89 = import3.createRenderElement(this.renderer,this._el_51,'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_90 = this.renderer.createText(this._el_89,'\n                                                    ',(null as any));
    this._el_91 = import3.createRenderElement(this.renderer,this._el_89,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_92 = this.renderer.createText(this._el_91,'',(null as any));
    this._text_93 = this.renderer.createText(this._el_89,'\n                                                    ',(null as any));
    this._el_94 = import3.createRenderElement(this.renderer,this._el_89,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_95 = this.renderer.createText(this._el_94,'',(null as any));
    this._text_96 = this.renderer.createText(this._el_89,'\n                                                ',(null as any));
    this._text_97 = this.renderer.createText(this._el_51,'\n                                            ',(null as any));
    this._text_98 = this.renderer.createText(this._el_49,'\n                                        ',(null as any));
    this._text_99 = this.renderer.createText(this._el_30,'\n                                    ',(null as any));
    this._text_100 = this.renderer.createText(this._el_28,'\n                                    ',(null as any));
    this._anchor_101 = this.renderer.createTemplateAnchor(this._el_28,(null as any));
    this._vc_101 = new import19.ViewContainer(101,28,this,this._anchor_101);
    this._TemplateRef_101_5 = new import22.TemplateRef_(this,101,this._anchor_101);
    this._NgIf_101_6 = new import21.Wrapper_NgIf(this._vc_101.vcRef,this._TemplateRef_101_5);
    this._text_102 = this.renderer.createText(this._el_28,'\n                                    ',(null as any));
    this._text_103 = this.renderer.createText(this._el_28,'\n                                    ',(null as any));
    this._el_104 = import3.createRenderElement(this.renderer,this._el_28,'div',new import3.InlineArray2(2,'class','footer-detail panel-info-border'),(null as any));
    this._text_105 = this.renderer.createText(this._el_104,'\n                                        ',(null as any));
    this._el_106 = import3.createRenderElement(this.renderer,this._el_104,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_107 = this.renderer.createText(this._el_106,'\n                                            ',(null as any));
    this._el_108 = import3.createRenderElement(this.renderer,this._el_106,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_109 = this.renderer.createText(this._el_108,'\n                                                    ',(null as any));
    this._el_110 = import3.createRenderElement(this.renderer,this._el_108,'email-tooltip',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_110 = new import34.View_EmailTooltipComponent0(this.viewUtils,this,110,this._el_110);
    this._GAService_110_3 = new import32.GAService();
    this._MobileService_110_4 = new import33.MobileService();
    this._BookingService_110_5 = new import5.BookingService(this.parentView.parentView.injectorGet(import9.Http,this.parentView.parentIndex));
    this._EmailTooltipComponent_110_6 = new import34.Wrapper_EmailTooltipComponent(this._GAService_110_3,this._MobileService_110_4,this._BookingService_110_5,this.parentView.parentView.injectorGet(import15.NotificationService,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import13.SessionService,this.parentView.parentIndex));
    this.compView_110.create(this._EmailTooltipComponent_110_6.context);
    this._text_111 = this.renderer.createText(this._el_108,'\n                                            ',(null as any));
    this._text_112 = this.renderer.createText(this._el_106,'\n                                        ',(null as any));
    this._text_113 = this.renderer.createText(this._el_104,'\n                                    ',(null as any));
    this._text_114 = this.renderer.createText(this._el_28,'\n                                    ',(null as any));
    this._text_115 = this.renderer.createText(this._el_28,'\n                                ',(null as any));
    this._text_116 = this.renderer.createText(this._el_26,'\n                            ',(null as any));
    this._text_117 = this.renderer.createText(this._el_24,'\n                            ',(null as any));
    this._text_118 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._text_119 = this.renderer.createText(this._el_6,'\n\n                            ',(null as any));
    this._text_120 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._el_121 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-panel-info full-panel -eva-3-bc-white -eva-3-mt-md detail-no-pt'),(null as any));
    this._text_122 = this.renderer.createText(this._el_121,'\n                                ',(null as any));
    this._el_123 = import3.createRenderElement(this.renderer,this._el_121,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_124 = this.renderer.createText(this._el_123,'\n                                    ',(null as any));
    this._el_125 = import3.createRenderElement(this.renderer,this._el_123,'div',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-12'),(null as any));
    this._text_126 = this.renderer.createText(this._el_125,'\n                                        ',(null as any));
    this._el_127 = import3.createRenderElement(this.renderer,this._el_125,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-lg'),(null as any));
    this._text_128 = this.renderer.createText(this._el_127,'\n                                            ',(null as any));
    this._el_129 = import3.createRenderElement(this.renderer,this._el_127,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_130 = this.renderer.createText(this._el_129,'\n                                                ',(null as any));
    this._el_131 = import3.createRenderElement(this.renderer,this._el_129,'div',new import3.InlineArray2(2,'class','detail-icon-info'),(null as any));
    this._text_132 = this.renderer.createText(this._el_131,'\n                                                    ',(null as any));
    this._el_133 = import3.createRenderElement(this.renderer,this._el_131,'i',new import3.InlineArray2(2,'class','eva-3-icon-check-in -eva-3-icon-sm -eva-3-tc-blue-1'),(null as any));
    this._text_134 = this.renderer.createText(this._el_131,'\n                                                ',(null as any));
    this._text_135 = this.renderer.createText(this._el_129,'\n                                                ',(null as any));
    this._el_136 = import3.createRenderElement(this.renderer,this._el_129,'div',new import3.InlineArray2(2,'class','detail-name-info'),(null as any));
    this._text_137 = this.renderer.createText(this._el_136,'\n                                                    ',(null as any));
    this._el_138 = import3.createRenderElement(this.renderer,this._el_136,'h5',new import3.InlineArray2(2,'class','eva-3-h5 -eva-3-tc-blue-1'),(null as any));
    this._text_139 = this.renderer.createText(this._el_138,'',(null as any));
    this._text_140 = this.renderer.createText(this._el_136,'\n                                                ',(null as any));
    this._text_141 = this.renderer.createText(this._el_129,'\n                                            ',(null as any));
    this._text_142 = this.renderer.createText(this._el_127,'\n                                        ',(null as any));
    this._text_143 = this.renderer.createText(this._el_125,'\n                                        ',(null as any));
    this._el_144 = import3.createRenderElement(this.renderer,this._el_125,'div',new import3.InlineArray2(2,'class','eva-3-row detail-left-padding'),(null as any));
    this._text_145 = this.renderer.createText(this._el_144,'\n                                            ',(null as any));
    this._el_146 = import3.createRenderElement(this.renderer,this._el_144,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_147 = this.renderer.createText(this._el_146,'\n                                                ',(null as any));
    this._el_148 = import3.createRenderElement(this.renderer,this._el_146,'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_149 = this.renderer.createText(this._el_148,'\n                                                    ',(null as any));
    this._el_150 = import3.createRenderElement(this.renderer,this._el_148,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_151 = this.renderer.createText(this._el_150,'',(null as any));
    this._text_152 = this.renderer.createText(this._el_148,'\n                                                    ',(null as any));
    this._el_153 = import3.createRenderElement(this.renderer,this._el_148,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_154 = this.renderer.createText(this._el_153,'',(null as any));
    this._text_155 = this.renderer.createText(this._el_148,'\n                                                ',(null as any));
    this._text_156 = this.renderer.createText(this._el_146,'\n                                                ',(null as any));
    this._el_157 = import3.createRenderElement(this.renderer,this._el_146,'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_158 = this.renderer.createText(this._el_157,'\n                                                    ',(null as any));
    this._el_159 = import3.createRenderElement(this.renderer,this._el_157,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_160 = this.renderer.createText(this._el_159,'',(null as any));
    this._text_161 = this.renderer.createText(this._el_157,'\n                                                    ',(null as any));
    this._el_162 = import3.createRenderElement(this.renderer,this._el_157,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_163 = this.renderer.createText(this._el_162,'',(null as any));
    this._text_164 = this.renderer.createText(this._el_157,'\n                                                ',(null as any));
    this._text_165 = this.renderer.createText(this._el_146,'\n                                                ',(null as any));
    this._el_166 = import3.createRenderElement(this.renderer,this._el_146,'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_167 = this.renderer.createText(this._el_166,'\n                                                    ',(null as any));
    this._el_168 = import3.createRenderElement(this.renderer,this._el_166,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_169 = this.renderer.createText(this._el_168,'',(null as any));
    this._text_170 = this.renderer.createText(this._el_166,'\n                                                    ',(null as any));
    this._el_171 = import3.createRenderElement(this.renderer,this._el_166,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_172 = this.renderer.createText(this._el_171,'',(null as any));
    this._text_173 = this.renderer.createText(this._el_166,'\n                                                ',(null as any));
    this._text_174 = this.renderer.createText(this._el_146,'\n                                                ',(null as any));
    this._el_175 = import3.createRenderElement(this.renderer,this._el_146,'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_176 = this.renderer.createText(this._el_175,'\n                                                    ',(null as any));
    this._el_177 = import3.createRenderElement(this.renderer,this._el_175,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_178 = this.renderer.createText(this._el_177,'',(null as any));
    this._text_179 = this.renderer.createText(this._el_175,'\n                                                    ',(null as any));
    this._el_180 = import3.createRenderElement(this.renderer,this._el_175,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_181 = this.renderer.createText(this._el_180,'',(null as any));
    this._text_182 = this.renderer.createText(this._el_175,'\n                                                ',(null as any));
    this._text_183 = this.renderer.createText(this._el_146,'\n                                                ',(null as any));
    this._anchor_184 = this.renderer.createTemplateAnchor(this._el_146,(null as any));
    this._vc_184 = new import19.ViewContainer(184,146,this,this._anchor_184);
    this._TemplateRef_184_5 = new import22.TemplateRef_(this,184,this._anchor_184);
    this._NgIf_184_6 = new import21.Wrapper_NgIf(this._vc_184.vcRef,this._TemplateRef_184_5);
    this._text_185 = this.renderer.createText(this._el_146,'~\n                                                ',(null as any));
    this._anchor_186 = this.renderer.createTemplateAnchor(this._el_146,(null as any));
    this._vc_186 = new import19.ViewContainer(186,146,this,this._anchor_186);
    this._TemplateRef_186_5 = new import22.TemplateRef_(this,186,this._anchor_186);
    this._NgIf_186_6 = new import21.Wrapper_NgIf(this._vc_186.vcRef,this._TemplateRef_186_5);
    this._text_187 = this.renderer.createText(this._el_146,'\n                                                ',(null as any));
    this._anchor_188 = this.renderer.createTemplateAnchor(this._el_146,(null as any));
    this._vc_188 = new import19.ViewContainer(188,146,this,this._anchor_188);
    this._TemplateRef_188_5 = new import22.TemplateRef_(this,188,this._anchor_188);
    this._NgIf_188_6 = new import21.Wrapper_NgIf(this._vc_188.vcRef,this._TemplateRef_188_5);
    this._text_189 = this.renderer.createText(this._el_146,'\n                                            ',(null as any));
    this._text_190 = this.renderer.createText(this._el_144,'\n                                        ',(null as any));
    this._text_191 = this.renderer.createText(this._el_125,'\n                                    ',(null as any));
    this._text_192 = this.renderer.createText(this._el_123,'\n                                    ',(null as any));
    this._el_193 = import3.createRenderElement(this.renderer,this._el_123,'div',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-12'),(null as any));
    this._text_194 = this.renderer.createText(this._el_193,'\n                                        ',(null as any));
    this._el_195 = import3.createRenderElement(this.renderer,this._el_193,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-lg'),(null as any));
    this._text_196 = this.renderer.createText(this._el_195,'\n                                            ',(null as any));
    this._el_197 = import3.createRenderElement(this.renderer,this._el_195,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_198 = this.renderer.createText(this._el_197,'\n                                                ',(null as any));
    this._el_199 = import3.createRenderElement(this.renderer,this._el_197,'div',new import3.InlineArray2(2,'class','detail-icon-info'),(null as any));
    this._text_200 = this.renderer.createText(this._el_199,'\n                                                    ',(null as any));
    this._el_201 = import3.createRenderElement(this.renderer,this._el_199,'i',new import3.InlineArray2(2,'class','eva-3-icon-check-out -eva-3-icon-sm -eva-3-tc-blue-1'),(null as any));
    this._text_202 = this.renderer.createText(this._el_199,'\n                                                ',(null as any));
    this._text_203 = this.renderer.createText(this._el_197,'\n                                                ',(null as any));
    this._el_204 = import3.createRenderElement(this.renderer,this._el_197,'div',new import3.InlineArray2(2,'class','detail-name-info'),(null as any));
    this._text_205 = this.renderer.createText(this._el_204,'\n                                                    ',(null as any));
    this._el_206 = import3.createRenderElement(this.renderer,this._el_204,'h5',new import3.InlineArray2(2,'class','eva-3-h5 -eva-3-tc-blue-1'),(null as any));
    this._text_207 = this.renderer.createText(this._el_206,'',(null as any));
    this._text_208 = this.renderer.createText(this._el_204,'\n                                                ',(null as any));
    this._text_209 = this.renderer.createText(this._el_197,'\n                                            ',(null as any));
    this._text_210 = this.renderer.createText(this._el_195,'\n                                        ',(null as any));
    this._text_211 = this.renderer.createText(this._el_193,'\n                                        ',(null as any));
    this._el_212 = import3.createRenderElement(this.renderer,this._el_193,'div',new import3.InlineArray2(2,'class','eva-3-row detail-left-padding'),(null as any));
    this._text_213 = this.renderer.createText(this._el_212,'\n                                            ',(null as any));
    this._el_214 = import3.createRenderElement(this.renderer,this._el_212,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_215 = this.renderer.createText(this._el_214,'\n                                                ',(null as any));
    this._el_216 = import3.createRenderElement(this.renderer,this._el_214,'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_217 = this.renderer.createText(this._el_216,'\n                                                    ',(null as any));
    this._el_218 = import3.createRenderElement(this.renderer,this._el_216,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_219 = this.renderer.createText(this._el_218,'',(null as any));
    this._text_220 = this.renderer.createText(this._el_216,'\n                                                    ',(null as any));
    this._el_221 = import3.createRenderElement(this.renderer,this._el_216,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_222 = this.renderer.createText(this._el_221,'',(null as any));
    this._text_223 = this.renderer.createText(this._el_216,'\n                                                ',(null as any));
    this._text_224 = this.renderer.createText(this._el_214,'\n                                                ',(null as any));
    this._el_225 = import3.createRenderElement(this.renderer,this._el_214,'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_226 = this.renderer.createText(this._el_225,'\n                                                    ',(null as any));
    this._el_227 = import3.createRenderElement(this.renderer,this._el_225,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_228 = this.renderer.createText(this._el_227,'',(null as any));
    this._text_229 = this.renderer.createText(this._el_225,'\n                                                    ',(null as any));
    this._el_230 = import3.createRenderElement(this.renderer,this._el_225,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_231 = this.renderer.createText(this._el_230,'',(null as any));
    this._text_232 = this.renderer.createText(this._el_225,'\n                                                ',(null as any));
    this._text_233 = this.renderer.createText(this._el_214,'\n                                                ',(null as any));
    this._el_234 = import3.createRenderElement(this.renderer,this._el_214,'div',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_235 = this.renderer.createText(this._el_234,'\n                                                    ',(null as any));
    this._el_236 = import3.createRenderElement(this.renderer,this._el_234,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_237 = this.renderer.createText(this._el_236,'',(null as any));
    this._text_238 = this.renderer.createText(this._el_234,'\n                                                    ',(null as any));
    this._el_239 = import3.createRenderElement(this.renderer,this._el_234,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3 -eva-3-bold'),(null as any));
    this._text_240 = this.renderer.createText(this._el_239,'',(null as any));
    this._text_241 = this.renderer.createText(this._el_234,'\n                                                ',(null as any));
    this._text_242 = this.renderer.createText(this._el_214,'\n                                                ',(null as any));
    this._anchor_243 = this.renderer.createTemplateAnchor(this._el_214,(null as any));
    this._vc_243 = new import19.ViewContainer(243,214,this,this._anchor_243);
    this._TemplateRef_243_5 = new import22.TemplateRef_(this,243,this._anchor_243);
    this._NgIf_243_6 = new import21.Wrapper_NgIf(this._vc_243.vcRef,this._TemplateRef_243_5);
    this._text_244 = this.renderer.createText(this._el_214,'\n                                                ',(null as any));
    this._anchor_245 = this.renderer.createTemplateAnchor(this._el_214,(null as any));
    this._vc_245 = new import19.ViewContainer(245,214,this,this._anchor_245);
    this._TemplateRef_245_5 = new import22.TemplateRef_(this,245,this._anchor_245);
    this._NgIf_245_6 = new import21.Wrapper_NgIf(this._vc_245.vcRef,this._TemplateRef_245_5);
    this._text_246 = this.renderer.createText(this._el_214,'\n                                            ',(null as any));
    this._text_247 = this.renderer.createText(this._el_212,'\n                                        ',(null as any));
    this._text_248 = this.renderer.createText(this._el_193,'\n                                    ',(null as any));
    this._text_249 = this.renderer.createText(this._el_123,'\n                                ',(null as any));
    this._text_250 = this.renderer.createText(this._el_121,'\n                            ',(null as any));
    this._text_251 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._text_252 = this.renderer.createText(this._el_6,'\n\n                            ',(null as any));
    this._text_253 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._anchor_254 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_254 = new import19.ViewContainer(254,6,this,this._anchor_254);
    this._TemplateRef_254_5 = new import22.TemplateRef_(this,254,this._anchor_254);
    this._NgIf_254_6 = new import21.Wrapper_NgIf(this._vc_254.vcRef,this._TemplateRef_254_5);
    this._text_255 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._text_256 = this.renderer.createText(this._el_6,'\n\n                            ',(null as any));
    this._text_257 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._el_258 = import3.createRenderElement(this.renderer,this._el_6,'dsp-dropdown',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_259 = this.renderer.createText(this._el_258,'\n                                ',(null as any));
    this._el_260 = import3.createRenderElement(this.renderer,this._el_258,'div',new import3.InlineArray2(2,'class','panel-info-border'),(null as any));
    this._text_261 = this.renderer.createText(this._el_260,'\n                                    ',(null as any));
    this._el_262 = import3.createRenderElement(this.renderer,this._el_260,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_263 = this.renderer.createText(this._el_262,'\n                                        ',(null as any));
    this._el_264 = import3.createRenderElement(this.renderer,this._el_262,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_265 = this.renderer.createText(this._el_264,'\n                                            ',(null as any));
    this._el_266 = import3.createRenderElement(this.renderer,this._el_264,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_267 = this.renderer.createText(this._el_266,'\n                                                ',(null as any));
    this._el_268 = import3.createRenderElement(this.renderer,this._el_266,'ul',new import3.InlineArray2(2,'class',''),(null as any));
    this._text_269 = this.renderer.createText(this._el_268,'\n                                                    ',(null as any));
    this._anchor_270 = this.renderer.createTemplateAnchor(this._el_268,(null as any));
    this._vc_270 = new import19.ViewContainer(270,268,this,this._anchor_270);
    this._TemplateRef_270_5 = new import22.TemplateRef_(this,270,this._anchor_270);
    this._NgIf_270_6 = new import21.Wrapper_NgIf(this._vc_270.vcRef,this._TemplateRef_270_5);
    this._text_271 = this.renderer.createText(this._el_268,'\n                                                    ',(null as any));
    this._el_272 = import3.createRenderElement(this.renderer,this._el_268,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_273 = this.renderer.createText(this._el_272,'\n                                                        ',(null as any));
    this._el_274 = import3.createRenderElement(this.renderer,this._el_272,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_275 = this.renderer.createText(this._el_274,'',(null as any));
    this._text_276 = this.renderer.createText(this._el_272,'\n                                                        ',(null as any));
    this._el_277 = import3.createRenderElement(this.renderer,this._el_272,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_278 = this.renderer.createText(this._el_277,'',(null as any));
    this._text_279 = this.renderer.createText(this._el_272,'\n                                                    ',(null as any));
    this._text_280 = this.renderer.createText(this._el_268,'\n                                                    ',(null as any));
    this._anchor_281 = this.renderer.createTemplateAnchor(this._el_268,(null as any));
    this._vc_281 = new import19.ViewContainer(281,268,this,this._anchor_281);
    this._TemplateRef_281_5 = new import22.TemplateRef_(this,281,this._anchor_281);
    this._NgFor_281_6 = new import29.Wrapper_NgFor(this._vc_281.vcRef,this._TemplateRef_281_5,this.parentView.parentView.injectorGet(import25.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_282 = this.renderer.createText(this._el_268,'\n                                                    ',(null as any));
    this._el_283 = import3.createRenderElement(this.renderer,this._el_268,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_284 = this.renderer.createText(this._el_283,'\n                                                        ',(null as any));
    this._el_285 = import3.createRenderElement(this.renderer,this._el_283,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_286 = this.renderer.createText(this._el_285,'',(null as any));
    this._text_287 = this.renderer.createText(this._el_283,'\n                                                        ',(null as any));
    this._el_288 = import3.createRenderElement(this.renderer,this._el_283,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_289 = this.renderer.createText(this._el_288,'',(null as any));
    this._text_290 = this.renderer.createText(this._el_283,'\n                                                    ',(null as any));
    this._text_291 = this.renderer.createText(this._el_268,'\n                                                    ',(null as any));
    this._anchor_292 = this.renderer.createTemplateAnchor(this._el_268,(null as any));
    this._vc_292 = new import19.ViewContainer(292,268,this,this._anchor_292);
    this._TemplateRef_292_5 = new import22.TemplateRef_(this,292,this._anchor_292);
    this._NgIf_292_6 = new import21.Wrapper_NgIf(this._vc_292.vcRef,this._TemplateRef_292_5);
    this._text_293 = this.renderer.createText(this._el_268,'\n                                                    ',(null as any));
    this._el_294 = import3.createRenderElement(this.renderer,this._el_268,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_295 = this.renderer.createText(this._el_294,'\n                                                        ',(null as any));
    this._el_296 = import3.createRenderElement(this.renderer,this._el_294,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_297 = this.renderer.createText(this._el_296,'',(null as any));
    this._text_298 = this.renderer.createText(this._el_294,'\n                                                        ',(null as any));
    this._el_299 = import3.createRenderElement(this.renderer,this._el_294,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_300 = this.renderer.createText(this._el_299,'',(null as any));
    this._text_301 = this.renderer.createText(this._el_294,'\n                                                    ',(null as any));
    this._text_302 = this.renderer.createText(this._el_268,'\n                                                ',(null as any));
    this._text_303 = this.renderer.createText(this._el_266,'\n                                            ',(null as any));
    this._text_304 = this.renderer.createText(this._el_264,'\n                                        ',(null as any));
    this._text_305 = this.renderer.createText(this._el_262,'\n                                    ',(null as any));
    this._text_306 = this.renderer.createText(this._el_260,'\n                                ',(null as any));
    this._text_307 = this.renderer.createText(this._el_258,'\n                                ',(null as any));
    this._el_308 = import3.createRenderElement(this.renderer,this._el_258,'div',new import3.InlineArray2(2,'class','panel-info-border'),(null as any));
    this._text_309 = this.renderer.createText(this._el_308,'\n                                    ',(null as any));
    this._el_310 = import3.createRenderElement(this.renderer,this._el_308,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_311 = this.renderer.createText(this._el_310,'\n                                        ',(null as any));
    this._el_312 = import3.createRenderElement(this.renderer,this._el_310,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_313 = this.renderer.createText(this._el_312,'\n                                            ',(null as any));
    this._el_314 = import3.createRenderElement(this.renderer,this._el_312,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_315 = this.renderer.createText(this._el_314,'\n                                                ',(null as any));
    this._el_316 = import3.createRenderElement(this.renderer,this._el_314,'ul',new import3.InlineArray2(2,'class',''),(null as any));
    this._text_317 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._el_318 = import3.createRenderElement(this.renderer,this._el_316,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_319 = this.renderer.createText(this._el_318,'\n                                                        ',(null as any));
    this._el_320 = import3.createRenderElement(this.renderer,this._el_318,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_321 = this.renderer.createText(this._el_320,'',(null as any));
    this._text_322 = this.renderer.createText(this._el_318,'\n                                                        ',(null as any));
    this._el_323 = import3.createRenderElement(this.renderer,this._el_318,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_324 = this.renderer.createText(this._el_323,'',(null as any));
    this._text_325 = this.renderer.createText(this._el_318,'\n                                                    ',(null as any));
    this._text_326 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._el_327 = import3.createRenderElement(this.renderer,this._el_316,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_328 = this.renderer.createText(this._el_327,'\n                                                        ',(null as any));
    this._el_329 = import3.createRenderElement(this.renderer,this._el_327,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_330 = this.renderer.createText(this._el_329,'',(null as any));
    this._text_331 = this.renderer.createText(this._el_327,'\n                                                        ',(null as any));
    this._el_332 = import3.createRenderElement(this.renderer,this._el_327,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_333 = this.renderer.createText(this._el_332,'',(null as any));
    this._text_334 = this.renderer.createText(this._el_327,'\n                                                    ',(null as any));
    this._text_335 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._el_336 = import3.createRenderElement(this.renderer,this._el_316,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_337 = this.renderer.createText(this._el_336,'\n                                                        ',(null as any));
    this._el_338 = import3.createRenderElement(this.renderer,this._el_336,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_339 = this.renderer.createText(this._el_338,'',(null as any));
    this._text_340 = this.renderer.createText(this._el_336,'\n                                                        ',(null as any));
    this._el_341 = import3.createRenderElement(this.renderer,this._el_336,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_342 = this.renderer.createText(this._el_341,'',(null as any));
    this._text_343 = this.renderer.createText(this._el_336,'\n                                                    ',(null as any));
    this._text_344 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._el_345 = import3.createRenderElement(this.renderer,this._el_316,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_346 = this.renderer.createText(this._el_345,'\n                                                        ',(null as any));
    this._el_347 = import3.createRenderElement(this.renderer,this._el_345,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_348 = this.renderer.createText(this._el_347,'',(null as any));
    this._text_349 = this.renderer.createText(this._el_345,'\n                                                        ',(null as any));
    this._el_350 = import3.createRenderElement(this.renderer,this._el_345,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_351 = this.renderer.createText(this._el_350,'',(null as any));
    this._text_352 = this.renderer.createText(this._el_345,'\n                                                    ',(null as any));
    this._text_353 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._anchor_354 = this.renderer.createTemplateAnchor(this._el_316,(null as any));
    this._vc_354 = new import19.ViewContainer(354,316,this,this._anchor_354);
    this._TemplateRef_354_5 = new import22.TemplateRef_(this,354,this._anchor_354);
    this._NgIf_354_6 = new import21.Wrapper_NgIf(this._vc_354.vcRef,this._TemplateRef_354_5);
    this._text_355 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._anchor_356 = this.renderer.createTemplateAnchor(this._el_316,(null as any));
    this._vc_356 = new import19.ViewContainer(356,316,this,this._anchor_356);
    this._TemplateRef_356_5 = new import22.TemplateRef_(this,356,this._anchor_356);
    this._NgIf_356_6 = new import21.Wrapper_NgIf(this._vc_356.vcRef,this._TemplateRef_356_5);
    this._text_357 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._anchor_358 = this.renderer.createTemplateAnchor(this._el_316,(null as any));
    this._vc_358 = new import19.ViewContainer(358,316,this,this._anchor_358);
    this._TemplateRef_358_5 = new import22.TemplateRef_(this,358,this._anchor_358);
    this._NgIf_358_6 = new import21.Wrapper_NgIf(this._vc_358.vcRef,this._TemplateRef_358_5);
    this._text_359 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._anchor_360 = this.renderer.createTemplateAnchor(this._el_316,(null as any));
    this._vc_360 = new import19.ViewContainer(360,316,this,this._anchor_360);
    this._TemplateRef_360_5 = new import22.TemplateRef_(this,360,this._anchor_360);
    this._NgIf_360_6 = new import21.Wrapper_NgIf(this._vc_360.vcRef,this._TemplateRef_360_5);
    this._text_361 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._anchor_362 = this.renderer.createTemplateAnchor(this._el_316,(null as any));
    this._vc_362 = new import19.ViewContainer(362,316,this,this._anchor_362);
    this._TemplateRef_362_5 = new import22.TemplateRef_(this,362,this._anchor_362);
    this._NgIf_362_6 = new import21.Wrapper_NgIf(this._vc_362.vcRef,this._TemplateRef_362_5);
    this._text_363 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._anchor_364 = this.renderer.createTemplateAnchor(this._el_316,(null as any));
    this._vc_364 = new import19.ViewContainer(364,316,this,this._anchor_364);
    this._TemplateRef_364_5 = new import22.TemplateRef_(this,364,this._anchor_364);
    this._NgIf_364_6 = new import21.Wrapper_NgIf(this._vc_364.vcRef,this._TemplateRef_364_5);
    this._text_365 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._anchor_366 = this.renderer.createTemplateAnchor(this._el_316,(null as any));
    this._vc_366 = new import19.ViewContainer(366,316,this,this._anchor_366);
    this._TemplateRef_366_5 = new import22.TemplateRef_(this,366,this._anchor_366);
    this._NgIf_366_6 = new import21.Wrapper_NgIf(this._vc_366.vcRef,this._TemplateRef_366_5);
    this._text_367 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._el_368 = import3.createRenderElement(this.renderer,this._el_316,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-md -eva-3-pt-sm -eva-3-pb-sm -eva-3-bc-gray-8'),(null as any));
    this._text_369 = this.renderer.createText(this._el_368,'\n                                                        ',(null as any));
    this._el_370 = import3.createRenderElement(this.renderer,this._el_368,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-bold'),(null as any));
    this._text_371 = this.renderer.createText(this._el_370,'',(null as any));
    this._text_372 = this.renderer.createText(this._el_368,'\n                                                        ',(null as any));
    this._el_373 = import3.createRenderElement(this.renderer,this._el_368,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_374 = this.renderer.createText(this._el_373,'',(null as any));
    this._el_375 = import3.createRenderElement(this.renderer,this._el_373,'span',new import3.InlineArray2(2,'style','font-size: 16px;'),(null as any));
    this._text_376 = this.renderer.createText(this._el_375,'',(null as any));
    this._text_377 = this.renderer.createText(this._el_368,'\n                                                    ',(null as any));
    this._text_378 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._anchor_379 = this.renderer.createTemplateAnchor(this._el_316,(null as any));
    this._vc_379 = new import19.ViewContainer(379,316,this,this._anchor_379);
    this._TemplateRef_379_5 = new import22.TemplateRef_(this,379,this._anchor_379);
    this._NgIf_379_6 = new import21.Wrapper_NgIf(this._vc_379.vcRef,this._TemplateRef_379_5);
    this._text_380 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._anchor_381 = this.renderer.createTemplateAnchor(this._el_316,(null as any));
    this._vc_381 = new import19.ViewContainer(381,316,this,this._anchor_381);
    this._TemplateRef_381_5 = new import22.TemplateRef_(this,381,this._anchor_381);
    this._NgIf_381_6 = new import21.Wrapper_NgIf(this._vc_381.vcRef,this._TemplateRef_381_5);
    this._text_382 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._anchor_383 = this.renderer.createTemplateAnchor(this._el_316,(null as any));
    this._vc_383 = new import19.ViewContainer(383,316,this,this._anchor_383);
    this._TemplateRef_383_5 = new import22.TemplateRef_(this,383,this._anchor_383);
    this._NgIf_383_6 = new import21.Wrapper_NgIf(this._vc_383.vcRef,this._TemplateRef_383_5);
    this._text_384 = this.renderer.createText(this._el_316,'\n                                                    ',(null as any));
    this._el_385 = import3.createRenderElement(this.renderer,this._el_316,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-md -eva-3-pt-sm -eva-3-pb-sm -eva-3-bc-gray-8'),(null as any));
    this._text_386 = this.renderer.createText(this._el_385,'\n                                                        ',(null as any));
    this._el_387 = import3.createRenderElement(this.renderer,this._el_385,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-bold'),(null as any));
    this._text_388 = this.renderer.createText(this._el_387,'',(null as any));
    this._text_389 = this.renderer.createText(this._el_385,'\n                                                        ',(null as any));
    this._el_390 = import3.createRenderElement(this.renderer,this._el_385,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_391 = this.renderer.createText(this._el_390,'',(null as any));
    this._el_392 = import3.createRenderElement(this.renderer,this._el_390,'span',new import3.InlineArray2(2,'style','font-size: 16px;'),(null as any));
    this._text_393 = this.renderer.createText(this._el_392,'',(null as any));
    this._text_394 = this.renderer.createText(this._el_385,'\n                                                    ',(null as any));
    this._text_395 = this.renderer.createText(this._el_316,'\n                                                ',(null as any));
    this._text_396 = this.renderer.createText(this._el_314,'\n                                            ',(null as any));
    this._text_397 = this.renderer.createText(this._el_312,'\n                                        ',(null as any));
    this._text_398 = this.renderer.createText(this._el_310,'\n                                    ',(null as any));
    this._text_399 = this.renderer.createText(this._el_308,'\n                                ',(null as any));
    this._text_400 = this.renderer.createText(this._el_258,'\n                                ',(null as any));
    this._anchor_401 = this.renderer.createTemplateAnchor(this._el_258,(null as any));
    this._vc_401 = new import19.ViewContainer(401,258,this,this._anchor_401);
    this._TemplateRef_401_5 = new import22.TemplateRef_(this,401,this._anchor_401);
    this._NgIf_401_6 = new import21.Wrapper_NgIf(this._vc_401.vcRef,this._TemplateRef_401_5);
    this._text_402 = this.renderer.createText(this._el_258,'\n                            ',(null as any));
    this._text_403 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._text_404 = this.renderer.createText(this._el_6,'\n\n                            ',(null as any));
    this._text_405 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._el_406 = import3.createRenderElement(this.renderer,this._el_6,'dsp-dropdown',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_407 = this.renderer.createText(this._el_406,'\n                                ',(null as any));
    this._el_408 = import3.createRenderElement(this.renderer,this._el_406,'div',new import3.InlineArray2(2,'class','panel-info-border'),(null as any));
    this._text_409 = this.renderer.createText(this._el_408,'\n                                    ',(null as any));
    this._el_410 = import3.createRenderElement(this.renderer,this._el_408,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_411 = this.renderer.createText(this._el_410,'\n                                        ',(null as any));
    this._el_412 = import3.createRenderElement(this.renderer,this._el_410,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_413 = this.renderer.createText(this._el_412,'\n                                            ',(null as any));
    this._text_414 = this.renderer.createText(this._el_412,'\n                                            ',(null as any));
    this._el_415 = import3.createRenderElement(this.renderer,this._el_412,'div',new import3.InlineArray2(2,'class','sara-message -success'),(null as any));
    this._text_416 = this.renderer.createText(this._el_415,'\n                                                ',(null as any));
    this._el_417 = import3.createRenderElement(this.renderer,this._el_415,'div',new import3.InlineArray2(2,'class','message-header'),(null as any));
    this._text_418 = this.renderer.createText(this._el_417,'\n                                                    ',(null as any));
    this._el_419 = import3.createRenderElement(this.renderer,this._el_417,'div',new import3.InlineArray2(2,'class','message-icon'),(null as any));
    this._el_420 = import3.createRenderElement(this.renderer,this._el_419,'i',new import3.InlineArray4(4,'aria-hidden','true','class','glyphicon glyphicon-ok-sign'),(null as any));
    this._text_421 = this.renderer.createText(this._el_417,'\n                                                    ',(null as any));
    this._el_422 = import3.createRenderElement(this.renderer,this._el_417,'h5',new import3.InlineArray2(2,'class','-h5'),(null as any));
    this._text_423 = this.renderer.createText(this._el_422,'',(null as any));
    this._text_424 = this.renderer.createText(this._el_417,'\n                                                ',(null as any));
    this._text_425 = this.renderer.createText(this._el_415,'\n                                            ',(null as any));
    this._text_426 = this.renderer.createText(this._el_412,'\n                                            ',(null as any));
    this._el_427 = import3.createRenderElement(this.renderer,this._el_412,'div',new import3.InlineArray2(2,'class','sara-message -success'),(null as any));
    this._text_428 = this.renderer.createText(this._el_427,'\n                                                ',(null as any));
    this._el_429 = import3.createRenderElement(this.renderer,this._el_427,'div',new import3.InlineArray2(2,'class','message-header'),(null as any));
    this._text_430 = this.renderer.createText(this._el_429,'\n                                                    ',(null as any));
    this._el_431 = import3.createRenderElement(this.renderer,this._el_429,'div',new import3.InlineArray2(2,'class','message-icon'),(null as any));
    this._el_432 = import3.createRenderElement(this.renderer,this._el_431,'i',new import3.InlineArray4(4,'aria-hidden','true','class','glyphicon glyphicon-ok-sign'),(null as any));
    this._text_433 = this.renderer.createText(this._el_429,'\n                                                    ',(null as any));
    this._el_434 = import3.createRenderElement(this.renderer,this._el_429,'h5',new import3.InlineArray2(2,'class','-h5'),(null as any));
    this._text_435 = this.renderer.createText(this._el_434,'',(null as any));
    this._text_436 = this.renderer.createText(this._el_429,'\n                                                ',(null as any));
    this._text_437 = this.renderer.createText(this._el_427,'\n                                            ',(null as any));
    this._text_438 = this.renderer.createText(this._el_412,'\n                                            ',(null as any));
    this._el_439 = import3.createRenderElement(this.renderer,this._el_412,'div',new import3.InlineArray2(2,'class','sara-message -success'),(null as any));
    this._text_440 = this.renderer.createText(this._el_439,'\n                                                ',(null as any));
    this._el_441 = import3.createRenderElement(this.renderer,this._el_439,'div',new import3.InlineArray2(2,'class','message-header'),(null as any));
    this._text_442 = this.renderer.createText(this._el_441,'\n                                                    ',(null as any));
    this._el_443 = import3.createRenderElement(this.renderer,this._el_441,'div',new import3.InlineArray2(2,'class','message-icon'),(null as any));
    this._el_444 = import3.createRenderElement(this.renderer,this._el_443,'i',new import3.InlineArray4(4,'aria-hidden','true','class','glyphicon glyphicon-ok-sign'),(null as any));
    this._text_445 = this.renderer.createText(this._el_441,'\n                                                    ',(null as any));
    this._el_446 = import3.createRenderElement(this.renderer,this._el_441,'h5',new import3.InlineArray2(2,'class','-h5'),(null as any));
    this._text_447 = this.renderer.createText(this._el_446,'',(null as any));
    this._text_448 = this.renderer.createText(this._el_441,'\n                                                ',(null as any));
    this._text_449 = this.renderer.createText(this._el_439,'\n                                            ',(null as any));
    this._text_450 = this.renderer.createText(this._el_412,'\n                                            ',(null as any));
    this._text_451 = this.renderer.createText(this._el_412,'\n                                            ',(null as any));
    this._el_452 = import3.createRenderElement(this.renderer,this._el_412,'dsp-table',new import3.InlineArray4(4,'page-size','20','sort','false'),(null as any));
    this._text_453 = this.renderer.createText(this._el_452,'\n                                                ',(null as any));
    this._el_454 = import3.createRenderElement(this.renderer,this._el_452,'dsp-table-head',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_455 = this.renderer.createText(this._el_454,'\n                                                    ',(null as any));
    this._el_456 = import3.createRenderElement(this.renderer,this._el_454,'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal;'),(null as any));
    this._el_457 = import3.createRenderElement(this.renderer,this._el_456,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_458 = this.renderer.createText(this._el_457,'',(null as any));
    this._text_459 = this.renderer.createText(this._el_454,'\n                                                    ',(null as any));
    this._anchor_460 = this.renderer.createTemplateAnchor(this._el_454,(null as any));
    this._vc_460 = new import19.ViewContainer(460,454,this,this._anchor_460);
    this._TemplateRef_460_5 = new import22.TemplateRef_(this,460,this._anchor_460);
    this._NgIf_460_6 = new import21.Wrapper_NgIf(this._vc_460.vcRef,this._TemplateRef_460_5);
    this._text_461 = this.renderer.createText(this._el_454,'\n                                                    ',(null as any));
    this._anchor_462 = this.renderer.createTemplateAnchor(this._el_454,(null as any));
    this._vc_462 = new import19.ViewContainer(462,454,this,this._anchor_462);
    this._TemplateRef_462_5 = new import22.TemplateRef_(this,462,this._anchor_462);
    this._NgIf_462_6 = new import21.Wrapper_NgIf(this._vc_462.vcRef,this._TemplateRef_462_5);
    this._text_463 = this.renderer.createText(this._el_454,'\n                                                    ',(null as any));
    this._anchor_464 = this.renderer.createTemplateAnchor(this._el_454,(null as any));
    this._vc_464 = new import19.ViewContainer(464,454,this,this._anchor_464);
    this._TemplateRef_464_5 = new import22.TemplateRef_(this,464,this._anchor_464);
    this._NgIf_464_6 = new import21.Wrapper_NgIf(this._vc_464.vcRef,this._TemplateRef_464_5);
    this._text_465 = this.renderer.createText(this._el_454,'\n                                                    ',(null as any));
    this._anchor_466 = this.renderer.createTemplateAnchor(this._el_454,(null as any));
    this._vc_466 = new import19.ViewContainer(466,454,this,this._anchor_466);
    this._TemplateRef_466_5 = new import22.TemplateRef_(this,466,this._anchor_466);
    this._NgIf_466_6 = new import21.Wrapper_NgIf(this._vc_466.vcRef,this._TemplateRef_466_5);
    this._text_467 = this.renderer.createText(this._el_454,'\n                                                    ',(null as any));
    this._anchor_468 = this.renderer.createTemplateAnchor(this._el_454,(null as any));
    this._vc_468 = new import19.ViewContainer(468,454,this,this._anchor_468);
    this._TemplateRef_468_5 = new import22.TemplateRef_(this,468,this._anchor_468);
    this._NgIf_468_6 = new import21.Wrapper_NgIf(this._vc_468.vcRef,this._TemplateRef_468_5);
    this._text_469 = this.renderer.createText(this._el_454,'\n                                                    ',(null as any));
    this._anchor_470 = this.renderer.createTemplateAnchor(this._el_454,(null as any));
    this._vc_470 = new import19.ViewContainer(470,454,this,this._anchor_470);
    this._TemplateRef_470_5 = new import22.TemplateRef_(this,470,this._anchor_470);
    this._NgIf_470_6 = new import21.Wrapper_NgIf(this._vc_470.vcRef,this._TemplateRef_470_5);
    this._text_471 = this.renderer.createText(this._el_454,'\n                                                    ',(null as any));
    this._el_472 = import3.createRenderElement(this.renderer,this._el_454,'dsp-table-header',new import3.InlineArray4(4,'class','-eva-3-tl','style','white-space: normal;'),(null as any));
    this._el_473 = import3.createRenderElement(this.renderer,this._el_472,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_474 = this.renderer.createText(this._el_473,'',(null as any));
    this._text_475 = this.renderer.createText(this._el_454,'\n                                                ',(null as any));
    this._text_476 = this.renderer.createText(this._el_452,'\n                                                ',(null as any));
    this._el_477 = import3.createRenderElement(this.renderer,this._el_452,'dsp-table-body',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_478 = this.renderer.createText(this._el_477,'\n                                                    ',(null as any));
    this._anchor_479 = this.renderer.createTemplateAnchor(this._el_477,(null as any));
    this._vc_479 = new import19.ViewContainer(479,477,this,this._anchor_479);
    this._TemplateRef_479_5 = new import22.TemplateRef_(this,479,this._anchor_479);
    this._NgFor_479_6 = new import29.Wrapper_NgFor(this._vc_479.vcRef,this._TemplateRef_479_5,this.parentView.parentView.injectorGet(import25.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_480 = this.renderer.createText(this._el_477,'\n                                                ',(null as any));
    this._text_481 = this.renderer.createText(this._el_452,'\n                                            ',(null as any));
    this._text_482 = this.renderer.createText(this._el_412,'\n                                        ',(null as any));
    this._text_483 = this.renderer.createText(this._el_410,'\n                                    ',(null as any));
    this._text_484 = this.renderer.createText(this._el_408,'\n                                ',(null as any));
    this._text_485 = this.renderer.createText(this._el_406,'\n                            ',(null as any));
    this._text_486 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._text_487 = this.renderer.createText(this._el_6,'\n\n                            ',(null as any));
    this._text_488 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._anchor_489 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_489 = new import19.ViewContainer(489,6,this,this._anchor_489);
    this._TemplateRef_489_5 = new import22.TemplateRef_(this,489,this._anchor_489);
    this._NgIf_489_6 = new import21.Wrapper_NgIf(this._vc_489.vcRef,this._TemplateRef_489_5);
    this._text_490 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._text_491 = this.renderer.createText(this._el_6,'\n\n                            ',(null as any));
    this._text_492 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._anchor_493 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_493 = new import19.ViewContainer(493,6,this,this._anchor_493);
    this._TemplateRef_493_5 = new import22.TemplateRef_(this,493,this._anchor_493);
    this._NgIf_493_6 = new import21.Wrapper_NgIf(this._vc_493.vcRef,this._TemplateRef_493_5);
    this._text_494 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._text_495 = this.renderer.createText(this._el_6,'\n\n                            ',(null as any));
    this._text_496 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._el_497 = import3.createRenderElement(this.renderer,this._el_6,'dsp-dropdown',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_498 = this.renderer.createText(this._el_497,'\n                                ',(null as any));
    this._el_499 = import3.createRenderElement(this.renderer,this._el_497,'div',new import3.InlineArray2(2,'class','panel-info-border'),(null as any));
    this._text_500 = this.renderer.createText(this._el_499,'\n                                    ',(null as any));
    this._el_501 = import3.createRenderElement(this.renderer,this._el_499,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_502 = this.renderer.createText(this._el_501,'\n                                        ',(null as any));
    this._el_503 = import3.createRenderElement(this.renderer,this._el_501,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_504 = this.renderer.createText(this._el_503,'\n                                            ',(null as any));
    this._el_505 = import3.createRenderElement(this.renderer,this._el_503,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_506 = this.renderer.createText(this._el_505,'\n                                                ',(null as any));
    this._anchor_507 = this.renderer.createTemplateAnchor(this._el_505,(null as any));
    this._vc_507 = new import19.ViewContainer(507,505,this,this._anchor_507);
    this._TemplateRef_507_5 = new import22.TemplateRef_(this,507,this._anchor_507);
    this._NgFor_507_6 = new import29.Wrapper_NgFor(this._vc_507.vcRef,this._TemplateRef_507_5,this.parentView.parentView.injectorGet(import25.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_508 = this.renderer.createText(this._el_505,'\n                                                ',(null as any));
    this._el_509 = import3.createRenderElement(this.renderer,this._el_505,'ul',new import3.InlineArray2(2,'class',''),(null as any));
    this._text_510 = this.renderer.createText(this._el_509,'\n                                                    ',(null as any));
    this._el_511 = import3.createRenderElement(this.renderer,this._el_509,'li',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_512 = this.renderer.createText(this._el_511,'\n                                                        ',(null as any));
    this._el_513 = import3.createRenderElement(this.renderer,this._el_511,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6'),(null as any));
    this._text_514 = this.renderer.createText(this._el_513,'',(null as any));
    this._text_515 = this.renderer.createText(this._el_511,'\n                                                        ',(null as any));
    this._el_516 = import3.createRenderElement(this.renderer,this._el_511,'span',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-6 -eva-3-tr'),(null as any));
    this._text_517 = this.renderer.createText(this._el_516,'',(null as any));
    this._text_518 = this.renderer.createText(this._el_511,'\n                                                    ',(null as any));
    this._text_519 = this.renderer.createText(this._el_509,'\n                                                ',(null as any));
    this._text_520 = this.renderer.createText(this._el_505,'\n                                            ',(null as any));
    this._text_521 = this.renderer.createText(this._el_503,'\n                                        ',(null as any));
    this._text_522 = this.renderer.createText(this._el_501,'\n                                    ',(null as any));
    this._text_523 = this.renderer.createText(this._el_499,'\n                                ',(null as any));
    this._text_524 = this.renderer.createText(this._el_497,'\n                            ',(null as any));
    this._text_525 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._text_526 = this.renderer.createText(this._el_6,'\n                        ',(null as any));
    this._text_527 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._el_528 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -lg-3 -md-12 -sm-12'),(null as any));
    this._text_529 = this.renderer.createText(this._el_528,'\n                            ',(null as any));
    this._el_530 = import3.createRenderElement(this.renderer,this._el_528,'div',new import3.InlineArray2(2,'class','eva-3-panel-info right-panel -eva-3-bc-gray-7'),(null as any));
    this._text_531 = this.renderer.createText(this._el_530,'\n                                ',(null as any));
    this._el_532 = import3.createRenderElement(this.renderer,this._el_530,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_533 = this.renderer.createText(this._el_532,'\n                                    ',(null as any));
    this._el_534 = import3.createRenderElement(this.renderer,this._el_532,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_535 = this.renderer.createText(this._el_534,'\n                                        ',(null as any));
    this._el_536 = import3.createRenderElement(this.renderer,this._el_534,'h5',new import3.InlineArray2(2,'class','eva-3-h6'),(null as any));
    this._text_537 = this.renderer.createText(this._el_536,'',(null as any));
    this._text_538 = this.renderer.createText(this._el_534,'\n                                    ',(null as any));
    this._text_539 = this.renderer.createText(this._el_532,'\n                                ',(null as any));
    this._text_540 = this.renderer.createText(this._el_530,'\n                                ',(null as any));
    this._el_541 = import3.createRenderElement(this.renderer,this._el_530,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_542 = this.renderer.createText(this._el_541,'\n                                    ',(null as any));
    this._el_543 = import3.createRenderElement(this.renderer,this._el_541,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_544 = this.renderer.createText(this._el_543,'\n                                        ',(null as any));
    this._el_545 = import3.createRenderElement(this.renderer,this._el_543,'ul',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_546 = this.renderer.createText(this._el_545,'\n                                            ',(null as any));
    this._el_547 = import3.createRenderElement(this.renderer,this._el_545,'li',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_548 = this.renderer.createText(this._el_547,'\n                                                ',(null as any));
    this._el_549 = import3.createRenderElement(this.renderer,this._el_547,'p',new import3.InlineArray2(2,'class','detail-text -eva-3-tc-gray-3'),(null as any));
    this._text_550 = this.renderer.createText(this._el_549,'',(null as any));
    this._text_551 = this.renderer.createText(this._el_547,'\n                                                ',(null as any));
    this._el_552 = import3.createRenderElement(this.renderer,this._el_547,'p',new import3.InlineArray2(2,'class','-eva-3-bold -eva-3-tc-gray-3'),(null as any));
    this._text_553 = this.renderer.createText(this._el_552,'',(null as any));
    this._text_554 = this.renderer.createText(this._el_547,'\n                                            ',(null as any));
    this._text_555 = this.renderer.createText(this._el_545,'\n                                            ',(null as any));
    this._el_556 = import3.createRenderElement(this.renderer,this._el_545,'li',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_557 = this.renderer.createText(this._el_556,'\n                                                ',(null as any));
    this._el_558 = import3.createRenderElement(this.renderer,this._el_556,'p',new import3.InlineArray2(2,'class','detail-text -eva-3-tc-gray-3'),(null as any));
    this._text_559 = this.renderer.createText(this._el_558,'',(null as any));
    this._text_560 = this.renderer.createText(this._el_556,'\n                                                ',(null as any));
    this._el_561 = import3.createRenderElement(this.renderer,this._el_556,'p',new import3.InlineArray2(2,'class','-eva-3-bold -eva-3-tc-gray-3'),(null as any));
    this._text_562 = this.renderer.createText(this._el_561,'',(null as any));
    this._text_563 = this.renderer.createText(this._el_556,'\n                                            ',(null as any));
    this._text_564 = this.renderer.createText(this._el_545,'\n                                        ',(null as any));
    this._text_565 = this.renderer.createText(this._el_543,'\n                                    ',(null as any));
    this._text_566 = this.renderer.createText(this._el_541,'\n                                ',(null as any));
    this._text_567 = this.renderer.createText(this._el_530,'\n                            ',(null as any));
    this._text_568 = this.renderer.createText(this._el_528,'\n                            ',(null as any));
    this._el_569 = import3.createRenderElement(this.renderer,this._el_528,'div',new import3.InlineArray2(2,'class','eva-3-panel-info right-panel -eva-3-bc-gray-7 -eva-3-mt-md'),(null as any));
    this._text_570 = this.renderer.createText(this._el_569,'\n                                ',(null as any));
    this._el_571 = import3.createRenderElement(this.renderer,this._el_569,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_572 = this.renderer.createText(this._el_571,'\n                                    ',(null as any));
    this._el_573 = import3.createRenderElement(this.renderer,this._el_571,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_574 = this.renderer.createText(this._el_573,'\n                                        ',(null as any));
    this._el_575 = import3.createRenderElement(this.renderer,this._el_573,'h5',new import3.InlineArray2(2,'class','eva-3-h6'),(null as any));
    this._text_576 = this.renderer.createText(this._el_575,'',(null as any));
    this._text_577 = this.renderer.createText(this._el_573,'\n                                    ',(null as any));
    this._text_578 = this.renderer.createText(this._el_571,'\n                                ',(null as any));
    this._text_579 = this.renderer.createText(this._el_569,'\n                                ',(null as any));
    this._el_580 = import3.createRenderElement(this.renderer,this._el_569,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_581 = this.renderer.createText(this._el_580,'\n                                    ',(null as any));
    this._el_582 = import3.createRenderElement(this.renderer,this._el_580,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_583 = this.renderer.createText(this._el_582,'\n                                        ',(null as any));
    this._el_584 = import3.createRenderElement(this.renderer,this._el_582,'ul',new import3.InlineArray2(2,'style','border-bottom: 1.3px solid #888;'),(null as any));
    this._text_585 = this.renderer.createText(this._el_584,'\n                                            ',(null as any));
    this._el_586 = import3.createRenderElement(this.renderer,this._el_584,'li',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_587 = this.renderer.createText(this._el_586,'\n                                                ',(null as any));
    this._el_588 = import3.createRenderElement(this.renderer,this._el_586,'p',new import3.InlineArray2(2,'class','detail-text -eva-3-tc-gray-3'),(null as any));
    this._text_589 = this.renderer.createText(this._el_588,'',(null as any));
    this._text_590 = this.renderer.createText(this._el_586,'\n                                                ',(null as any));
    this._el_591 = import3.createRenderElement(this.renderer,this._el_586,'p',new import3.InlineArray2(2,'class','-eva-3-bold -eva-3-tc-gray-3'),(null as any));
    this._text_592 = this.renderer.createText(this._el_591,'',(null as any));
    this._text_593 = this.renderer.createText(this._el_586,'\n                                            ',(null as any));
    this._text_594 = this.renderer.createText(this._el_584,'\n                                            ',(null as any));
    this._anchor_595 = this.renderer.createTemplateAnchor(this._el_584,(null as any));
    this._vc_595 = new import19.ViewContainer(595,584,this,this._anchor_595);
    this._TemplateRef_595_5 = new import22.TemplateRef_(this,595,this._anchor_595);
    this._NgIf_595_6 = new import21.Wrapper_NgIf(this._vc_595.vcRef,this._TemplateRef_595_5);
    this._text_596 = this.renderer.createText(this._el_584,'\n                                            ',(null as any));
    this._anchor_597 = this.renderer.createTemplateAnchor(this._el_584,(null as any));
    this._vc_597 = new import19.ViewContainer(597,584,this,this._anchor_597);
    this._TemplateRef_597_5 = new import22.TemplateRef_(this,597,this._anchor_597);
    this._NgIf_597_6 = new import21.Wrapper_NgIf(this._vc_597.vcRef,this._TemplateRef_597_5);
    this._text_598 = this.renderer.createText(this._el_584,'\n                                        ',(null as any));
    this._text_599 = this.renderer.createText(this._el_582,'\n                                    ',(null as any));
    this._text_600 = this.renderer.createText(this._el_580,'\n                                ',(null as any));
    this._text_601 = this.renderer.createText(this._el_569,'\n\n                                ',(null as any));
    this._el_602 = import3.createRenderElement(this.renderer,this._el_569,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_603 = this.renderer.createText(this._el_602,'\n                                    ',(null as any));
    this._el_604 = import3.createRenderElement(this.renderer,this._el_602,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_605 = this.renderer.createText(this._el_604,'\n                                        ',(null as any));
    this._el_606 = import3.createRenderElement(this.renderer,this._el_604,'h5',new import3.InlineArray2(2,'class','eva-3-h6'),(null as any));
    this._text_607 = this.renderer.createText(this._el_606,'',(null as any));
    this._text_608 = this.renderer.createText(this._el_604,'\n                                    ',(null as any));
    this._text_609 = this.renderer.createText(this._el_602,'\n                                ',(null as any));
    this._text_610 = this.renderer.createText(this._el_569,'\n                                ',(null as any));
    this._el_611 = import3.createRenderElement(this.renderer,this._el_569,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_612 = this.renderer.createText(this._el_611,'\n                                    ',(null as any));
    this._el_613 = import3.createRenderElement(this.renderer,this._el_611,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_614 = this.renderer.createText(this._el_613,'\n                                        ',(null as any));
    this._el_615 = import3.createRenderElement(this.renderer,this._el_613,'ul',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_616 = this.renderer.createText(this._el_615,'\n                                            ',(null as any));
    this._el_617 = import3.createRenderElement(this.renderer,this._el_615,'li',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_618 = this.renderer.createText(this._el_617,'\n                                                ',(null as any));
    this._el_619 = import3.createRenderElement(this.renderer,this._el_617,'p',new import3.InlineArray2(2,'class','detail-text -eva-3-tc-gray-3'),(null as any));
    this._text_620 = this.renderer.createText(this._el_619,'',(null as any));
    this._text_621 = this.renderer.createText(this._el_617,'\n                                                ',(null as any));
    this._el_622 = import3.createRenderElement(this.renderer,this._el_617,'p',new import3.InlineArray2(2,'class','-eva-3-bold -eva-3-tc-gray-3'),(null as any));
    this._text_623 = this.renderer.createText(this._el_622,'',(null as any));
    this._text_624 = this.renderer.createText(this._el_617,'\n                                            ',(null as any));
    this._text_625 = this.renderer.createText(this._el_615,'\n                                            ',(null as any));
    this._el_626 = import3.createRenderElement(this.renderer,this._el_615,'li',new import3.InlineArray2(2,'class','-eva-3-pt-md'),(null as any));
    this._text_627 = this.renderer.createText(this._el_626,'\n                                                ',(null as any));
    this._el_628 = import3.createRenderElement(this.renderer,this._el_626,'p',new import3.InlineArray2(2,'class','detail-text -eva-3-tc-gray-3'),(null as any));
    this._text_629 = this.renderer.createText(this._el_628,'',(null as any));
    this._text_630 = this.renderer.createText(this._el_626,'\n                                                ',(null as any));
    this._el_631 = import3.createRenderElement(this.renderer,this._el_626,'p',new import3.InlineArray2(2,'class','-eva-3-bold -eva-3-tc-gray-3'),(null as any));
    this._text_632 = this.renderer.createText(this._el_631,'',(null as any));
    this._text_633 = this.renderer.createText(this._el_626,'\n                                            ',(null as any));
    this._text_634 = this.renderer.createText(this._el_615,'\n                                        ',(null as any));
    this._text_635 = this.renderer.createText(this._el_613,'\n                                    ',(null as any));
    this._text_636 = this.renderer.createText(this._el_611,'\n                                ',(null as any));
    this._text_637 = this.renderer.createText(this._el_569,'\n                            ',(null as any));
    this._text_638 = this.renderer.createText(this._el_528,'\n                            ',(null as any));
    this._el_639 = import3.createRenderElement(this.renderer,this._el_528,'div',new import3.InlineArray2(2,'class','eva-3-panel-info right-panel -eva-3-bc-gray-7 -eva-3-mt-md'),(null as any));
    this._text_640 = this.renderer.createText(this._el_639,'\n                                ',(null as any));
    this._el_641 = import3.createRenderElement(this.renderer,this._el_639,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_642 = this.renderer.createText(this._el_641,'\n                                    ',(null as any));
    this._el_643 = import3.createRenderElement(this.renderer,this._el_641,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_644 = this.renderer.createText(this._el_643,'\n                                        ',(null as any));
    this._el_645 = import3.createRenderElement(this.renderer,this._el_643,'h5',new import3.InlineArray2(2,'class','eva-3-h6'),(null as any));
    this._text_646 = this.renderer.createText(this._el_645,'',(null as any));
    this._text_647 = this.renderer.createText(this._el_643,'\n                                    ',(null as any));
    this._text_648 = this.renderer.createText(this._el_641,'\n                                ',(null as any));
    this._text_649 = this.renderer.createText(this._el_639,'\n                                ',(null as any));
    this._el_650 = import3.createRenderElement(this.renderer,this._el_639,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-md'),(null as any));
    this._text_651 = this.renderer.createText(this._el_650,'\n                                    ',(null as any));
    this._el_652 = import3.createRenderElement(this.renderer,this._el_650,'div',new import3.InlineArray4(4,'class','col -lg-12 -md-12 -sm-12','qadata','bookingDetailCompanyInfo'),(null as any));
    this._text_653 = this.renderer.createText(this._el_652,'\n                                        ',(null as any));
    this._el_654 = import3.createRenderElement(this.renderer,this._el_652,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_655 = this.renderer.createText(this._el_654,'',(null as any));
    this._el_656 = import3.createRenderElement(this.renderer,this._el_654,'a',new import3.InlineArray2(2,'class','eva-3-link message-link'),(null as any));
    this._text_657 = this.renderer.createText(this._el_656,'',(null as any));
    this._text_658 = this.renderer.createText(this._el_654,'',(null as any));
    this._el_659 = import3.createRenderElement(this.renderer,this._el_652,'p',new import3.InlineArray2(2,'class','-eva-3-pt-md -eva-3-tc-gray-3'),(null as any));
    this._text_660 = this.renderer.createText(this._el_659,'',(null as any));
    this._el_661 = import3.createRenderElement(this.renderer,this._el_659,'a',new import3.InlineArray2(2,'class','eva-3-link message-link'),(null as any));
    this._text_662 = this.renderer.createText(this._el_661,'',(null as any));
    this._text_663 = this.renderer.createText(this._el_659,'.',(null as any));
    this._text_664 = this.renderer.createText(this._el_652,'\n                                    ',(null as any));
    this._text_665 = this.renderer.createText(this._el_650,'\n                                ',(null as any));
    this._text_666 = this.renderer.createText(this._el_639,'\n                            ',(null as any));
    this._text_667 = this.renderer.createText(this._el_528,'\n                            ',(null as any));
    this._anchor_668 = this.renderer.createTemplateAnchor(this._el_528,(null as any));
    this._vc_668 = new import19.ViewContainer(668,528,this,this._anchor_668);
    this._TemplateRef_668_5 = new import22.TemplateRef_(this,668,this._anchor_668);
    this._NgIf_668_6 = new import21.Wrapper_NgIf(this._vc_668.vcRef,this._TemplateRef_668_5);
    this._text_669 = this.renderer.createText(this._el_528,'\n                            ',(null as any));
    this._anchor_670 = this.renderer.createTemplateAnchor(this._el_528,(null as any));
    this._vc_670 = new import19.ViewContainer(670,528,this,this._anchor_670);
    this._TemplateRef_670_5 = new import22.TemplateRef_(this,670,this._anchor_670);
    this._NgIf_670_6 = new import21.Wrapper_NgIf(this._vc_670.vcRef,this._TemplateRef_670_5);
    this._text_671 = this.renderer.createText(this._el_528,'\n                        ',(null as any));
    this._text_672 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._text_673 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._text_674 = this.renderer.createText(this._el_0,'\n\n                ',(null as any));
    this._text_675 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_676 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','-eva-3-mt-lg -eva-3-mb-lg booking-list-download-responsive'),(null as any));
    this._text_677 = this.renderer.createText(this._el_676,'\n                    ',(null as any));
    this._el_678 = import3.createRenderElement(this.renderer,this._el_676,'dsp-button',new import3.InlineArray8(8,'color','darken','loading','true','size','md','variation','ghost'),(null as any));
    this._text_679 = this.renderer.createText(this._el_678,'\n                        ',(null as any));
    this._el_680 = import3.createRenderElement(this.renderer,this._el_678,'i',new import3.InlineArray2(2,'class','eva-3-icon-download'),(null as any));
    this._text_681 = this.renderer.createText(this._el_678,'',(null as any));
    this._text_682 = this.renderer.createText(this._el_676,'\n                ',(null as any));
    this._text_683 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._text_684 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_2 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_3 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_4 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_5 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_6 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_7 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_8 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_9 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_10 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_11 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_12 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_13 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_14 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_15 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_16 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_17 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_18 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_19 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_20 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_21 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_22 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_23 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_24 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_25 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_26 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_27 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_28 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_29 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_30 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_31 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_32 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_33 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_34 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_35 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_36 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_37 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_38 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_39 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_40 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_41 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_42 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_43 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_44 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_45 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_46 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_47 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_48 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_49 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_50 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_51 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_52 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_656,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_656));
    this._pipe_translate_53 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_54 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_55 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_56 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_661,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_661));
    this._pipe_translate_57 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_678,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_678));
    this._pipe_translate_58 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_59 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._text_40,
      this._el_41,
      this._text_42,
      this._el_43,
      this._text_44,
      this._text_45,
      this._text_46,
      this._text_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._el_51,
      this._text_52,
      this._el_53,
      this._text_54,
      this._el_55,
      this._text_56,
      this._text_57,
      this._el_58,
      this._text_59,
      this._text_60,
      this._text_61,
      this._el_62,
      this._text_63,
      this._el_64,
      this._text_65,
      this._text_66,
      this._el_67,
      this._text_68,
      this._text_69,
      this._text_70,
      this._el_71,
      this._text_72,
      this._el_73,
      this._text_74,
      this._text_75,
      this._el_76,
      this._text_77,
      this._text_78,
      this._text_79,
      this._el_80,
      this._text_81,
      this._el_82,
      this._text_83,
      this._text_84,
      this._el_85,
      this._text_86,
      this._text_87,
      this._text_88,
      this._el_89,
      this._text_90,
      this._el_91,
      this._text_92,
      this._text_93,
      this._el_94,
      this._text_95,
      this._text_96,
      this._text_97,
      this._text_98,
      this._text_99,
      this._text_100,
      this._anchor_101,
      this._text_102,
      this._text_103,
      this._el_104,
      this._text_105,
      this._el_106,
      this._text_107,
      this._el_108,
      this._text_109,
      this._el_110,
      this._text_111,
      this._text_112,
      this._text_113,
      this._text_114,
      this._text_115,
      this._text_116,
      this._text_117,
      this._text_118,
      this._text_119,
      this._text_120,
      this._el_121,
      this._text_122,
      this._el_123,
      this._text_124,
      this._el_125,
      this._text_126,
      this._el_127,
      this._text_128,
      this._el_129,
      this._text_130,
      this._el_131,
      this._text_132,
      this._el_133,
      this._text_134,
      this._text_135,
      this._el_136,
      this._text_137,
      this._el_138,
      this._text_139,
      this._text_140,
      this._text_141,
      this._text_142,
      this._text_143,
      this._el_144,
      this._text_145,
      this._el_146,
      this._text_147,
      this._el_148,
      this._text_149,
      this._el_150,
      this._text_151,
      this._text_152,
      this._el_153,
      this._text_154,
      this._text_155,
      this._text_156,
      this._el_157,
      this._text_158,
      this._el_159,
      this._text_160,
      this._text_161,
      this._el_162,
      this._text_163,
      this._text_164,
      this._text_165,
      this._el_166,
      this._text_167,
      this._el_168,
      this._text_169,
      this._text_170,
      this._el_171,
      this._text_172,
      this._text_173,
      this._text_174,
      this._el_175,
      this._text_176,
      this._el_177,
      this._text_178,
      this._text_179,
      this._el_180,
      this._text_181,
      this._text_182,
      this._text_183,
      this._anchor_184,
      this._text_185,
      this._anchor_186,
      this._text_187,
      this._anchor_188,
      this._text_189,
      this._text_190,
      this._text_191,
      this._text_192,
      this._el_193,
      this._text_194,
      this._el_195,
      this._text_196,
      this._el_197,
      this._text_198,
      this._el_199,
      this._text_200,
      this._el_201,
      this._text_202,
      this._text_203,
      this._el_204,
      this._text_205,
      this._el_206,
      this._text_207,
      this._text_208,
      this._text_209,
      this._text_210,
      this._text_211,
      this._el_212,
      this._text_213,
      this._el_214,
      this._text_215,
      this._el_216,
      this._text_217,
      this._el_218,
      this._text_219,
      this._text_220,
      this._el_221,
      this._text_222,
      this._text_223,
      this._text_224,
      this._el_225,
      this._text_226,
      this._el_227,
      this._text_228,
      this._text_229,
      this._el_230,
      this._text_231,
      this._text_232,
      this._text_233,
      this._el_234,
      this._text_235,
      this._el_236,
      this._text_237,
      this._text_238,
      this._el_239,
      this._text_240,
      this._text_241,
      this._text_242,
      this._anchor_243,
      this._text_244,
      this._anchor_245,
      this._text_246,
      this._text_247,
      this._text_248,
      this._text_249,
      this._text_250,
      this._text_251,
      this._text_252,
      this._text_253,
      this._anchor_254,
      this._text_255,
      this._text_256,
      this._text_257,
      this._el_258,
      this._text_259,
      this._el_260,
      this._text_261,
      this._el_262,
      this._text_263,
      this._el_264,
      this._text_265,
      this._el_266,
      this._text_267,
      this._el_268,
      this._text_269,
      this._anchor_270,
      this._text_271,
      this._el_272,
      this._text_273,
      this._el_274,
      this._text_275,
      this._text_276,
      this._el_277,
      this._text_278,
      this._text_279,
      this._text_280,
      this._anchor_281,
      this._text_282,
      this._el_283,
      this._text_284,
      this._el_285,
      this._text_286,
      this._text_287,
      this._el_288,
      this._text_289,
      this._text_290,
      this._text_291,
      this._anchor_292,
      this._text_293,
      this._el_294,
      this._text_295,
      this._el_296,
      this._text_297,
      this._text_298,
      this._el_299,
      this._text_300,
      this._text_301,
      this._text_302,
      this._text_303,
      this._text_304,
      this._text_305,
      this._text_306,
      this._text_307,
      this._el_308,
      this._text_309,
      this._el_310,
      this._text_311,
      this._el_312,
      this._text_313,
      this._el_314,
      this._text_315,
      this._el_316,
      this._text_317,
      this._el_318,
      this._text_319,
      this._el_320,
      this._text_321,
      this._text_322,
      this._el_323,
      this._text_324,
      this._text_325,
      this._text_326,
      this._el_327,
      this._text_328,
      this._el_329,
      this._text_330,
      this._text_331,
      this._el_332,
      this._text_333,
      this._text_334,
      this._text_335,
      this._el_336,
      this._text_337,
      this._el_338,
      this._text_339,
      this._text_340,
      this._el_341,
      this._text_342,
      this._text_343,
      this._text_344,
      this._el_345,
      this._text_346,
      this._el_347,
      this._text_348,
      this._text_349,
      this._el_350,
      this._text_351,
      this._text_352,
      this._text_353,
      this._anchor_354,
      this._text_355,
      this._anchor_356,
      this._text_357,
      this._anchor_358,
      this._text_359,
      this._anchor_360,
      this._text_361,
      this._anchor_362,
      this._text_363,
      this._anchor_364,
      this._text_365,
      this._anchor_366,
      this._text_367,
      this._el_368,
      this._text_369,
      this._el_370,
      this._text_371,
      this._text_372,
      this._el_373,
      this._text_374,
      this._el_375,
      this._text_376,
      this._text_377,
      this._text_378,
      this._anchor_379,
      this._text_380,
      this._anchor_381,
      this._text_382,
      this._anchor_383,
      this._text_384,
      this._el_385,
      this._text_386,
      this._el_387,
      this._text_388,
      this._text_389,
      this._el_390,
      this._text_391,
      this._el_392,
      this._text_393,
      this._text_394,
      this._text_395,
      this._text_396,
      this._text_397,
      this._text_398,
      this._text_399,
      this._text_400,
      this._anchor_401,
      this._text_402,
      this._text_403,
      this._text_404,
      this._text_405,
      this._el_406,
      this._text_407,
      this._el_408,
      this._text_409,
      this._el_410,
      this._text_411,
      this._el_412,
      this._text_413,
      this._text_414,
      this._el_415,
      this._text_416,
      this._el_417,
      this._text_418,
      this._el_419,
      this._el_420,
      this._text_421,
      this._el_422,
      this._text_423,
      this._text_424,
      this._text_425,
      this._text_426,
      this._el_427,
      this._text_428,
      this._el_429,
      this._text_430,
      this._el_431,
      this._el_432,
      this._text_433,
      this._el_434,
      this._text_435,
      this._text_436,
      this._text_437,
      this._text_438,
      this._el_439,
      this._text_440,
      this._el_441,
      this._text_442,
      this._el_443,
      this._el_444,
      this._text_445,
      this._el_446,
      this._text_447,
      this._text_448,
      this._text_449,
      this._text_450,
      this._text_451,
      this._el_452,
      this._text_453,
      this._el_454,
      this._text_455,
      this._el_456,
      this._el_457,
      this._text_458,
      this._text_459,
      this._anchor_460,
      this._text_461,
      this._anchor_462,
      this._text_463,
      this._anchor_464,
      this._text_465,
      this._anchor_466,
      this._text_467,
      this._anchor_468,
      this._text_469,
      this._anchor_470,
      this._text_471,
      this._el_472,
      this._el_473,
      this._text_474,
      this._text_475,
      this._text_476,
      this._el_477,
      this._text_478,
      this._anchor_479,
      this._text_480,
      this._text_481,
      this._text_482,
      this._text_483,
      this._text_484,
      this._text_485,
      this._text_486,
      this._text_487,
      this._text_488,
      this._anchor_489,
      this._text_490,
      this._text_491,
      this._text_492,
      this._anchor_493,
      this._text_494,
      this._text_495,
      this._text_496,
      this._el_497,
      this._text_498,
      this._el_499,
      this._text_500,
      this._el_501,
      this._text_502,
      this._el_503,
      this._text_504,
      this._el_505,
      this._text_506,
      this._anchor_507,
      this._text_508,
      this._el_509,
      this._text_510,
      this._el_511,
      this._text_512,
      this._el_513,
      this._text_514,
      this._text_515,
      this._el_516,
      this._text_517,
      this._text_518,
      this._text_519,
      this._text_520,
      this._text_521,
      this._text_522,
      this._text_523,
      this._text_524,
      this._text_525,
      this._text_526,
      this._text_527,
      this._el_528,
      this._text_529,
      this._el_530,
      this._text_531,
      this._el_532,
      this._text_533,
      this._el_534,
      this._text_535,
      this._el_536,
      this._text_537,
      this._text_538,
      this._text_539,
      this._text_540,
      this._el_541,
      this._text_542,
      this._el_543,
      this._text_544,
      this._el_545,
      this._text_546,
      this._el_547,
      this._text_548,
      this._el_549,
      this._text_550,
      this._text_551,
      this._el_552,
      this._text_553,
      this._text_554,
      this._text_555,
      this._el_556,
      this._text_557,
      this._el_558,
      this._text_559,
      this._text_560,
      this._el_561,
      this._text_562,
      this._text_563,
      this._text_564,
      this._text_565,
      this._text_566,
      this._text_567,
      this._text_568,
      this._el_569,
      this._text_570,
      this._el_571,
      this._text_572,
      this._el_573,
      this._text_574,
      this._el_575,
      this._text_576,
      this._text_577,
      this._text_578,
      this._text_579,
      this._el_580,
      this._text_581,
      this._el_582,
      this._text_583,
      this._el_584,
      this._text_585,
      this._el_586,
      this._text_587,
      this._el_588,
      this._text_589,
      this._text_590,
      this._el_591,
      this._text_592,
      this._text_593,
      this._text_594,
      this._anchor_595,
      this._text_596,
      this._anchor_597,
      this._text_598,
      this._text_599,
      this._text_600,
      this._text_601,
      this._el_602,
      this._text_603,
      this._el_604,
      this._text_605,
      this._el_606,
      this._text_607,
      this._text_608,
      this._text_609,
      this._text_610,
      this._el_611,
      this._text_612,
      this._el_613,
      this._text_614,
      this._el_615,
      this._text_616,
      this._el_617,
      this._text_618,
      this._el_619,
      this._text_620,
      this._text_621,
      this._el_622,
      this._text_623,
      this._text_624,
      this._text_625,
      this._el_626,
      this._text_627,
      this._el_628,
      this._text_629,
      this._text_630,
      this._el_631,
      this._text_632,
      this._text_633,
      this._text_634,
      this._text_635,
      this._text_636,
      this._text_637,
      this._text_638,
      this._el_639,
      this._text_640,
      this._el_641,
      this._text_642,
      this._el_643,
      this._text_644,
      this._el_645,
      this._text_646,
      this._text_647,
      this._text_648,
      this._text_649,
      this._el_650,
      this._text_651,
      this._el_652,
      this._text_653,
      this._el_654,
      this._text_655,
      this._el_656,
      this._text_657,
      this._text_658,
      this._el_659,
      this._text_660,
      this._el_661,
      this._text_662,
      this._text_663,
      this._text_664,
      this._text_665,
      this._text_666,
      this._text_667,
      this._anchor_668,
      this._text_669,
      this._anchor_670,
      this._text_671,
      this._text_672,
      this._text_673,
      this._text_674,
      this._text_675,
      this._el_676,
      this._text_677,
      this._el_678,
      this._text_679,
      this._el_680,
      this._text_681,
      this._text_682,
      this._text_683,
      this._text_684
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (101 === requestNodeIndex))) { return this._TemplateRef_101_5; }
    if (((token === import23.NgIf) && (101 === requestNodeIndex))) { return this._NgIf_101_6.context; }
    if (((token === import32.GAService) && (110 === requestNodeIndex))) { return this._GAService_110_3; }
    if (((token === import33.MobileService) && (110 === requestNodeIndex))) { return this._MobileService_110_4; }
    if (((token === import5.BookingService) && (110 === requestNodeIndex))) { return this._BookingService_110_5; }
    if (((token === import31.EmailTooltipComponent) && (110 === requestNodeIndex))) { return this._EmailTooltipComponent_110_6.context; }
    if (((token === import22.TemplateRef) && (184 === requestNodeIndex))) { return this._TemplateRef_184_5; }
    if (((token === import23.NgIf) && (184 === requestNodeIndex))) { return this._NgIf_184_6.context; }
    if (((token === import22.TemplateRef) && (186 === requestNodeIndex))) { return this._TemplateRef_186_5; }
    if (((token === import23.NgIf) && (186 === requestNodeIndex))) { return this._NgIf_186_6.context; }
    if (((token === import22.TemplateRef) && (188 === requestNodeIndex))) { return this._TemplateRef_188_5; }
    if (((token === import23.NgIf) && (188 === requestNodeIndex))) { return this._NgIf_188_6.context; }
    if (((token === import22.TemplateRef) && (243 === requestNodeIndex))) { return this._TemplateRef_243_5; }
    if (((token === import23.NgIf) && (243 === requestNodeIndex))) { return this._NgIf_243_6.context; }
    if (((token === import22.TemplateRef) && (245 === requestNodeIndex))) { return this._TemplateRef_245_5; }
    if (((token === import23.NgIf) && (245 === requestNodeIndex))) { return this._NgIf_245_6.context; }
    if (((token === import22.TemplateRef) && (254 === requestNodeIndex))) { return this._TemplateRef_254_5; }
    if (((token === import23.NgIf) && (254 === requestNodeIndex))) { return this._NgIf_254_6.context; }
    if (((token === import22.TemplateRef) && (270 === requestNodeIndex))) { return this._TemplateRef_270_5; }
    if (((token === import23.NgIf) && (270 === requestNodeIndex))) { return this._NgIf_270_6.context; }
    if (((token === import22.TemplateRef) && (281 === requestNodeIndex))) { return this._TemplateRef_281_5; }
    if (((token === import30.NgFor) && (281 === requestNodeIndex))) { return this._NgFor_281_6.context; }
    if (((token === import22.TemplateRef) && (292 === requestNodeIndex))) { return this._TemplateRef_292_5; }
    if (((token === import23.NgIf) && (292 === requestNodeIndex))) { return this._NgIf_292_6.context; }
    if (((token === import22.TemplateRef) && (354 === requestNodeIndex))) { return this._TemplateRef_354_5; }
    if (((token === import23.NgIf) && (354 === requestNodeIndex))) { return this._NgIf_354_6.context; }
    if (((token === import22.TemplateRef) && (356 === requestNodeIndex))) { return this._TemplateRef_356_5; }
    if (((token === import23.NgIf) && (356 === requestNodeIndex))) { return this._NgIf_356_6.context; }
    if (((token === import22.TemplateRef) && (358 === requestNodeIndex))) { return this._TemplateRef_358_5; }
    if (((token === import23.NgIf) && (358 === requestNodeIndex))) { return this._NgIf_358_6.context; }
    if (((token === import22.TemplateRef) && (360 === requestNodeIndex))) { return this._TemplateRef_360_5; }
    if (((token === import23.NgIf) && (360 === requestNodeIndex))) { return this._NgIf_360_6.context; }
    if (((token === import22.TemplateRef) && (362 === requestNodeIndex))) { return this._TemplateRef_362_5; }
    if (((token === import23.NgIf) && (362 === requestNodeIndex))) { return this._NgIf_362_6.context; }
    if (((token === import22.TemplateRef) && (364 === requestNodeIndex))) { return this._TemplateRef_364_5; }
    if (((token === import23.NgIf) && (364 === requestNodeIndex))) { return this._NgIf_364_6.context; }
    if (((token === import22.TemplateRef) && (366 === requestNodeIndex))) { return this._TemplateRef_366_5; }
    if (((token === import23.NgIf) && (366 === requestNodeIndex))) { return this._NgIf_366_6.context; }
    if (((token === import22.TemplateRef) && (379 === requestNodeIndex))) { return this._TemplateRef_379_5; }
    if (((token === import23.NgIf) && (379 === requestNodeIndex))) { return this._NgIf_379_6.context; }
    if (((token === import22.TemplateRef) && (381 === requestNodeIndex))) { return this._TemplateRef_381_5; }
    if (((token === import23.NgIf) && (381 === requestNodeIndex))) { return this._NgIf_381_6.context; }
    if (((token === import22.TemplateRef) && (383 === requestNodeIndex))) { return this._TemplateRef_383_5; }
    if (((token === import23.NgIf) && (383 === requestNodeIndex))) { return this._NgIf_383_6.context; }
    if (((token === import22.TemplateRef) && (401 === requestNodeIndex))) { return this._TemplateRef_401_5; }
    if (((token === import23.NgIf) && (401 === requestNodeIndex))) { return this._NgIf_401_6.context; }
    if (((token === import22.TemplateRef) && (460 === requestNodeIndex))) { return this._TemplateRef_460_5; }
    if (((token === import23.NgIf) && (460 === requestNodeIndex))) { return this._NgIf_460_6.context; }
    if (((token === import22.TemplateRef) && (462 === requestNodeIndex))) { return this._TemplateRef_462_5; }
    if (((token === import23.NgIf) && (462 === requestNodeIndex))) { return this._NgIf_462_6.context; }
    if (((token === import22.TemplateRef) && (464 === requestNodeIndex))) { return this._TemplateRef_464_5; }
    if (((token === import23.NgIf) && (464 === requestNodeIndex))) { return this._NgIf_464_6.context; }
    if (((token === import22.TemplateRef) && (466 === requestNodeIndex))) { return this._TemplateRef_466_5; }
    if (((token === import23.NgIf) && (466 === requestNodeIndex))) { return this._NgIf_466_6.context; }
    if (((token === import22.TemplateRef) && (468 === requestNodeIndex))) { return this._TemplateRef_468_5; }
    if (((token === import23.NgIf) && (468 === requestNodeIndex))) { return this._NgIf_468_6.context; }
    if (((token === import22.TemplateRef) && (470 === requestNodeIndex))) { return this._TemplateRef_470_5; }
    if (((token === import23.NgIf) && (470 === requestNodeIndex))) { return this._NgIf_470_6.context; }
    if (((token === import22.TemplateRef) && (479 === requestNodeIndex))) { return this._TemplateRef_479_5; }
    if (((token === import30.NgFor) && (479 === requestNodeIndex))) { return this._NgFor_479_6.context; }
    if (((token === import22.TemplateRef) && (489 === requestNodeIndex))) { return this._TemplateRef_489_5; }
    if (((token === import23.NgIf) && (489 === requestNodeIndex))) { return this._NgIf_489_6.context; }
    if (((token === import22.TemplateRef) && (493 === requestNodeIndex))) { return this._TemplateRef_493_5; }
    if (((token === import23.NgIf) && (493 === requestNodeIndex))) { return this._NgIf_493_6.context; }
    if (((token === import22.TemplateRef) && (507 === requestNodeIndex))) { return this._TemplateRef_507_5; }
    if (((token === import30.NgFor) && (507 === requestNodeIndex))) { return this._NgFor_507_6.context; }
    if (((token === import22.TemplateRef) && (595 === requestNodeIndex))) { return this._TemplateRef_595_5; }
    if (((token === import23.NgIf) && (595 === requestNodeIndex))) { return this._NgIf_595_6.context; }
    if (((token === import22.TemplateRef) && (597 === requestNodeIndex))) { return this._TemplateRef_597_5; }
    if (((token === import23.NgIf) && (597 === requestNodeIndex))) { return this._NgIf_597_6.context; }
    if (((token === import22.TemplateRef) && (668 === requestNodeIndex))) { return this._TemplateRef_668_5; }
    if (((token === import23.NgIf) && (668 === requestNodeIndex))) { return this._NgIf_668_6.context; }
    if (((token === import22.TemplateRef) && (670 === requestNodeIndex))) { return this._TemplateRef_670_5; }
    if (((token === import23.NgIf) && (670 === requestNodeIndex))) { return this._NgIf_670_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    const currVal_101_0_0:any = (this.parentView.context.bookingDetail.airline != (null as any));
    this._NgIf_101_6.check_ngIf(currVal_101_0_0,throwOnChange,false);
    this._NgIf_101_6.ngDoCheck(this,this._anchor_101,throwOnChange);
    const currVal_110_0_0:any = this.parentView.context.bookingOid;
    this._EmailTooltipComponent_110_6.check_bookingOid(currVal_110_0_0,throwOnChange,false);
    const currVal_110_0_1:any = this.parentView.context.companyOid;
    this._EmailTooltipComponent_110_6.check_companyOid(currVal_110_0_1,throwOnChange,false);
    const currVal_110_0_2:any = 'Contactar_PAX_Detalle';
    this._EmailTooltipComponent_110_6.check_gaValue(currVal_110_0_2,throwOnChange,false);
    this._EmailTooltipComponent_110_6.ngDoCheck(this,this._el_110,throwOnChange);
    const currVal_184_0_0:any = this.parentView.context.isPhoneReq;
    this._NgIf_184_6.check_ngIf(currVal_184_0_0,throwOnChange,false);
    this._NgIf_184_6.ngDoCheck(this,this._anchor_184,throwOnChange);
    const currVal_186_0_0:boolean = !this.parentView.context.isPhoneReq;
    this._NgIf_186_6.check_ngIf(currVal_186_0_0,throwOnChange,false);
    this._NgIf_186_6.ngDoCheck(this,this._anchor_186,throwOnChange);
    const currVal_188_0_0:any = ((this.parentView.context.bookingDetail.meetingType && (this.parentView.context.bookingDetail.meetingType != 'NO_INFO')) && (this.parentView.context.bookingDetail.pickUpPointType == 'AIRPORT'));
    this._NgIf_188_6.check_ngIf(currVal_188_0_0,throwOnChange,false);
    this._NgIf_188_6.ngDoCheck(this,this._anchor_188,throwOnChange);
    const currVal_243_0_0:any = this.parentView.context.isPhoneReq;
    this._NgIf_243_6.check_ngIf(currVal_243_0_0,throwOnChange,false);
    this._NgIf_243_6.ngDoCheck(this,this._anchor_243,throwOnChange);
    const currVal_245_0_0:boolean = !this.parentView.context.isPhoneReq;
    this._NgIf_245_6.check_ngIf(currVal_245_0_0,throwOnChange,false);
    this._NgIf_245_6.ngDoCheck(this,this._anchor_245,throwOnChange);
    const currVal_254_0_0:any = (((this.parentView.context.bookingHistories != (null as any)) && (this.parentView.context.bookingHistories.length > 0)) && this.parentView.context.historyVisible);
    this._NgIf_254_6.check_ngIf(currVal_254_0_0,throwOnChange,false);
    this._NgIf_254_6.ngDoCheck(this,this._anchor_254,throwOnChange);
    const currVal_270_0_0:any = ((this.parentView.context.bookingDetail.dailyPrice != (null as any)) && !this.parentView.context.hasSpecialOffer);
    this._NgIf_270_6.check_ngIf(currVal_270_0_0,throwOnChange,false);
    this._NgIf_270_6.ngDoCheck(this,this._anchor_270,throwOnChange);
    const currVal_281_0_0:any = this.parentView.context.bookingDetail.bookedCharges;
    this._NgFor_281_6.check_ngForOf(currVal_281_0_0,throwOnChange,false);
    this._NgFor_281_6.ngDoCheck(this,this._anchor_281,throwOnChange);
    const currVal_292_0_0:any = (this.parentView.context.bookingDetail.bookedInsurancesBaseAmount > 0);
    this._NgIf_292_6.check_ngIf(currVal_292_0_0,throwOnChange,false);
    this._NgIf_292_6.ngDoCheck(this,this._anchor_292,throwOnChange);
    const currVal_354_0_0:any = (this.parentView.context.bookingDetail.percentageAdditionalChargesAmount > 0);
    this._NgIf_354_6.check_ngIf(currVal_354_0_0,throwOnChange,false);
    this._NgIf_354_6.ngDoCheck(this,this._anchor_354,throwOnChange);
    const currVal_356_0_0:any = (this.parentView.context.bookingDetail.fixedAmountAdditionalCharges > 0);
    this._NgIf_356_6.check_ngIf(currVal_356_0_0,throwOnChange,false);
    this._NgIf_356_6.ngDoCheck(this,this._anchor_356,throwOnChange);
    const currVal_358_0_0:any = (this.parentView.context.bookingDetail.bookedAssuredAdditionalsCost > 0);
    this._NgIf_358_6.check_ngIf(currVal_358_0_0,throwOnChange,false);
    this._NgIf_358_6.ngDoCheck(this,this._anchor_358,throwOnChange);
    const currVal_360_0_0:any = (this.parentView.context.bookingDetail.bookedAssuredAdditionalsIvaCost > 0);
    this._NgIf_360_6.check_ngIf(currVal_360_0_0,throwOnChange,false);
    this._NgIf_360_6.ngDoCheck(this,this._anchor_360,throwOnChange);
    const currVal_362_0_0:any = (this.parentView.context.bookingDetail.bookedAssuredAdditionalsPercentageFeesAmount > 0);
    this._NgIf_362_6.check_ngIf(currVal_362_0_0,throwOnChange,false);
    this._NgIf_362_6.ngDoCheck(this,this._anchor_362,throwOnChange);
    const currVal_364_0_0:any = (this.parentView.context.bookingDetail.ageChargePrice > 0);
    this._NgIf_364_6.check_ngIf(currVal_364_0_0,throwOnChange,false);
    this._NgIf_364_6.ngDoCheck(this,this._anchor_364,throwOnChange);
    const currVal_366_0_0:any = (this.parentView.context.bookingDetail.paymentMethod != 'PREPAYMENT');
    this._NgIf_366_6.check_ngIf(currVal_366_0_0,throwOnChange,false);
    this._NgIf_366_6.ngDoCheck(this,this._anchor_366,throwOnChange);
    const currVal_379_0_0:any = ((this.parentView.context.bookingDetail.paymentMethod == 'PREPAYMENT_COMMISSION') && (this.parentView.context.bookingDetail.totalToPayAtDestination > 0));
    this._NgIf_379_6.check_ngIf(currVal_379_0_0,throwOnChange,false);
    this._NgIf_379_6.ngDoCheck(this,this._anchor_379,throwOnChange);
    const currVal_381_0_0:any = ((this.parentView.context.bookingDetail.paymentMethod == 'PREPAYMENT') && (this.parentView.context.bookingDetail.settlementPrice > 0));
    this._NgIf_381_6.check_ngIf(currVal_381_0_0,throwOnChange,false);
    this._NgIf_381_6.ngDoCheck(this,this._anchor_381,throwOnChange);
    const currVal_383_0_0:any = ((this.parentView.context.bookingDetail.paymentMethod == 'PREPAYMENT') && (this.parentView.context.bookingDetail.ageChargePrice > 0));
    this._NgIf_383_6.check_ngIf(currVal_383_0_0,throwOnChange,false);
    this._NgIf_383_6.ngDoCheck(this,this._anchor_383,throwOnChange);
    const currVal_401_0_0:any = ((this.parentView.context.bookingDetail.paymentMethod == 'PREPAYMENT_COMMISSION') || (this.parentView.context.bookingDetail.paymentMethod == 'PREPAYMENT'));
    this._NgIf_401_6.check_ngIf(currVal_401_0_0,throwOnChange,false);
    this._NgIf_401_6.ngDoCheck(this,this._anchor_401,throwOnChange);
    const currVal_460_0_0:any = this.parentView.context.isCommissionableOrMarkupVisible(this.parentView.context.permViewMarkup,this.parentView.context.bookingDetail.commissionType);
    this._NgIf_460_6.check_ngIf(currVal_460_0_0,throwOnChange,false);
    this._NgIf_460_6.ngDoCheck(this,this._anchor_460,throwOnChange);
    const currVal_462_0_0:any = this.parentView.context.hasSpecialOffer;
    this._NgIf_462_6.check_ngIf(currVal_462_0_0,throwOnChange,false);
    this._NgIf_462_6.ngDoCheck(this,this._anchor_462,throwOnChange);
    const currVal_464_0_0:any = this.parentView.context.hasSpecialOffer;
    this._NgIf_464_6.check_ngIf(currVal_464_0_0,throwOnChange,false);
    this._NgIf_464_6.ngDoCheck(this,this._anchor_464,throwOnChange);
    const currVal_466_0_0:any = this.parentView.context.hasSpecialOffer;
    this._NgIf_466_6.check_ngIf(currVal_466_0_0,throwOnChange,false);
    this._NgIf_466_6.ngDoCheck(this,this._anchor_466,throwOnChange);
    const currVal_468_0_0:any = this.parentView.context.hasOpaqueDiscount;
    this._NgIf_468_6.check_ngIf(currVal_468_0_0,throwOnChange,false);
    this._NgIf_468_6.ngDoCheck(this,this._anchor_468,throwOnChange);
    const currVal_470_0_0:any = this.parentView.context.hasOpaqueDiscount;
    this._NgIf_470_6.check_ngIf(currVal_470_0_0,throwOnChange,false);
    this._NgIf_470_6.ngDoCheck(this,this._anchor_470,throwOnChange);
    const currVal_479_0_0:any = this.parentView.context.bookingDetail.bookedPricesDto;
    this._NgFor_479_6.check_ngForOf(currVal_479_0_0,throwOnChange,false);
    this._NgFor_479_6.ngDoCheck(this,this._anchor_479,throwOnChange);
    const currVal_489_0_0:any = (this.parentView.context.bookingDetail.additionalsExcludedFromTotal.length > 0);
    this._NgIf_489_6.check_ngIf(currVal_489_0_0,throwOnChange,false);
    this._NgIf_489_6.ngDoCheck(this,this._anchor_489,throwOnChange);
    const currVal_493_0_0:any = (this.parentView.context.bookingDetail.additionalsIncludedOnTotal.length > 0);
    this._NgIf_493_6.check_ngIf(currVal_493_0_0,throwOnChange,false);
    this._NgIf_493_6.ngDoCheck(this,this._anchor_493,throwOnChange);
    const currVal_507_0_0:any = this.parentView.context.bookingDetail.additionalCharges;
    this._NgFor_507_6.check_ngForOf(currVal_507_0_0,throwOnChange,false);
    this._NgFor_507_6.ngDoCheck(this,this._anchor_507,throwOnChange);
    const currVal_595_0_0:any = this.parentView.context.upgradeCar;
    this._NgIf_595_6.check_ngIf(currVal_595_0_0,throwOnChange,false);
    this._NgIf_595_6.ngDoCheck(this,this._anchor_595,throwOnChange);
    const currVal_597_0_0:any = (this.parentView.context.bookingDetail.distanceUnit != (null as any));
    this._NgIf_597_6.check_ngIf(currVal_597_0_0,throwOnChange,false);
    this._NgIf_597_6.ngDoCheck(this,this._anchor_597,throwOnChange);
    const currVal_668_0_0:any = ((this.parentView.context.bookingDetail.status == 'CANCELED') || (this.parentView.context.bookingDetail.status == 'REVERTED'));
    this._NgIf_668_6.check_ngIf(currVal_668_0_0,throwOnChange,false);
    this._NgIf_668_6.ngDoCheck(this,this._anchor_668,throwOnChange);
    const currVal_670_0_0:any = ((this.parentView.context.bookingDetail.status == 'BOOKED') || (this.parentView.context.bookingDetail.status == 'MODIFIED'));
    this._NgIf_670_6.check_ngIf(currVal_670_0_0,throwOnChange,false);
    this._NgIf_670_6.ngDoCheck(this,this._anchor_670,throwOnChange);
    this._vc_101.detectChangesInNestedViews(throwOnChange);
    this._vc_184.detectChangesInNestedViews(throwOnChange);
    this._vc_186.detectChangesInNestedViews(throwOnChange);
    this._vc_188.detectChangesInNestedViews(throwOnChange);
    this._vc_243.detectChangesInNestedViews(throwOnChange);
    this._vc_245.detectChangesInNestedViews(throwOnChange);
    this._vc_254.detectChangesInNestedViews(throwOnChange);
    this._vc_270.detectChangesInNestedViews(throwOnChange);
    this._vc_281.detectChangesInNestedViews(throwOnChange);
    this._vc_292.detectChangesInNestedViews(throwOnChange);
    this._vc_354.detectChangesInNestedViews(throwOnChange);
    this._vc_356.detectChangesInNestedViews(throwOnChange);
    this._vc_358.detectChangesInNestedViews(throwOnChange);
    this._vc_360.detectChangesInNestedViews(throwOnChange);
    this._vc_362.detectChangesInNestedViews(throwOnChange);
    this._vc_364.detectChangesInNestedViews(throwOnChange);
    this._vc_366.detectChangesInNestedViews(throwOnChange);
    this._vc_379.detectChangesInNestedViews(throwOnChange);
    this._vc_381.detectChangesInNestedViews(throwOnChange);
    this._vc_383.detectChangesInNestedViews(throwOnChange);
    this._vc_401.detectChangesInNestedViews(throwOnChange);
    this._vc_460.detectChangesInNestedViews(throwOnChange);
    this._vc_462.detectChangesInNestedViews(throwOnChange);
    this._vc_464.detectChangesInNestedViews(throwOnChange);
    this._vc_466.detectChangesInNestedViews(throwOnChange);
    this._vc_468.detectChangesInNestedViews(throwOnChange);
    this._vc_470.detectChangesInNestedViews(throwOnChange);
    this._vc_479.detectChangesInNestedViews(throwOnChange);
    this._vc_489.detectChangesInNestedViews(throwOnChange);
    this._vc_493.detectChangesInNestedViews(throwOnChange);
    this._vc_507.detectChangesInNestedViews(throwOnChange);
    this._vc_595.detectChangesInNestedViews(throwOnChange);
    this._vc_597.detectChangesInNestedViews(throwOnChange);
    this._vc_668.detectChangesInNestedViews(throwOnChange);
    this._vc_670.detectChangesInNestedViews(throwOnChange);
    if (!throwOnChange) { this._EmailTooltipComponent_110_6.context.ngAfterContentChecked(); }
    const currVal_795:any = import3.inlineInterpolate(2,'-eva-3-tc-',this.parentView.context.bookingStatusColor,'-',this.parentView.context.bookingStatusNumber,' -eva-3-tc');
    if (import3.checkBinding(throwOnChange,this._expr_795,currVal_795)) {
      this.renderer.setElementProperty(this._el_16,'className',currVal_795);
      this._expr_795 = currVal_795;
    }
    valUnwrapper.reset();
    const currVal_796:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.BOOKING')),' ',valUnwrapper.unwrap(this._pipe_translate_1.transform(('bookingDetail.' + this.parentView.context.bookingDetail.status))),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_796,currVal_796))) {
      this.renderer.setText(this._text_17,currVal_796);
      this._expr_796 = currVal_796;
    }
    valUnwrapper.reset();
    const currVal_799:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('bookingDetail.PASSENGER_INFO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_799,currVal_799))) {
      this.renderer.setText(this._text_44,currVal_799);
      this._expr_799 = currVal_799;
    }
    valUnwrapper.reset();
    const currVal_801:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('bookingDetail.PASSENGER_NAME')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_801,currVal_801))) {
      this.renderer.setText(this._text_56,currVal_801);
      this._expr_801 = currVal_801;
    }
    const currVal_803:any = import3.inlineInterpolate(2,'',this.parentView.context.bookingDetail.username,' ',this.parentView.context.bookingDetail.lastname,'');
    if (import3.checkBinding(throwOnChange,this._expr_803,currVal_803)) {
      this.renderer.setText(this._text_59,currVal_803);
      this._expr_803 = currVal_803;
    }
    valUnwrapper.reset();
    const currVal_804:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('bookingDetail.PASSENGER_PHONE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_804,currVal_804))) {
      this.renderer.setText(this._text_65,currVal_804);
      this._expr_804 = currVal_804;
    }
    const currVal_806:any = import3.inlineInterpolate(1,'',this.parentView.context.bookingDetail.phoneNumber,'');
    if (import3.checkBinding(throwOnChange,this._expr_806,currVal_806)) {
      this.renderer.setText(this._text_68,currVal_806);
      this._expr_806 = currVal_806;
    }
    valUnwrapper.reset();
    const currVal_807:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('bookingDetail.SITE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_807,currVal_807))) {
      this.renderer.setText(this._text_74,currVal_807);
      this._expr_807 = currVal_807;
    }
    const currVal_809:any = import3.inlineInterpolate(1,'',(this.parentView.context.isDefined(this.parentView.context.bookingDetail.searchCountryName)? this.parentView.context.bookingDetail.searchCountryName: 'Despegar Intl'),'');
    if (import3.checkBinding(throwOnChange,this._expr_809,currVal_809)) {
      this.renderer.setText(this._text_77,currVal_809);
      this._expr_809 = currVal_809;
    }
    valUnwrapper.reset();
    const currVal_810:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('bookingDetail.ID')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_810,currVal_810))) {
      this.renderer.setText(this._text_83,currVal_810);
      this._expr_810 = currVal_810;
    }
    const currVal_812:any = import3.inlineInterpolate(1,'',this.parentView.context.bookingDetail.oid,'');
    if (import3.checkBinding(throwOnChange,this._expr_812,currVal_812)) {
      this.renderer.setText(this._text_86,currVal_812);
      this._expr_812 = currVal_812;
    }
    valUnwrapper.reset();
    const currVal_813:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('bookingDetail.FENIX_ID')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_813,currVal_813))) {
      this.renderer.setText(this._text_92,currVal_813);
      this._expr_813 = currVal_813;
    }
    const currVal_815:any = import3.inlineInterpolate(1,'',this.parentView.context.bookingDetail.fenixOid,'');
    if (import3.checkBinding(throwOnChange,this._expr_815,currVal_815)) {
      this.renderer.setText(this._text_95,currVal_815);
      this._expr_815 = currVal_815;
    }
    valUnwrapper.reset();
    const currVal_816:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_8.transform('bookingDetail.PUP')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_816,currVal_816))) {
      this.renderer.setText(this._text_139,currVal_816);
      this._expr_816 = currVal_816;
    }
    valUnwrapper.reset();
    const currVal_818:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_9.transform('bookingDetail.PICKUP_DATE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_818,currVal_818))) {
      this.renderer.setText(this._text_151,currVal_818);
      this._expr_818 = currVal_818;
    }
    valUnwrapper.reset();
    const currVal_820:any = import3.inlineInterpolate(4,'',this.parentView.context.getDate(this.parentView.context.bookingDetail.period.from),' ',valUnwrapper.unwrap(this._pipe_translate_10.transform(('common.month.short.' + this.parentView.context.getMonth(this.parentView.context.bookingDetail.period.from)))),' ',this.parentView.context.getYear(this.parentView.context.bookingDetail.period.from),' -  ',this.parentView.context.getHour(this.parentView.context.bookingDetail.period.from),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_820,currVal_820))) {
      this.renderer.setText(this._text_154,currVal_820);
      this._expr_820 = currVal_820;
    }
    valUnwrapper.reset();
    const currVal_822:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_11.transform('bookingDetail.AMOUNT_DAYS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_822,currVal_822))) {
      this.renderer.setText(this._text_160,currVal_822);
      this._expr_822 = currVal_822;
    }
    valUnwrapper.reset();
    const currVal_824:any = import3.inlineInterpolate(2,'',this.parentView.context.bookingDetail.totalDays,' ',((this.parentView.context.bookingDetail.totalDays > 1)? valUnwrapper.unwrap(this._pipe_translate_12.transform('bookingDetail.PUP_DAYS')): valUnwrapper.unwrap(this._pipe_translate_13.transform('bookingDetail.PUP_DAY'))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_824,currVal_824))) {
      this.renderer.setText(this._text_163,currVal_824);
      this._expr_824 = currVal_824;
    }
    valUnwrapper.reset();
    const currVal_827:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_14.transform('bookingDetail.POINT.NAME')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_827,currVal_827))) {
      this.renderer.setText(this._text_169,currVal_827);
      this._expr_827 = currVal_827;
    }
    const currVal_829:any = import3.inlineInterpolate(1,'',this.parentView.context.bookingDetail.pickupPoint.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_829,currVal_829)) {
      this.renderer.setText(this._text_172,currVal_829);
      this._expr_829 = currVal_829;
    }
    valUnwrapper.reset();
    const currVal_830:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_15.transform('bookingDetail.POINT.ADDRESS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_830,currVal_830))) {
      this.renderer.setText(this._text_178,currVal_830);
      this._expr_830 = currVal_830;
    }
    const currVal_832:any = import3.inlineInterpolate(2,'',(this.parentView.context.isDefined(this.parentView.context.bookingDetail.pickupPoint.street)? (this.parentView.context.bookingDetail.pickupPoint.street + ' / '): ''),' ',this.parentView.context.bookingDetail.pickupPoint.locationName,'');
    if (import3.checkBinding(throwOnChange,this._expr_832,currVal_832)) {
      this.renderer.setText(this._text_181,currVal_832);
      this._expr_832 = currVal_832;
    }
    valUnwrapper.reset();
    const currVal_833:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_16.transform('bookingDetail.DOP')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_833,currVal_833))) {
      this.renderer.setText(this._text_207,currVal_833);
      this._expr_833 = currVal_833;
    }
    valUnwrapper.reset();
    const currVal_835:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_17.transform('bookingDetail.DROPOFF_DATE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_835,currVal_835))) {
      this.renderer.setText(this._text_219,currVal_835);
      this._expr_835 = currVal_835;
    }
    valUnwrapper.reset();
    const currVal_837:any = import3.inlineInterpolate(4,'',this.parentView.context.getDate(this.parentView.context.bookingDetail.period.to),' ',valUnwrapper.unwrap(this._pipe_translate_18.transform(('common.month.short.' + this.parentView.context.getMonth(this.parentView.context.bookingDetail.period.to)))),' ',this.parentView.context.getYear(this.parentView.context.bookingDetail.period.to),' -  ',this.parentView.context.getHour(this.parentView.context.bookingDetail.period.to),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_837,currVal_837))) {
      this.renderer.setText(this._text_222,currVal_837);
      this._expr_837 = currVal_837;
    }
    valUnwrapper.reset();
    const currVal_839:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_19.transform('bookingDetail.POINT.NAME')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_839,currVal_839))) {
      this.renderer.setText(this._text_228,currVal_839);
      this._expr_839 = currVal_839;
    }
    const currVal_841:any = import3.inlineInterpolate(1,'',this.parentView.context.bookingDetail.dropoffPoint.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_841,currVal_841)) {
      this.renderer.setText(this._text_231,currVal_841);
      this._expr_841 = currVal_841;
    }
    valUnwrapper.reset();
    const currVal_842:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_20.transform('bookingDetail.POINT.ADDRESS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_842,currVal_842))) {
      this.renderer.setText(this._text_237,currVal_842);
      this._expr_842 = currVal_842;
    }
    const currVal_844:any = import3.inlineInterpolate(2,'',(this.parentView.context.isDefined(this.parentView.context.bookingDetail.dropoffPoint.street)? (this.parentView.context.bookingDetail.dropoffPoint.street + ' / '): ''),' ',this.parentView.context.bookingDetail.dropoffPoint.locationName,'');
    if (import3.checkBinding(throwOnChange,this._expr_844,currVal_844)) {
      this.renderer.setText(this._text_240,currVal_844);
      this._expr_844 = currVal_844;
    }
    valUnwrapper.reset();
    const currVal_845:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_21.transform('bookingDetail.RATE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_845,currVal_845))) {
      this.renderer.setElementProperty(this._el_258,'label',currVal_845);
      this._expr_845 = currVal_845;
    }
    valUnwrapper.reset();
    const currVal_847:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_22.transform('bookingDetail.RATE.BASE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_847,currVal_847))) {
      this.renderer.setText(this._text_275,currVal_847);
      this._expr_847 = currVal_847;
    }
    const currVal_849:any = import3.inlineInterpolate(2,'',this.parentView.context.bookingDetail.currencyCode,' ',this.parentView.context.bookingDetail.carBaseAmount,'');
    if (import3.checkBinding(throwOnChange,this._expr_849,currVal_849)) {
      this.renderer.setText(this._text_278,currVal_849);
      this._expr_849 = currVal_849;
    }
    valUnwrapper.reset();
    const currVal_850:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_23.transform('bookingDetail.INSURANCES')),' (',this.parentView.context.bookingDetail.includedInsurances.join(),')');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_850,currVal_850))) {
      this.renderer.setText(this._text_286,currVal_850);
      this._expr_850 = currVal_850;
    }
    const currVal_852:any = import3.inlineInterpolate(1,'',this.parentView.context.bookingDetail.currencyCode,' 0.00');
    if (import3.checkBinding(throwOnChange,this._expr_852,currVal_852)) {
      this.renderer.setText(this._text_289,currVal_852);
      this._expr_852 = currVal_852;
    }
    valUnwrapper.reset();
    const currVal_853:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_24.transform('bookingDetail.COMMISIONABLE_BASE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_853,currVal_853))) {
      this.renderer.setText(this._text_297,currVal_853);
      this._expr_853 = currVal_853;
    }
    const currVal_855:any = import3.inlineInterpolate(2,'',this.parentView.context.bookingDetail.currencyCode,' ',this.parentView.context.bookingDetail.commissionableBase,'');
    if (import3.checkBinding(throwOnChange,this._expr_855,currVal_855)) {
      this.renderer.setText(this._text_300,currVal_855);
      this._expr_855 = currVal_855;
    }
    const currVal_856:boolean = !(this.parentView.context.permViewMarkup || (this.parentView.context.bookingDetail.commissionType == 'COMMISSIONABLE'));
    if (import3.checkBinding(throwOnChange,this._expr_856,currVal_856)) {
      this.renderer.setElementProperty(this._el_318,'hidden',currVal_856);
      this._expr_856 = currVal_856;
    }
    valUnwrapper.reset();
    const currVal_857:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_25.transform(('bookingDetail.COMMISION.' + this.parentView.context.bookingDetail.commissionType))),' (',this.parentView.context.bookingDetail.commissionPercentage,'%)');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_857,currVal_857))) {
      this.renderer.setText(this._text_321,currVal_857);
      this._expr_857 = currVal_857;
    }
    const currVal_859:any = import3.inlineInterpolate(2,'',this.parentView.context.bookingDetail.currencyCode,' ',this.parentView.context.bookingDetail.commissionAmount,'');
    if (import3.checkBinding(throwOnChange,this._expr_859,currVal_859)) {
      this.renderer.setText(this._text_324,currVal_859);
      this._expr_859 = currVal_859;
    }
    const currVal_860:boolean = !(this.parentView.context.permViewMarkup || (this.parentView.context.bookingDetail.commissionType == 'COMMISSIONABLE'));
    if (import3.checkBinding(throwOnChange,this._expr_860,currVal_860)) {
      this.renderer.setElementProperty(this._el_327,'hidden',currVal_860);
      this._expr_860 = currVal_860;
    }
    valUnwrapper.reset();
    const currVal_861:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_26.transform(('bookingDetail.VAT_COMMISION.' + this.parentView.context.bookingDetail.commissionType))),' (',this.parentView.context.bookingDetail.ivaCommissionPercentage,'%)');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_861,currVal_861))) {
      this.renderer.setText(this._text_330,currVal_861);
      this._expr_861 = currVal_861;
    }
    const currVal_863:any = import3.inlineInterpolate(2,'',this.parentView.context.bookingDetail.currencyCode,' ',this.parentView.context.bookingDetail.ivaCommissionAmount,'');
    if (import3.checkBinding(throwOnChange,this._expr_863,currVal_863)) {
      this.renderer.setText(this._text_333,currVal_863);
      this._expr_863 = currVal_863;
    }
    valUnwrapper.reset();
    const currVal_864:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_27.transform('bookingDetail.COST')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_864,currVal_864))) {
      this.renderer.setText(this._text_339,currVal_864);
      this._expr_864 = currVal_864;
    }
    const currVal_866:any = import3.inlineInterpolate(2,'',this.parentView.context.bookingDetail.currencyCode,' ',this.parentView.context.bookingDetail.costAmount,'');
    if (import3.checkBinding(throwOnChange,this._expr_866,currVal_866)) {
      this.renderer.setText(this._text_342,currVal_866);
      this._expr_866 = currVal_866;
    }
    valUnwrapper.reset();
    const currVal_867:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_28.transform('bookingDetail.VAT_COST')),' (',this.parentView.context.bookingDetail.ivaCostPercentage,'%)');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_867,currVal_867))) {
      this.renderer.setText(this._text_348,currVal_867);
      this._expr_867 = currVal_867;
    }
    const currVal_869:any = import3.inlineInterpolate(2,'',this.parentView.context.bookingDetail.currencyCode,' ',this.parentView.context.bookingDetail.ivaCostAmount,'');
    if (import3.checkBinding(throwOnChange,this._expr_869,currVal_869)) {
      this.renderer.setText(this._text_351,currVal_869);
      this._expr_869 = currVal_869;
    }
    const currVal_870:boolean = !(this.parentView.context.permViewMarkup || (this.parentView.context.bookingDetail.commissionType == 'COMMISSIONABLE'));
    if (import3.checkBinding(throwOnChange,this._expr_870,currVal_870)) {
      this.renderer.setElementProperty(this._el_368,'hidden',currVal_870);
      this._expr_870 = currVal_870;
    }
    valUnwrapper.reset();
    const currVal_871:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_29.transform('bookingDetail.TOTAL_PRICE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_871,currVal_871))) {
      this.renderer.setText(this._text_371,currVal_871);
      this._expr_871 = currVal_871;
    }
    const currVal_873:any = import3.inlineInterpolate(1,'',this.parentView.context.bookingDetail.currencyCode,' ');
    if (import3.checkBinding(throwOnChange,this._expr_873,currVal_873)) {
      this.renderer.setText(this._text_374,currVal_873);
      this._expr_873 = currVal_873;
    }
    const currVal_874:any = import3.inlineInterpolate(1,'',this.parentView.context.bookingDetail.totalPrice,'');
    if (import3.checkBinding(throwOnChange,this._expr_874,currVal_874)) {
      this.renderer.setText(this._text_376,currVal_874);
      this._expr_874 = currVal_874;
    }
    const currVal_875:boolean = !this.parentView.context.permViewMarkup;
    if (import3.checkBinding(throwOnChange,this._expr_875,currVal_875)) {
      this.renderer.setElementProperty(this._el_385,'hidden',currVal_875);
      this._expr_875 = currVal_875;
    }
    valUnwrapper.reset();
    const currVal_876:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_30.transform('bookingDetail.DESPEGAR_COMMISSION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_876,currVal_876))) {
      this.renderer.setText(this._text_388,currVal_876);
      this._expr_876 = currVal_876;
    }
    const currVal_878:any = import3.inlineInterpolate(1,'',this.parentView.context.bookingDetail.currencyCode,' ');
    if (import3.checkBinding(throwOnChange,this._expr_878,currVal_878)) {
      this.renderer.setText(this._text_391,currVal_878);
      this._expr_878 = currVal_878;
    }
    const currVal_879:any = import3.inlineInterpolate(1,'',(this.parentView.context.bookingDetail.commissionAmount + this.parentView.context.bookingDetail.ivaCommissionAmount).toFixed(2),'');
    if (import3.checkBinding(throwOnChange,this._expr_879,currVal_879)) {
      this.renderer.setText(this._text_393,currVal_879);
      this._expr_879 = currVal_879;
    }
    valUnwrapper.reset();
    const currVal_880:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_31.transform('bookingDetail.DAILY_DETAIL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_880,currVal_880))) {
      this.renderer.setElementProperty(this._el_406,'label',currVal_880);
      this._expr_880 = currVal_880;
    }
    const currVal_882:boolean = !(this.parentView.context.hasSpecialOffer && !this.parentView.context.hasOpaqueDiscount);
    if (import3.checkBinding(throwOnChange,this._expr_882,currVal_882)) {
      this.renderer.setElementProperty(this._el_415,'hidden',currVal_882);
      this._expr_882 = currVal_882;
    }
    valUnwrapper.reset();
    const currVal_883:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_32.transform('bookingDetail.PROMOTIONS_HAVE_BEEN_APPLIED')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_883,currVal_883))) {
      this.renderer.setText(this._text_423,currVal_883);
      this._expr_883 = currVal_883;
    }
    const currVal_885:boolean = !(this.parentView.context.hasSpecialOffer && this.parentView.context.hasOpaqueDiscount);
    if (import3.checkBinding(throwOnChange,this._expr_885,currVal_885)) {
      this.renderer.setElementProperty(this._el_427,'hidden',currVal_885);
      this._expr_885 = currVal_885;
    }
    valUnwrapper.reset();
    const currVal_886:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_33.transform('bookingDetail.PROMOTIONS_AND_OPAQUE_HAVE_BEEN_APPLIED')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_886,currVal_886))) {
      this.renderer.setText(this._text_435,currVal_886);
      this._expr_886 = currVal_886;
    }
    const currVal_888:boolean = !(!this.parentView.context.hasSpecialOffer && this.parentView.context.hasOpaqueDiscount);
    if (import3.checkBinding(throwOnChange,this._expr_888,currVal_888)) {
      this.renderer.setElementProperty(this._el_439,'hidden',currVal_888);
      this._expr_888 = currVal_888;
    }
    valUnwrapper.reset();
    const currVal_889:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_34.transform('bookingDetail.OPAQUE_RATES_HAVE_BEEN_APPLIED')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_889,currVal_889))) {
      this.renderer.setText(this._text_447,currVal_889);
      this._expr_889 = currVal_889;
    }
    valUnwrapper.reset();
    const currVal_891:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_35.transform('bookingDetail.dailyRatesTable.DAY')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_891,currVal_891))) {
      this.renderer.setText(this._text_458,currVal_891);
      this._expr_891 = currVal_891;
    }
    valUnwrapper.reset();
    const currVal_893:any = import3.inlineInterpolate(1,'',((this.parentView.context.hasSpecialOffer || this.parentView.context.hasOpaqueDiscount)? valUnwrapper.unwrap(this._pipe_translate_36.transform('bookingDetail.dailyRatesTable.price.desc')): valUnwrapper.unwrap(this._pipe_translate_37.transform('bookingDetail.dailyRatesTable.price'))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_893,currVal_893))) {
      this.renderer.setText(this._text_474,currVal_893);
      this._expr_893 = currVal_893;
    }
    valUnwrapper.reset();
    const currVal_896:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_38.transform('bookingDetail.FEES_AND_TAXES')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_896,currVal_896))) {
      this.renderer.setElementProperty(this._el_497,'label',currVal_896);
      this._expr_896 = currVal_896;
    }
    valUnwrapper.reset();
    const currVal_898:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_39.transform('bookingDetail.VAT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_898,currVal_898))) {
      this.renderer.setText(this._text_514,currVal_898);
      this._expr_898 = currVal_898;
    }
    const currVal_900:any = import3.inlineInterpolate(2,'',this.parentView.context.bookingDetail.currencyCode,' ',this.parentView.context.bookingDetail.totalVat,'');
    if (import3.checkBinding(throwOnChange,this._expr_900,currVal_900)) {
      this.renderer.setText(this._text_517,currVal_900);
      this._expr_900 = currVal_900;
    }
    valUnwrapper.reset();
    const currVal_901:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_40.transform('bookingDetail.GENERAL_INFO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_901,currVal_901))) {
      this.renderer.setText(this._text_537,currVal_901);
      this._expr_901 = currVal_901;
    }
    valUnwrapper.reset();
    const currVal_903:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_41.transform('bookingDetail.DATE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_903,currVal_903))) {
      this.renderer.setText(this._text_550,currVal_903);
      this._expr_903 = currVal_903;
    }
    const currVal_905:any = import3.inlineInterpolate(1,'',this.parentView.context.getBookingFullDate(this.parentView.context.bookingDetail.bookingDateMillis),'');
    if (import3.checkBinding(throwOnChange,this._expr_905,currVal_905)) {
      this.renderer.setText(this._text_553,currVal_905);
      this._expr_905 = currVal_905;
    }
    valUnwrapper.reset();
    const currVal_906:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_42.transform('bookingDetail.PAYMENT_METHOD')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_906,currVal_906))) {
      this.renderer.setText(this._text_559,currVal_906);
      this._expr_906 = currVal_906;
    }
    valUnwrapper.reset();
    const currVal_908:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_43.transform(('booking.paymentMethod.' + this.parentView.context.bookingDetail.paymentMethod))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_908,currVal_908))) {
      this.renderer.setText(this._text_562,currVal_908);
      this._expr_908 = currVal_908;
    }
    valUnwrapper.reset();
    const currVal_910:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_44.transform('bookingDetail.CAR_DETAIL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_910,currVal_910))) {
      this.renderer.setText(this._text_576,currVal_910);
      this._expr_910 = currVal_910;
    }
    valUnwrapper.reset();
    const currVal_912:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_45.transform('bookingDetail.CAR.NAME')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_912,currVal_912))) {
      this.renderer.setText(this._text_589,currVal_912);
      this._expr_912 = currVal_912;
    }
    valUnwrapper.reset();
    const currVal_914:any = import3.inlineInterpolate(6,'\n                                                    ',this.parentView.context.bookingDetail.car.carModel.category,' - ',this.parentView.context.bookingDetail.car.name,' - ',this.parentView.context.bookingDetail.car.carModel.model,' ',this.parentView.context.bookingDetail.car.carModel.brand,' ',this.parentView.context.bookingDetail.car.doors,' ',valUnwrapper.unwrap(this._pipe_translate_46.transform('bookingDetail.CAR.DOORS')),'\n                                                ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_914,currVal_914))) {
      this.renderer.setText(this._text_592,currVal_914);
      this._expr_914 = currVal_914;
    }
    valUnwrapper.reset();
    const currVal_916:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_47.transform('bookingDetail.COMPANY_INFO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_916,currVal_916))) {
      this.renderer.setText(this._text_607,currVal_916);
      this._expr_916 = currVal_916;
    }
    valUnwrapper.reset();
    const currVal_918:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_48.transform('bookingDetail.COMPANY.NAME')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_918,currVal_918))) {
      this.renderer.setText(this._text_620,currVal_918);
      this._expr_918 = currVal_918;
    }
    const currVal_920:any = import3.inlineInterpolate(2,'',this.parentView.context.bookingDetail.company.companyName,' ( ',this.parentView.context.bookingDetail.company.tradeName,' )');
    if (import3.checkBinding(throwOnChange,this._expr_920,currVal_920)) {
      this.renderer.setText(this._text_623,currVal_920);
      this._expr_920 = currVal_920;
    }
    valUnwrapper.reset();
    const currVal_921:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_49.transform('bookingDetail.COMPANY.COUNTRY')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_921,currVal_921))) {
      this.renderer.setText(this._text_629,currVal_921);
      this._expr_921 = currVal_921;
    }
    const currVal_923:any = import3.inlineInterpolate(1,'',this.parentView.context.bookingDetail.company.countryName,'');
    if (import3.checkBinding(throwOnChange,this._expr_923,currVal_923)) {
      this.renderer.setText(this._text_632,currVal_923);
      this._expr_923 = currVal_923;
    }
    const currVal_924:any = this.parentView.context.hideVcc();
    if (import3.checkBinding(throwOnChange,this._expr_924,currVal_924)) {
      this.renderer.setElementProperty(this._el_639,'hidden',currVal_924);
      this._expr_924 = currVal_924;
    }
    valUnwrapper.reset();
    const currVal_925:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_50.transform('bookingDetail.vcc')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_925,currVal_925))) {
      this.renderer.setText(this._text_646,currVal_925);
      this._expr_925 = currVal_925;
    }
    valUnwrapper.reset();
    const currVal_927:any = import3.inlineInterpolate(3,'\n                                            ',valUnwrapper.unwrap(this._pipe_translate_51.transform('bookingDetail.vcc.description.init')),' (',this.parentView.context.getVccDate(this.parentView.context.bookingDetail.period.to),'), ',valUnwrapper.unwrap(this._pipe_translate_52.transform('bookingDetail.vcc.description.preLink')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_927,currVal_927))) {
      this.renderer.setText(this._text_655,currVal_927);
      this._expr_927 = currVal_927;
    }
    valUnwrapper.reset();
    const currVal_930:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_53.transform('bookingDetail.vcc.description.link')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_930,currVal_930))) {
      this.renderer.setText(this._text_657,currVal_930);
      this._expr_930 = currVal_930;
    }
    valUnwrapper.reset();
    const currVal_932:any = import3.inlineInterpolate(4,'\n                                            ',valUnwrapper.unwrap(this._pipe_translate_54.transform('bookingDetail.vcc.description.final')),' ',this.parentView.context.bookingDetail.prepaySettlementPrice,' ',this.parentView.context.bookingDetail.currencyCode,'. ',valUnwrapper.unwrap(this._pipe_translate_55.transform('bookingDetail.vcc.description.validity',this._map_934(this.parentView.context.vccActiveTo))),'\n                                        ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_932,currVal_932))) {
      this.renderer.setText(this._text_658,currVal_932);
      this._expr_932 = currVal_932;
    }
    valUnwrapper.reset();
    const currVal_936:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_56.transform('bookingDetail.vcc.faq.description')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_936,currVal_936))) {
      this.renderer.setText(this._text_660,currVal_936);
      this._expr_936 = currVal_936;
    }
    valUnwrapper.reset();
    const currVal_938:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_57.transform('bookingDetail.vcc.faq.link')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_938,currVal_938))) {
      this.renderer.setText(this._text_662,currVal_938);
      this._expr_938 = currVal_938;
    }
    valUnwrapper.reset();
    const currVal_940:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_58.transform('common.LOADING')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_940,currVal_940))) {
      this.renderer.setElementProperty(this._el_678,'loading-text',currVal_940);
      this._expr_940 = currVal_940;
    }
    valUnwrapper.reset();
    const currVal_942:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_59.transform('bookingList.DOWNLOAD')),'\n                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_942,currVal_942))) {
      this.renderer.setText(this._text_681,currVal_942);
      this._expr_942 = currVal_942;
    }
    this.compView_110.internalDetectChanges(throwOnChange);
  }
  dirtyParentQueriesInternal():void {
    (<View_BookingDetailComponent0>this.parentView)._viewQuery_dp2_1.setDirty();
    (<View_BookingDetailComponent0>this.parentView)._viewQuery_dp3_2.setDirty();
    (<View_BookingDetailComponent0>this.parentView)._viewQuery_dp6_5.setDirty();
  }
  destroyInternal():void {
    this._vc_101.destroyNestedViews();
    this._vc_184.destroyNestedViews();
    this._vc_186.destroyNestedViews();
    this._vc_188.destroyNestedViews();
    this._vc_243.destroyNestedViews();
    this._vc_245.destroyNestedViews();
    this._vc_254.destroyNestedViews();
    this._vc_270.destroyNestedViews();
    this._vc_281.destroyNestedViews();
    this._vc_292.destroyNestedViews();
    this._vc_354.destroyNestedViews();
    this._vc_356.destroyNestedViews();
    this._vc_358.destroyNestedViews();
    this._vc_360.destroyNestedViews();
    this._vc_362.destroyNestedViews();
    this._vc_364.destroyNestedViews();
    this._vc_366.destroyNestedViews();
    this._vc_379.destroyNestedViews();
    this._vc_381.destroyNestedViews();
    this._vc_383.destroyNestedViews();
    this._vc_401.destroyNestedViews();
    this._vc_460.destroyNestedViews();
    this._vc_462.destroyNestedViews();
    this._vc_464.destroyNestedViews();
    this._vc_466.destroyNestedViews();
    this._vc_468.destroyNestedViews();
    this._vc_470.destroyNestedViews();
    this._vc_479.destroyNestedViews();
    this._vc_489.destroyNestedViews();
    this._vc_493.destroyNestedViews();
    this._vc_507.destroyNestedViews();
    this._vc_595.destroyNestedViews();
    this._vc_597.destroyNestedViews();
    this._vc_668.destroyNestedViews();
    this._vc_670.destroyNestedViews();
    this.compView_110.destroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
    this._pipe_translate_10.ngOnDestroy();
    this._pipe_translate_11.ngOnDestroy();
    this._pipe_translate_12.ngOnDestroy();
    this._pipe_translate_13.ngOnDestroy();
    this._pipe_translate_14.ngOnDestroy();
    this._pipe_translate_15.ngOnDestroy();
    this._pipe_translate_16.ngOnDestroy();
    this._pipe_translate_17.ngOnDestroy();
    this._pipe_translate_18.ngOnDestroy();
    this._pipe_translate_19.ngOnDestroy();
    this._pipe_translate_20.ngOnDestroy();
    this._pipe_translate_21.ngOnDestroy();
    this._pipe_translate_22.ngOnDestroy();
    this._pipe_translate_23.ngOnDestroy();
    this._pipe_translate_24.ngOnDestroy();
    this._pipe_translate_25.ngOnDestroy();
    this._pipe_translate_26.ngOnDestroy();
    this._pipe_translate_27.ngOnDestroy();
    this._pipe_translate_28.ngOnDestroy();
    this._pipe_translate_29.ngOnDestroy();
    this._pipe_translate_30.ngOnDestroy();
    this._pipe_translate_31.ngOnDestroy();
    this._pipe_translate_32.ngOnDestroy();
    this._pipe_translate_33.ngOnDestroy();
    this._pipe_translate_34.ngOnDestroy();
    this._pipe_translate_35.ngOnDestroy();
    this._pipe_translate_36.ngOnDestroy();
    this._pipe_translate_37.ngOnDestroy();
    this._pipe_translate_38.ngOnDestroy();
    this._pipe_translate_39.ngOnDestroy();
    this._pipe_translate_40.ngOnDestroy();
    this._pipe_translate_41.ngOnDestroy();
    this._pipe_translate_42.ngOnDestroy();
    this._pipe_translate_43.ngOnDestroy();
    this._pipe_translate_44.ngOnDestroy();
    this._pipe_translate_45.ngOnDestroy();
    this._pipe_translate_46.ngOnDestroy();
    this._pipe_translate_47.ngOnDestroy();
    this._pipe_translate_48.ngOnDestroy();
    this._pipe_translate_49.ngOnDestroy();
    this._pipe_translate_50.ngOnDestroy();
    this._pipe_translate_51.ngOnDestroy();
    this._pipe_translate_52.ngOnDestroy();
    this._pipe_translate_53.ngOnDestroy();
    this._pipe_translate_54.ngOnDestroy();
    this._pipe_translate_55.ngOnDestroy();
    this._pipe_translate_56.ngOnDestroy();
    this._pipe_translate_57.ngOnDestroy();
    this._pipe_translate_58.ngOnDestroy();
    this._pipe_translate_59.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 101)) { return new View_BookingDetailComponent3(this.viewUtils,this,101,this._anchor_101,this._vc_101); }
    if ((nodeIndex == 184)) { return new View_BookingDetailComponent4(this.viewUtils,this,184,this._anchor_184,this._vc_184); }
    if ((nodeIndex == 186)) { return new View_BookingDetailComponent6(this.viewUtils,this,186,this._anchor_186,this._vc_186); }
    if ((nodeIndex == 188)) { return new View_BookingDetailComponent7(this.viewUtils,this,188,this._anchor_188,this._vc_188); }
    if ((nodeIndex == 243)) { return new View_BookingDetailComponent21(this.viewUtils,this,243,this._anchor_243,this._vc_243); }
    if ((nodeIndex == 245)) { return new View_BookingDetailComponent23(this.viewUtils,this,245,this._anchor_245,this._vc_245); }
    if ((nodeIndex == 254)) { return new View_BookingDetailComponent24(this.viewUtils,this,254,this._anchor_254,this._vc_254); }
    if ((nodeIndex == 270)) { return new View_BookingDetailComponent26(this.viewUtils,this,270,this._anchor_270,this._vc_270); }
    if ((nodeIndex == 281)) { return new View_BookingDetailComponent27(this.viewUtils,this,281,this._anchor_281,this._vc_281); }
    if ((nodeIndex == 292)) { return new View_BookingDetailComponent28(this.viewUtils,this,292,this._anchor_292,this._vc_292); }
    if ((nodeIndex == 354)) { return new View_BookingDetailComponent29(this.viewUtils,this,354,this._anchor_354,this._vc_354); }
    if ((nodeIndex == 356)) { return new View_BookingDetailComponent30(this.viewUtils,this,356,this._anchor_356,this._vc_356); }
    if ((nodeIndex == 358)) { return new View_BookingDetailComponent31(this.viewUtils,this,358,this._anchor_358,this._vc_358); }
    if ((nodeIndex == 360)) { return new View_BookingDetailComponent32(this.viewUtils,this,360,this._anchor_360,this._vc_360); }
    if ((nodeIndex == 362)) { return new View_BookingDetailComponent33(this.viewUtils,this,362,this._anchor_362,this._vc_362); }
    if ((nodeIndex == 364)) { return new View_BookingDetailComponent34(this.viewUtils,this,364,this._anchor_364,this._vc_364); }
    if ((nodeIndex == 366)) { return new View_BookingDetailComponent37(this.viewUtils,this,366,this._anchor_366,this._vc_366); }
    if ((nodeIndex == 379)) { return new View_BookingDetailComponent38(this.viewUtils,this,379,this._anchor_379,this._vc_379); }
    if ((nodeIndex == 381)) { return new View_BookingDetailComponent39(this.viewUtils,this,381,this._anchor_381,this._vc_381); }
    if ((nodeIndex == 383)) { return new View_BookingDetailComponent42(this.viewUtils,this,383,this._anchor_383,this._vc_383); }
    if ((nodeIndex == 401)) { return new View_BookingDetailComponent43(this.viewUtils,this,401,this._anchor_401,this._vc_401); }
    if ((nodeIndex == 460)) { return new View_BookingDetailComponent46(this.viewUtils,this,460,this._anchor_460,this._vc_460); }
    if ((nodeIndex == 462)) { return new View_BookingDetailComponent47(this.viewUtils,this,462,this._anchor_462,this._vc_462); }
    if ((nodeIndex == 464)) { return new View_BookingDetailComponent48(this.viewUtils,this,464,this._anchor_464,this._vc_464); }
    if ((nodeIndex == 466)) { return new View_BookingDetailComponent49(this.viewUtils,this,466,this._anchor_466,this._vc_466); }
    if ((nodeIndex == 468)) { return new View_BookingDetailComponent50(this.viewUtils,this,468,this._anchor_468,this._vc_468); }
    if ((nodeIndex == 470)) { return new View_BookingDetailComponent51(this.viewUtils,this,470,this._anchor_470,this._vc_470); }
    if ((nodeIndex == 479)) { return new View_BookingDetailComponent52(this.viewUtils,this,479,this._anchor_479,this._vc_479); }
    if ((nodeIndex == 489)) { return new View_BookingDetailComponent58(this.viewUtils,this,489,this._anchor_489,this._vc_489); }
    if ((nodeIndex == 493)) { return new View_BookingDetailComponent60(this.viewUtils,this,493,this._anchor_493,this._vc_493); }
    if ((nodeIndex == 507)) { return new View_BookingDetailComponent62(this.viewUtils,this,507,this._anchor_507,this._vc_507); }
    if ((nodeIndex == 595)) { return new View_BookingDetailComponent66(this.viewUtils,this,595,this._anchor_595,this._vc_595); }
    if ((nodeIndex == 597)) { return new View_BookingDetailComponent67(this.viewUtils,this,597,this._anchor_597,this._vc_597); }
    if ((nodeIndex == 668)) { return new View_BookingDetailComponent70(this.viewUtils,this,668,this._anchor_668,this._vc_668); }
    if ((nodeIndex == 670)) { return new View_BookingDetailComponent71(this.viewUtils,this,670,this._anchor_670,this._vc_670); }
    return (null as any);
  }
  handleEvent_656(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.showVcc()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_661(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.showFaq()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_678(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.download()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_BookingDetailComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_BookingDetailComponent,{});
export class View_BookingDetailComponent0 extends import1.AppView<import0.BookingDetailComponent> {
  _viewQuery_dp1_0:import35.QueryList<any>;
  _viewQuery_dp2_1:import35.QueryList<any>;
  _viewQuery_dp3_2:import35.QueryList<any>;
  _viewQuery_dp4_3:import35.QueryList<any>;
  _viewQuery_dp5_4:import35.QueryList<any>;
  _viewQuery_dp6_5:import35.QueryList<any>;
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _anchor_23:any;
  /*private*/ _vc_23:import19.ViewContainer;
  _TemplateRef_23_5:any;
  _NgIf_23_6:import21.Wrapper_NgIf;
  _text_24:any;
  _text_25:any;
  _anchor_26:any;
  /*private*/ _vc_26:import19.ViewContainer;
  _TemplateRef_26_5:any;
  _NgIf_26_6:import21.Wrapper_NgIf;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  /*private*/ _expr_42:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_44:any;
  _pipe_translate_1:import18.TranslatePipe;
  _pipe_date_2:import36.DatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_BookingDetailComponent0,renderType_BookingDetailComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_42 = import20.UNINITIALIZED;
    this._expr_44 = import20.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._viewQuery_dp1_0 = new import35.QueryList<any>();
    this._viewQuery_dp2_1 = new import35.QueryList<any>();
    this._viewQuery_dp3_2 = new import35.QueryList<any>();
    this._viewQuery_dp4_3 = new import35.QueryList<any>();
    this._viewQuery_dp5_4 = new import35.QueryList<any>();
    this._viewQuery_dp6_5 = new import35.QueryList<any>();
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray4(4,'class','eva-slide -up -start reset-styles','id','print-detail'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-container eva3-restyle'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','col -lg-9 -md-9 -sm-12 detail-title'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'a',new import3.InlineArray2(2,'class','eva-3-btn -link -sm -icon -eva-3-mr-md back-to-booking'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                            ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_12,'em',new import3.InlineArray2(2,'class','btn-text -eva-3-tc-blue-1'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(this._el_12,'\n                        ',(null as any));
    this._text_17 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_10,'h3',new import3.InlineArray2(2,'class','eva-3-h3'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'',(null as any));
    this._text_20 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_21 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_22 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._anchor_23 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_23 = new import19.ViewContainer(23,6,this,this._anchor_23);
    this._TemplateRef_23_5 = new import22.TemplateRef_(this,23,this._anchor_23);
    this._NgIf_23_6 = new import21.Wrapper_NgIf(this._vc_23.vcRef,this._TemplateRef_23_5);
    this._text_24 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_25 = this.renderer.createText(this._el_4,'\n\n            ',(null as any));
    this._anchor_26 = this.renderer.createTemplateAnchor(this._el_4,(null as any));
    this._vc_26 = new import19.ViewContainer(26,4,this,this._anchor_26);
    this._TemplateRef_26_5 = new import22.TemplateRef_(this,26,this._anchor_26);
    this._NgIf_26_6 = new import21.Wrapper_NgIf(this._vc_26.vcRef,this._TemplateRef_26_5);
    this._text_27 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_28 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_29 = this.renderer.createText(this._el_0,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_12,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_12));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_date_2 = new import36.DatePipe(this.parentView.injectorGet(import37.LOCALE_ID,this.parentIndex));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._anchor_23,
      this._text_24,
      this._text_25,
      this._anchor_26,
      this._text_27,
      this._text_28,
      this._text_29
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (23 === requestNodeIndex))) { return this._TemplateRef_23_5; }
    if (((token === import23.NgIf) && (23 === requestNodeIndex))) { return this._NgIf_23_6.context; }
    if (((token === import22.TemplateRef) && (26 === requestNodeIndex))) { return this._TemplateRef_26_5; }
    if (((token === import23.NgIf) && (26 === requestNodeIndex))) { return this._NgIf_26_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import20.ValueUnwrapper();
    const currVal_23_0_0:any = this.context.showBookingDetail;
    this._NgIf_23_6.check_ngIf(currVal_23_0_0,throwOnChange,false);
    this._NgIf_23_6.ngDoCheck(this,this._anchor_23,throwOnChange);
    const currVal_26_0_0:any = this.context.showBookingDetail;
    this._NgIf_26_6.check_ngIf(currVal_26_0_0,throwOnChange,false);
    this._NgIf_26_6.ngDoCheck(this,this._anchor_26,throwOnChange);
    this._vc_23.detectChangesInNestedViews(throwOnChange);
    this._vc_26.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_42:any = import3.inlineInterpolate(1,'« ',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingDetail.BACK')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_42,currVal_42))) {
      this.renderer.setText(this._text_15,currVal_42);
      this._expr_42 = currVal_42;
    }
    valUnwrapper.reset();
    const currVal_44:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingDetail.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_44,currVal_44))) {
      this.renderer.setText(this._text_19,currVal_44);
      this._expr_44 = currVal_44;
    }
    if (!throwOnChange) {
      if (this._viewQuery_dp1_0.dirty) {
          this._viewQuery_dp1_0.reset([this._vc_26.mapNestedViews(View_BookingDetailComponent2,(nestedView:View_BookingDetailComponent2):any => {
              return [nestedView._vc_254.mapNestedViews(View_BookingDetailComponent24,(nestedView:View_BookingDetailComponent24):any => {
                return [new import27.ElementRef(nestedView._el_0)];
            })];
        })]);
        this.context.dp1 = this._viewQuery_dp1_0.first;
      }
      if (this._viewQuery_dp2_1.dirty) {
          this._viewQuery_dp2_1.reset([this._vc_26.mapNestedViews(View_BookingDetailComponent2,(nestedView:View_BookingDetailComponent2):any => {
            return [new import27.ElementRef(nestedView._el_258)];
        })]);
        this.context.dp2 = this._viewQuery_dp2_1.first;
      }
      if (this._viewQuery_dp3_2.dirty) {
          this._viewQuery_dp3_2.reset([this._vc_26.mapNestedViews(View_BookingDetailComponent2,(nestedView:View_BookingDetailComponent2):any => {
            return [new import27.ElementRef(nestedView._el_406)];
        })]);
        this.context.dp3 = this._viewQuery_dp3_2.first;
      }
      if (this._viewQuery_dp4_3.dirty) {
          this._viewQuery_dp4_3.reset([this._vc_26.mapNestedViews(View_BookingDetailComponent2,(nestedView:View_BookingDetailComponent2):any => {
              return [nestedView._vc_489.mapNestedViews(View_BookingDetailComponent58,(nestedView:View_BookingDetailComponent58):any => {
                return [new import27.ElementRef(nestedView._el_0)];
            })];
        })]);
        this.context.dp4 = this._viewQuery_dp4_3.first;
      }
      if (this._viewQuery_dp5_4.dirty) {
          this._viewQuery_dp5_4.reset([this._vc_26.mapNestedViews(View_BookingDetailComponent2,(nestedView:View_BookingDetailComponent2):any => {
              return [nestedView._vc_493.mapNestedViews(View_BookingDetailComponent60,(nestedView:View_BookingDetailComponent60):any => {
                return [new import27.ElementRef(nestedView._el_0)];
            })];
        })]);
        this.context.dp5 = this._viewQuery_dp5_4.first;
      }
      if (this._viewQuery_dp6_5.dirty) {
          this._viewQuery_dp6_5.reset([this._vc_26.mapNestedViews(View_BookingDetailComponent2,(nestedView:View_BookingDetailComponent2):any => {
            return [new import27.ElementRef(nestedView._el_497)];
        })]);
        this.context.dp6 = this._viewQuery_dp6_5.first;
      }
    }
  }
  destroyInternal():void {
    this._vc_23.destroyNestedViews();
    this._vc_26.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 23)) { return new View_BookingDetailComponent1(this.viewUtils,this,23,this._anchor_23,this._vc_23); }
    if ((nodeIndex == 26)) { return new View_BookingDetailComponent2(this.viewUtils,this,26,this._anchor_26,this._vc_26); }
    return (null as any);
  }
  handleEvent_12(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.goToBookingList()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/booking/detail/booking-detail.component.ngfactory.ts